webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);

var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_loader_js__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47375472_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__ = __webpack_require__(618);
function injectStyle (ssrContext) {
  __webpack_require__(616)
}
var normalizeComponent = __webpack_require__(3)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-47375472"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_loader_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47375472_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_dropdown_js__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_066b9f56_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__ = __webpack_require__(589);
function injectStyle (ssrContext) {
  __webpack_require__(587)
}
var normalizeComponent = __webpack_require__(3)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-066b9f56"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_dropdown_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_066b9f56_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_modal_js__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_694c6ad2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__(633);
function injectStyle (ssrContext) {
  __webpack_require__(631)
}
var normalizeComponent = __webpack_require__(3)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_modal_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_694c6ad2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cam_js__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b45c951_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cam_vue__ = __webpack_require__(624);
function injectStyle (ssrContext) {
  __webpack_require__(619)
}
var normalizeComponent = __webpack_require__(3)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3b45c951"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cam_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b45c951_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cam_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_player_js__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c96278e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Player_vue__ = __webpack_require__(639);
function injectStyle (ssrContext) {
  __webpack_require__(634)
}
var normalizeComponent = __webpack_require__(3)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c96278e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_player_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c96278e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Player_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 135 */,
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_inputText_js__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42342122_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputText_vue__ = __webpack_require__(642);
function injectStyle (ssrContext) {
  __webpack_require__(640)
}
var normalizeComponent = __webpack_require__(3)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42342122"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_inputText_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42342122_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputText_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);



/* harmony default export */ __webpack_exports__["a"] = ({
    preloadImage: function preloadImage(src) {
        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            var image = new Image();

            image.onload = function () {
                resolve(image);
            };

            image.onerror = function () {
                reject();
            };

            image.src = src;
        });
    },
    isEqual: function isEqual(obj1, obj2) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, obj1)) === __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, obj2));
    }
});

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_sidebar_js__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32d49374_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__(615);
function injectStyle (ssrContext) {
  __webpack_require__(598)
}
var normalizeComponent = __webpack_require__(3)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-32d49374"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_sidebar_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32d49374_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_circleProgress_js__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ddaeecc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircleProgress_vue__ = __webpack_require__(608);
function injectStyle (ssrContext) {
  __webpack_require__(606)
}
var normalizeComponent = __webpack_require__(3)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ddaeecc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_circleProgress_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ddaeecc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircleProgress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_iconCam_js__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc5b9682_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IconCam_vue__ = __webpack_require__(623);
function injectStyle (ssrContext) {
  __webpack_require__(621)
}
var normalizeComponent = __webpack_require__(3)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bc5b9682"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_iconCam_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc5b9682_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IconCam_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_search_js__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c22b5ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__(627);
function injectStyle (ssrContext) {
  __webpack_require__(625)
}
var normalizeComponent = __webpack_require__(3)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5c22b5ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_search_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c22b5ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__maskit__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dynamic_mask__ = __webpack_require__(656);


// Facade to maskit/dynamicMask when mask is String or Array
/* harmony default export */ __webpack_exports__["a"] = (function (value, mask) {
    var masked = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var tokens = arguments[3];

    return Array.isArray(mask) ? Object(__WEBPACK_IMPORTED_MODULE_1__dynamic_mask__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__maskit__["a" /* default */], mask, tokens)(value, mask, masked, tokens) : Object(__WEBPACK_IMPORTED_MODULE_0__maskit__["a" /* default */])(value, mask, masked, tokens);
});

/***/ }),
/* 316 */
/***/ (function(module, exports) {

module.exports = {
    '#': { pattern: /\d/ },
    'X': { pattern: /[0-9a-zA-Z]/ },
    'S': { pattern: /[a-zA-Z]/ },
    'A': { pattern: /[a-zA-Z]/, transform: function transform(v) {
            return v.toLocaleUpperCase();
        } },
    'a': { pattern: /[a-zA-Z]/, transform: function transform(v) {
            return v.toLocaleLowerCase();
        } },
    '!': { escape: true }
};

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _ru;

/* harmony default export */ __webpack_exports__["a"] = ({
    ru: (_ru = {
        'About SecurOS': 'О приложении',
        'Privace policy': 'Политика конфиденциальности',
        'Help': 'Помощь',
        'Save': 'Сохранить',
        'Save as': 'Сохранить как',
        'Cancel': 'Отмена',
        'Reset': 'Сбросить',
        'Download': 'Загрузить',
        'Download all': 'Загрузить всё',
        'Undo сhanges': 'Отменить изменения',
        'Clear View': 'Очистить область',
        'Change language': 'Сменить язык',
        'Select language': 'Выберите язык',
        'Logout': 'Выйти',
        'Save object': 'Сохранение объекта',
        'Object': 'Объект',
        'Alarms': 'Тревоги',
        'Live': 'Живое',
        'Playback': 'Архив',
        'Cameras': 'Камеры',
        'Views': 'Виды',
        'View all': 'Смотреть все',
        'Find cameras': 'Найти камеры',
        'Find alarms': 'Найти тревоги',
        'Find object': 'Найти объект',
        'Map': 'Карта',
        'Video': 'Видео',
        'drop cams': 'Для начала просмотра перетяните камеры сюда. Вид не будет сохранен автоматически и будет потерян при перезапуске',
        'No cameras': 'Нет камер',
        'No signal': 'Нет сигнала',
        'Main View': 'Главный вид',
        'Delete view': 'Удалить вид',
        'Rename': 'Переименовать',
        'Remove': 'Удалить',
        'Are you sure you want to delete view?': 'Вы действительно хотите удалить вид?',
        'Save view': 'Сохранение вида',
        'View name': 'Название вида',
        'New object': 'Новый объект',
        'Forgot password?': 'Забыли пароль?',
        'Login': 'Логин',
        'Password': 'Пароль',
        'Add object': 'Добавить объект',
        'Enter': 'Войти',
        'Forgot password message': 'Чтобы получить доступ или изменить пароль, свяжитесь с системным администратором.',
        'Save credentials': 'Запомнить меня',
        'No alarms for this period': 'Нет тревог за данный период',
        'Image unavailable': 'Изображение недоступно',
        'Location on map': 'Расположение на карте',
        'IDs cameras': 'ID камер',
        'Views with camera': 'Виды с камерой',
        'View': 'Вид',
        'View camera': 'Просмотр камеры'
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, 'No cameras', 'Нет камер'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, 'max cameras error', 'Текущая сетка не может вместить в себя большее количество камер. Измените параметры сетки'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, 'Fit into window', 'Вписать в окно'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, 'Service is temporarily unavailable', 'Сервис временно недоступен'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, 'Error', 'Ошибка'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, 'You can not create more than 10 views', 'Вы не можете создать больше 10 видов'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, 'Error IE', 'Internet Explorer не поддерживается SecurOS WebConnect. Пожалуйста, используйте Google Chrome, ' + 'Mozilla Firefox, Safari, MS Edge или другой современный браузер.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, 'Indicate alarms on cameras', 'Обозначить тревожные камеры'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, 'Base', 'Базовый'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, 'Low resolution', 'Низкое разрешение'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, 'High resolution', 'Высокое разрешение'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, 'Video Complete', 'Файл готов к загрузке'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, 'Video Loading', 'Файл готовится к загрузке'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, 'DOWNLOADING', 'Загрузка видео'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, 'VIDEO_EXPORT_PERIOD', 'Выберите период для сохранения'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, 'CAM_ALARMED', 'Тревога'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, 'CAM_ARMED', 'Поставлена на охрану'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, 'CAM_DETACHED', 'Нет сигнала'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, 'CAM_DISARMED', 'Снята с охраны'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, 'CAM_DISARM_DETACHED', 'Нет сигнала'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, 'EVENT_ATTACH', 'Камера подключена'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, 'EVENT_BLINDING', 'Плохая видимость'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, 'EVENT_DETACH', 'Нет видео'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, 'EVENT_DEFOCUSED', 'Потеря фокусировки'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, 'EVENT_FOCUSED', 'Сфокусирована'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, 'EVENT_MD_START', 'Тревога'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, 'EVENT_MD_STOP', 'Конец тревоги'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, 'EVENT_REC', 'Запись на диск'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, 'EVENT_REC_STOP', 'Конец записи на диск'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, 'EVENT_UNBLINDING', 'Хорошая видимость'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, 'EVENT_ARMED', 'Камера была поставлена на охрану'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, 'EVENT_DISARMED', 'Камера была снята с охраны '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, 'EVENT_REC_ERROR', 'Ошибка записи'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, 'uniqueObject', 'Объект с указанными именем уже существует.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, 'uniqueLogin', 'Объект с указанным логином уже существует.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, 'auth', "Не найден аккаунт с указанными логином и паролем."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, 'wrongPassword', 'Неправильный пароль.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, 'uniqueViewName', 'Вид с указанными именем уже существует.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, 'disableRoot', 'Авторизация суперпользователя (root) запрещена политикой безопасности. Пожалуйста, используйте другую учетную запись пользователя.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, 'validation', {
        messages: {
            required: function required(field) {
                return '\u041F\u043E\u043B\u0435 "' + field + '" \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0434\u043B\u044F \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F.';
            },
            regex: function regex(field) {
                return '\u041F\u043E\u043B\u0435 "' + field + '" \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u043D\u0435\u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0435 \u0441\u0438\u043C\u0432\u043E\u043B\u044B.';
            }
        }
    }), _ru),
    en: {
        'drop cams': 'Drop cameras here to start watching video. View is not saved automatically and will be lost after restart.',
        'Forgot password message': 'Please contact your SecurOS system administrator to receive user credentials or to change your account password.',
        'max cameras error': 'The current layout can support no more cameras. Please, change the layout details',

        'About SecurOS': 'About',
        'Save object': 'Save site',
        'Object': 'Site',
        'Find object': 'Find location',
        'New object': 'New site',
        'Add object': 'Add site',
        'Error IE': 'Internet Explorer is not supported by SecurOS WebConnect. Please use Google Chrome, ' + 'Mozilla Firefox, Safari, MS Edge or other up-to-date browser.',

        // Статусы камер
        CAM_ALARMED: 'Alarmed',
        CAM_ARMED: 'Armed',
        CAM_DETACHED: 'No signal',
        CAM_DISARMED: 'Disarmed',
        CAM_DISARM_DETACHED: 'No signal',

        // Статусы событий
        EVENT_ATTACH: 'Camera connected',
        EVENT_BLINDING: 'Bad visibility',
        EVENT_DETACH: 'No video',
        EVENT_DEFOCUSED: 'Loss of focus',
        EVENT_FOCUSED: 'Focused',
        EVENT_MD_START: 'Alarm',
        EVENT_MD_STOP: 'End of alarm',
        EVENT_REC: 'Burn to disk',
        EVENT_REC_STOP: 'End of writing to disk',
        EVENT_UNBLINDING: 'Good visibility',
        EVENT_ARMED: 'The camera was armed',
        EVENT_DISARMED: 'The camera was disarmed',
        EVENT_REC_ERROR: 'Write error',

        // Работа с выгрузкой видео
        DOWNLOADING: 'Downloading',
        VIDEO_EXPORT_PERIOD: 'Choose export time period',
        'Video Complete': 'File is ready for download',
        'Video Loading': 'File is being prepared for download',

        // Кастомные ошибки валидации
        uniqueObject: 'That site name is in use. Please try another.',
        uniqueLogin: 'That login is in use. Please try another.',
        auth: "Sorry, we couldn't find an account with that login and password.",
        wrongPassword: 'Wrong password.',
        uniqueViewName: 'That view name is in use. Please try another.',
        disableRoot: 'Login as superuser (root) is prohibited by the security policy. Please use another user account.'
    }
});

/***/ }),
/* 318 */,
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_alarms_js__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1aedc0ac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Alarms_vue__ = __webpack_require__(680);
function injectStyle (ssrContext) {
  __webpack_require__(674)
}
var normalizeComponent = __webpack_require__(3)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1aedc0ac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_alarms_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1aedc0ac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Alarms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_dropdownSelect_js__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b372fbba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DropdownSelect_vue__ = __webpack_require__(695);
function injectStyle (ssrContext) {
  __webpack_require__(693)
}
var normalizeComponent = __webpack_require__(3)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b372fbba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_dropdownSelect_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b372fbba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DropdownSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(322);
module.exports = __webpack_require__(524);


/***/ }),
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_i18n__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vee_validate__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_moment__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_store__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_router__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_filters__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_translates__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_app_App_vue__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_AuthService__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_LocalizationService__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_drag_drop__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_drag_drop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_drag_drop__);















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_13_vue_drag_drop___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_moment___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex_i18n__["a" /* default */].plugin, __WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8__common_filters__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vee_validate__["b" /* default */], {
    dictionary: {
        ru: {
            messages: __WEBPACK_IMPORTED_MODULE_9__common_translates__["a" /* default */].ru.validation.messages,
            attributes: __WEBPACK_IMPORTED_MODULE_9__common_translates__["a" /* default */].ru.validation.attributes
        }
    }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].i18n.add('ru', __WEBPACK_IMPORTED_MODULE_9__common_translates__["a" /* default */].ru);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].i18n.add('en', __WEBPACK_IMPORTED_MODULE_9__common_translates__["a" /* default */].en);

Object(__WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__common_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_7__common_router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_10__modules_app_App_vue__["a" /* default */] },
    provide: {
        auth: new __WEBPACK_IMPORTED_MODULE_11__services_AuthService__["a" /* default */](__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__common_router__["a" /* default */]),
        localization: new __WEBPACK_IMPORTED_MODULE_12__services_LocalizationService__["a" /* default */]()
    }
});

/***/ }),
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 530 */,
/* 531 */,
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 173,
	"./af.js": 173,
	"./ar": 174,
	"./ar-dz": 175,
	"./ar-dz.js": 175,
	"./ar-kw": 176,
	"./ar-kw.js": 176,
	"./ar-ly": 177,
	"./ar-ly.js": 177,
	"./ar-ma": 178,
	"./ar-ma.js": 178,
	"./ar-sa": 179,
	"./ar-sa.js": 179,
	"./ar-tn": 180,
	"./ar-tn.js": 180,
	"./ar.js": 174,
	"./az": 181,
	"./az.js": 181,
	"./be": 182,
	"./be.js": 182,
	"./bg": 183,
	"./bg.js": 183,
	"./bm": 184,
	"./bm.js": 184,
	"./bn": 185,
	"./bn.js": 185,
	"./bo": 186,
	"./bo.js": 186,
	"./br": 187,
	"./br.js": 187,
	"./bs": 188,
	"./bs.js": 188,
	"./ca": 189,
	"./ca.js": 189,
	"./cs": 190,
	"./cs.js": 190,
	"./cv": 191,
	"./cv.js": 191,
	"./cy": 192,
	"./cy.js": 192,
	"./da": 193,
	"./da.js": 193,
	"./de": 194,
	"./de-at": 195,
	"./de-at.js": 195,
	"./de-ch": 196,
	"./de-ch.js": 196,
	"./de.js": 194,
	"./dv": 197,
	"./dv.js": 197,
	"./el": 198,
	"./el.js": 198,
	"./en-au": 199,
	"./en-au.js": 199,
	"./en-ca": 200,
	"./en-ca.js": 200,
	"./en-gb": 201,
	"./en-gb.js": 201,
	"./en-ie": 202,
	"./en-ie.js": 202,
	"./en-nz": 203,
	"./en-nz.js": 203,
	"./eo": 204,
	"./eo.js": 204,
	"./es": 205,
	"./es-do": 206,
	"./es-do.js": 206,
	"./es-us": 207,
	"./es-us.js": 207,
	"./es.js": 205,
	"./et": 208,
	"./et.js": 208,
	"./eu": 209,
	"./eu.js": 209,
	"./fa": 210,
	"./fa.js": 210,
	"./fi": 211,
	"./fi.js": 211,
	"./fo": 212,
	"./fo.js": 212,
	"./fr": 213,
	"./fr-ca": 214,
	"./fr-ca.js": 214,
	"./fr-ch": 215,
	"./fr-ch.js": 215,
	"./fr.js": 213,
	"./fy": 216,
	"./fy.js": 216,
	"./gd": 217,
	"./gd.js": 217,
	"./gl": 218,
	"./gl.js": 218,
	"./gom-latn": 219,
	"./gom-latn.js": 219,
	"./gu": 220,
	"./gu.js": 220,
	"./he": 221,
	"./he.js": 221,
	"./hi": 222,
	"./hi.js": 222,
	"./hr": 223,
	"./hr.js": 223,
	"./hu": 224,
	"./hu.js": 224,
	"./hy-am": 225,
	"./hy-am.js": 225,
	"./id": 226,
	"./id.js": 226,
	"./is": 227,
	"./is.js": 227,
	"./it": 228,
	"./it.js": 228,
	"./ja": 229,
	"./ja.js": 229,
	"./jv": 230,
	"./jv.js": 230,
	"./ka": 231,
	"./ka.js": 231,
	"./kk": 232,
	"./kk.js": 232,
	"./km": 233,
	"./km.js": 233,
	"./kn": 234,
	"./kn.js": 234,
	"./ko": 235,
	"./ko.js": 235,
	"./ky": 236,
	"./ky.js": 236,
	"./lb": 237,
	"./lb.js": 237,
	"./lo": 238,
	"./lo.js": 238,
	"./lt": 239,
	"./lt.js": 239,
	"./lv": 240,
	"./lv.js": 240,
	"./me": 241,
	"./me.js": 241,
	"./mi": 242,
	"./mi.js": 242,
	"./mk": 243,
	"./mk.js": 243,
	"./ml": 244,
	"./ml.js": 244,
	"./mr": 245,
	"./mr.js": 245,
	"./ms": 246,
	"./ms-my": 247,
	"./ms-my.js": 247,
	"./ms.js": 246,
	"./my": 248,
	"./my.js": 248,
	"./nb": 249,
	"./nb.js": 249,
	"./ne": 250,
	"./ne.js": 250,
	"./nl": 251,
	"./nl-be": 252,
	"./nl-be.js": 252,
	"./nl.js": 251,
	"./nn": 253,
	"./nn.js": 253,
	"./pa-in": 254,
	"./pa-in.js": 254,
	"./pl": 255,
	"./pl.js": 255,
	"./pt": 256,
	"./pt-br": 257,
	"./pt-br.js": 257,
	"./pt.js": 256,
	"./ro": 258,
	"./ro.js": 258,
	"./ru": 259,
	"./ru.js": 259,
	"./sd": 260,
	"./sd.js": 260,
	"./se": 261,
	"./se.js": 261,
	"./si": 262,
	"./si.js": 262,
	"./sk": 263,
	"./sk.js": 263,
	"./sl": 264,
	"./sl.js": 264,
	"./sq": 265,
	"./sq.js": 265,
	"./sr": 266,
	"./sr-cyrl": 267,
	"./sr-cyrl.js": 267,
	"./sr.js": 266,
	"./ss": 268,
	"./ss.js": 268,
	"./sv": 269,
	"./sv.js": 269,
	"./sw": 270,
	"./sw.js": 270,
	"./ta": 271,
	"./ta.js": 271,
	"./te": 272,
	"./te.js": 272,
	"./tet": 273,
	"./tet.js": 273,
	"./th": 274,
	"./th.js": 274,
	"./tl-ph": 275,
	"./tl-ph.js": 275,
	"./tlh": 276,
	"./tlh.js": 276,
	"./tr": 277,
	"./tr.js": 277,
	"./tzl": 278,
	"./tzl.js": 278,
	"./tzm": 279,
	"./tzm-latn": 280,
	"./tzm-latn.js": 280,
	"./tzm.js": 279,
	"./uk": 281,
	"./uk.js": 281,
	"./ur": 282,
	"./ur.js": 282,
	"./uz": 283,
	"./uz-latn": 284,
	"./uz-latn.js": 284,
	"./uz.js": 283,
	"./vi": 285,
	"./vi.js": 285,
	"./x-pseudo": 286,
	"./x-pseudo.js": 286,
	"./yo": 287,
	"./yo.js": 287,
	"./zh-cn": 288,
	"./zh-cn.js": 288,
	"./zh-hk": 289,
	"./zh-hk.js": 289,
	"./zh-tw": 290,
	"./zh-tw.js": 290
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 532;

/***/ }),
/* 533 */,
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_getters__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_mutations__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_actions__ = __webpack_require__(558);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var getInitialUploadedVideos = function getInitialUploadedVideos() {
    var uploadedVideos = localStorage.getItem('uploadedVideos');
    return uploadedVideos ? JSON.parse(uploadedVideos) : [];
};

var getInitialStateVideos = function getInitialStateVideos() {
    var uploadedVideos = localStorage.getItem('uploadedVideos');
    return uploadedVideos ? JSON.parse(uploadedVideos).length : 0;
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: {
        user: false,
        cams: [],
        camIdFromCell: '',
        archCnvEnabled: true,
        views: [],
        maps: [],
        mode: 0,
        alarms: [],
        grids: [{ value: 1, max: 1, icon: 'grid-1' }, { value: 2, max: 4, icon: 'grid-4' }, { value: 10, max: 4, icon: 'grid-1-3' }, { value: 11, max: 6, icon: 'grid-1-5' }, { value: 12, max: 6, icon: 'grid-2-4' }, { value: 13, max: 7, icon: 'grid-4-3' }, { value: 4, max: 9, icon: 'grid-9' }, { value: 5, max: 8, icon: 'grid-1-7' }, { value: 14, max: 12, icon: 'grid-12' }, { value: 7, max: 13, icon: 'grid-1-12' }, { value: 6, max: 16, icon: 'grid-16' }],
        grid: 1,
        stream: 1,
        uploadedVideos: getInitialUploadedVideos(),
        videoState: {
            percent: 0,
            allVideoCount: getInitialStateVideos(),
            completeVideoCount: getInitialStateVideos(),
            status: 'success'
        },
        wsWebConnect: null
    },
    getters: __WEBPACK_IMPORTED_MODULE_2__store_getters__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_3__store_mutations__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_4__store_actions__["a" /* default */]
}));

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

/* harmony default export */ __webpack_exports__["a"] = ({
    getUser: function getUser(state) {
        return state.user;
    },
    getCams: function getCams(state) {
        return state.cams.map(function (cam) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, cam, {
                views: state.views.filter(function (view, i) {
                    return view.cams.indexOf(cam.id) > -1 && i != 0;
                })
            });
        });
    },
    getCamIdFromCell: function getCamIdFromCell(state) {
        return state.camIdFromCell;
    },
    getViews: function getViews(state) {
        return state.views.map(function (view) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, view, {
                cams: view.cams.map(function (id) {
                    return state.cams.find(function (cam) {
                        return cam.id == id;
                    }) || { id: null, name: 'Empty' };
                })
            });
        });
    },
    getActiveView: function getActiveView(state, getters) {
        return getters.getViews.find(function (view) {
            return view.id == state.route.params.viewId;
        }) || null;
    },
    getMaps: function getMaps(state) {
        return state.maps;
    },
    getMapById: function getMapById(state) {
        return function (groupId, mapId) {
            var group = state.maps.find(function (group) {
                return group.id == groupId;
            }) || null;

            if (group) {
                var map = group.map.find(function (map) {
                    return map.id == mapId;
                });

                if (map) {
                    var cams = map.objects.filter(function (item) {
                        return item.type == 'CAM';
                    }).map(function (cam) {
                        cam.open = false;

                        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, cam, state.cams.find(function (c) {
                            return c.id == cam.id;
                        }));
                    });

                    var levels = map.objects.filter(function (item) {
                        return item.type == 'LEVEL';
                    }).map(function (item) {
                        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, { mapId: group.map.find(function (m) {
                                return m.name == item.id;
                            }).id });
                    });

                    var mapObjs = map.objects.filter(function (item) {
                        return item.type !== 'LEVEL' && item.type !== 'CAM';
                    });

                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, map, {
                        cams: cams,
                        levels: levels,
                        mapObjs: mapObjs
                    });
                }

                return null;
            }

            return null;
        };
    },
    getAlarmCams: function getAlarmCams(state, getters) {
        return getters.getCams.filter(function (cam) {
            return ['DISARM_DETACHED', 'DETACHED', 'ALARMED'].includes(cam.status.state) || cam.status.valid === false || cam.status.focused === "false" || cam.status.unblinded === "false";
        });
    },
    getAlarmMaps: function getAlarmMaps(state, getters) {
        var alarmsCams = getters.getAlarmCams;
        var filterGroup = getters.getMaps.filter(function (group) {
            var isAlarm = false;
            for (var i = 0; i < group.map.length; i++) {
                if (isAlarm) {
                    break;
                }
                var mapObj = group.map[i];

                var _loop = function _loop(j) {
                    var camObj = mapObj.objects[j];
                    if (!!alarmsCams.find(function (ac) {
                        return ac.id === camObj.id;
                    })) {
                        isAlarm = true;
                        return 'break';
                    }
                };

                for (var j = 0; j < mapObj.objects.length; j++) {
                    var _ret = _loop(j);

                    if (_ret === 'break') break;
                }
            }
            return isAlarm;
        });

        if (filterGroup.length) {
            filterGroup = filterGroup.map(function (group) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, group, {
                    map: group.map.map(function (mapObj) {
                        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapObj, {
                            objects: mapObj.objects.filter(function (camObj) {
                                return !!alarmsCams.find(function (ac) {
                                    return ac.id === camObj.id;
                                });
                            })
                        });
                    })
                });
            });
            filterGroup = filterGroup.map(function (group) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, group, {
                    map: group.map.filter(function (mapObj) {
                        return !!mapObj.objects.length;
                    })
                });
            });
            return filterGroup;
        }

        return [];
    },
    getActiveMap: function getActiveMap(state, getters) {
        return getters.getMapById(state.route.params.mapGroupId, state.route.params.mapId) || null;
    },
    getAlarmViews: function getAlarmViews(state) {
        return state.views.slice(1);
    },
    getAlarms: function getAlarms(state) {
        return state.alarms;
    },
    getLatestAlarms: function getLatestAlarms(state) {
        return state.alarms.slice(0, 6);
    },
    getAlarmsActiveView: function getAlarmsActiveView(state) {
        if (state.route.query && state.route.query.view) {
            return state.views.find(function (view) {
                return view.id == state.route.query.view;
            }) || null;
        }

        return null;
    },
    getMode: function getMode(state) {
        return state.mode;
    },
    getGrids: function getGrids(state) {
        return state.grids;
    },
    getActiveGrid: function getActiveGrid(state) {
        return state.grids.find(function (grid) {
            return grid.value == state.grid;
        }) || null;
    },
    getGrid: function getGrid(state) {
        return state.grid;
    },
    getStream: function getStream(state) {
        return state.stream;
    },
    getUplodedVideos: function getUplodedVideos(state) {
        return state.uploadedVideos;
    },
    getVideoState: function getVideoState(state) {
        return state.videoState;
    },
    getArchCnvEnabled: function getArchCnvEnabled(state) {
        return state.archCnvEnabled;
    }
});

/***/ }),
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__consts_mapObjTypes__ = __webpack_require__(557);







/* harmony default export */ __webpack_exports__["a"] = ({
    setUser: function setUser(state, user) {
        state.user = user;
    },
    resetUser: function resetUser(state) {
        state.user = false;
    },
    setCams: function setCams(state, cams) {
        var old = state.cams;
        var _cams = cams.map(function (cam) {
            var icon = [];

            icon.push(!!cam.settings.telemetry_id ? 'swivel' : 'default');

            if (cam.status.recorded == '1') icon.push('rec');

            if (['DISARM_DETACHED', 'DETACHED'].includes(cam.status.state) || cam.status.valid === false) icon.push('detached');else if (cam.status.focused === "false" || cam.status.unblinded === "false" || cam.status.state === 'ALARMED') icon.push('alarmed');

            var oldCam = old.find(function (c) {
                return c.id === cam.id;
            });

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, cam, {
                image: oldCam ? oldCam.image : null,
                selected: false,
                icon: icon.join(' ')
            });
        });

        _cams = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(_cams.filter(function (item) {
            return item.id.indexOf('#') === -1;
        })), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.sortBy(_cams.filter(function (item) {
            return item.id.indexOf('#') > -1;
        }), function (item) {
            return item.name;
        })));

        state.cams = _cams;
    },
    setCamIdFromCell: function setCamIdFromCell(state, camId) {
        state.camIdFromCell = camId;
    },
    setViews: function setViews(state, views) {
        views = views.map(function (view) {
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, view, {
                changed: false,
                temp: false,
                selected: false
            });
        });

        state.views = [{
            id: 'main',
            name: 'Main View',
            changed: false,
            temp: true,
            cams: [],
            grid: state.grids[0].value
        }].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(views));
    },
    saveView: function saveView(state, view) {
        var existing = state.views.find(function (v) {
            return v.id == view.id;
        });

        if (existing) {
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(existing, view);
            existing.changed = false;
        } else {
            state.views.push(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, view, {
                changed: false,
                temp: false
            }));
        }
    },
    removeView: function removeView(state, viewId) {
        state.views = state.views.filter(function (view) {
            return view.id != viewId;
        });
    },
    changeViewGrid: function changeViewGrid(state, _ref) {
        var grid = _ref.grid,
            viewId = _ref.viewId;

        var view = state.views.find(function (view) {
            return view.id == viewId;
        }) || null;

        if (view) {
            view.grid = grid;
            view.changed = true;
        }
    },
    changeStream: function changeStream(state, stream) {
        state.stream = stream;
    },
    addCamsIntoView: function addCamsIntoView(state, _ref2) {
        var camIds = _ref2.camIds,
            viewId = _ref2.viewId;

        var view = state.views.find(function (view) {
            return view.id == viewId;
        });

        if (view) {
            view.changed = true;

            view.cams.forEach(function (cam, i) {
                if (!cam) {
                    view.cams[i] = camIds.shift();
                }
            });

            view.cams = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(view.cams), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(camIds));

            if (view.cams.length > state.grids.find(function (g) {
                return g.value == view.grid;
            }).max) {
                var grid = state.grids.find(function (g) {
                    return g.max >= view.cams.length;
                }) || __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.last(state.grids);
                view.grid = grid.value;
            }

            state.grid = view.grid;
        }
    },
    removeCamFromView: function removeCamFromView(state, _ref3) {
        var camId = _ref3.camId,
            viewId = _ref3.viewId;

        var view = state.views.find(function (view) {
            return view.id == viewId;
        });

        if (camId === null) {
            view.cams = [];
            view.changed = true;
            return;
        }

        var index = view.cams.findIndex(function (id) {
            return id == camId;
        });

        if (view && index > -1) {
            view.cams[index] = null;

            var last = null;

            view.cams.forEach(function (cam, i) {
                if (cam) last = i + 1;
            });

            view.cams = last === null ? [] : view.cams.slice(0, last);
            view.changed = true;
        }
    },
    replaceCam: function replaceCam(state, _ref4) {
        var camId = _ref4.camId,
            replacedCamId = _ref4.replacedCamId,
            viewId = _ref4.viewId;

        var view = state.views.find(function (view) {
            return view.id == viewId;
        });
        var index = view.cams.findIndex(function (id) {
            return id == replacedCamId;
        });
        var cams = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(view.cams));

        cams[index] = camId;
        view.cams = cams;
        view.changed = true;
    },
    resetTempView: function resetTempView(state) {
        state.views[0].grid = state.grids[0].value;
        state.views[0].cams = [];
        state.views[0].changed = false;
    },
    setMaps: function setMaps(state, maps) {
        maps.forEach(function (map) {
            var items = [];
            __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.forEach(map.map, function (item, i) {

                var itemProcessed = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, item, {
                    id: i,
                    imageId: item.image.split('/').pop(),
                    image: null,
                    parent: item.parent || 0,
                    width: null,
                    height: null,
                    group: { 'id': map.id, 'name': map.name }
                });

                itemProcessed.objects = itemProcessed.objects.filter(function (item) {
                    if (item.type === 'LEVEL' || item.type === 'CAM') {
                        return true;
                    }
                    var check = false;
                    for (var _i = 0; _i < __WEBPACK_IMPORTED_MODULE_5__consts_mapObjTypes__["a" /* default */].length; _i++) {
                        var webviewObjType = __WEBPACK_IMPORTED_MODULE_5__consts_mapObjTypes__["a" /* default */][_i];
                        if (item.type.startsWith(webviewObjType)) {
                            check = true;
                            break;
                        }
                    }
                    return check;
                }).map(function (item) {
                    for (var _i2 = 0; _i2 < __WEBPACK_IMPORTED_MODULE_5__consts_mapObjTypes__["a" /* default */].length; _i2++) {
                        var webviewObjType = __WEBPACK_IMPORTED_MODULE_5__consts_mapObjTypes__["a" /* default */][_i2];
                        if (item.type.startsWith(webviewObjType)) {
                            item.type = webviewObjType;
                            item.status = item.type;
                        }
                    }
                    return item;
                });

                items.push(itemProcessed);
            });

            map.map = items;
        });

        state.maps = maps;
    },
    updateMap: function updateMap(state, _ref5) {
        var mapGroupId = _ref5.mapGroupId,
            mapId = _ref5.mapId,
            map = _ref5.map;

        var group = state.maps.find(function (group) {
            return group.id == mapGroupId;
        }) || null;

        if (group) {
            var _map = group.map.find(function (map) {
                return map.id == mapId;
            }) || null;

            if (_map) {
                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(_map, map);
            }
        }
    },
    setAlarms: function setAlarms(state, alarms) {
        state.alarms = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.sortBy(alarms, function (item) {
            return -item.timestamp;
        });
    },
    setMode: function setMode(state, mode) {
        state.mode = mode;
    },
    setGrid: function setGrid(state, grid) {
        state.grid = grid;
    },
    setUplodedVideos: function setUplodedVideos(state, video) {
        var canseledStatuses = ['ARCH_TASK_CANCELLED', 'ARCH_TASK_NOT_EXISTS'];
        if (canseledStatuses.indexOf(video.status) !== -1) {
            return;
        }
        var listVideo = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(state.uploadedVideos));

        var videoState = {
            percent: 0,
            allVideoCount: 0,
            completeVideoCount: 0,
            status: 'success'
        };

        var completeVideo = [];

        if (listVideo.length > 0) {
            var sameSessionVideo = listVideo.find(function (item) {
                return item.session === video.session;
            });
            if (sameSessionVideo) {
                video.intervalDateVideo = sameSessionVideo.intervalDateVideo;
            }
            listVideo = listVideo.filter(function (item) {
                return item.session !== video.session;
            });
        }

        listVideo.push(video);

        listVideo = listVideo.map(function (item) {

            item.percent = parseInt(item.percent);
            if (item.hasOwnProperty('link')) {
                if (!!item.link && !item.link.includes(location.origin)) {
                    item.link = location.origin + item.link;
                }
                if (!!item.link) {
                    item['statusLoad'] = 'success';
                    item['tooltipText'] = 'Video Complete';
                    completeVideo.push(item);
                    videoState.completeVideoCount += 1;
                    videoState.percent += 100;
                }
            } else {
                item['link'] = null;
                item['statusLoad'] = !!item.problem ? 'fail' : 'progress';
                item['tooltipText'] = !!item.problem ? item.problem : 'Video Loading';
                videoState.percent += item.percent;
            }

            return item;
        });

        localStorage.setItem('uploadedVideos', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(completeVideo));
        state.uploadedVideos = listVideo;

        videoState.percent = videoState.percent / listVideo.length;
        videoState.allVideoCount = listVideo.length;
        videoState.status = videoState.completeVideoCount === videoState.allVideoCount ? 'success' : listVideo.every(function (item) {
            return !!item.problem;
        }) ? 'fail' : 'progress';

        state.videoState = videoState;
    },
    deleteUplodedVideo: function deleteUplodedVideo(state, id) {
        var newUploadedVideos = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(state.uploadedVideos)).filter(function (item) {
            return item.session !== id;
        });
        var newCompleteVideos = newUploadedVideos.filter(function (item) {
            return !!item.link;
        });
        var commonPercent = newUploadedVideos.reduce(function (summ, video) {
            return !!video.link ? summ + 100 : summ + video.percent;
        }, 0);

        localStorage.setItem('uploadedVideos', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(newCompleteVideos));

        state.uploadedVideos = newUploadedVideos;

        state.videoState = {
            allVideoCount: newUploadedVideos.length,
            percent: commonPercent / newUploadedVideos.length,
            completeVideoCount: newCompleteVideos.length,
            status: newCompleteVideos.length === newUploadedVideos.length ? 'success' : newUploadedVideos.every(function (item) {
                return !!item.problem;
            }) ? 'fail' : 'progress'
        };
    },
    setArchCnvEnabled: function setArchCnvEnabled(state, isEnabled) {
        state.archCnvEnabled = isEnabled;
    },
    setWsWebConnect: function setWsWebConnect(state, wsWebConnect) {
        state.wsWebConnect = wsWebConnect;
    },
    setObjectState: function setObjectState(state, _ref6) {
        var getters = _ref6.getters,
            data = _ref6.data;

        var activeMap = getters.getActiveMap;
        if (activeMap) {
            var object = activeMap.objects.find(function (o) {
                return o.type === statusData.type && o.id === statusData.id;
            });
            object.status = data.state;
        }
    }
});

/***/ }),
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (['BOLID2_SECTION', 'BOLID2_SECTION_GROUP', 'BOLID2_ACCESS_POINT', 'BOLID2_ACCESS_ZONE', 'BOLID2_DEVICE', 'BOLID2_READER', 'BOLID2_RELAY', 'BOLID2_LOOP', 'BOLID2_SCRIPT']);

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_ApiService__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_helper__ = __webpack_require__(310);








var api = new __WEBPACK_IMPORTED_MODULE_5__services_ApiService__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    getCams: function getCams(_ref) {
        var commit = _ref.commit;

        return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            api.getCams().then(function (cams) {
                commit('setCams', cams.filter(function (cam) {
                    return cam.status.enabled;
                }));
                resolve();
            }, function (e) {
                reject(e);
            });
        });
    },
    getMaps: function getMaps(_ref2) {
        var commit = _ref2.commit;

        api.getMaps().then(function (maps) {
            return commit('setMaps', maps);
        });
    },
    getMapImage: function getMapImage(_ref3, _ref4) {
        var commit = _ref3.commit,
            getters = _ref3.getters;
        var mapGroupId = _ref4.mapGroupId,
            mapId = _ref4.mapId,
            imageId = _ref4.imageId;

        var data = {
            mapGroupId: mapGroupId,
            mapId: mapId
        };

        return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            api.getMapImage(mapGroupId, imageId).then(function (r) {
                __WEBPACK_IMPORTED_MODULE_6__common_helper__["a" /* default */].preloadImage(r).then(function (image) {
                    commit('updateMap', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, data, {
                        map: {
                            image: r,
                            width: image.width,
                            height: image.height
                        }
                    }));

                    resolve(r);
                });
            }, function () {
                commit('updateMap', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, data, {
                    map: {
                        image: false
                    }
                }));

                reject();
            });
        });
    },
    getViews: function getViews(_ref5) {
        var commit = _ref5.commit,
            state = _ref5.state,
            getters = _ref5.getters;

        return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            api.getViews(state.user.login).then(function (views) {
                commit('setViews', views);
                var view = getters.getActiveView;

                if (view) commit('setGrid', view.grid);

                resolve(views);
            });
        });
    },
    getViewsData: function getViewsData(_ref6) {
        var commit = _ref6.commit,
            state = _ref6.state,
            getters = _ref6.getters;

        return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            api.getViews(state.user.login).then(function (views) {
                resolve(views);
            });
        });
    },
    saveView: function saveView(_ref7, view) {
        var commit = _ref7.commit,
            state = _ref7.state;

        return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            api.saveView(view, state.user.login).then(function (view) {
                commit('resetTempView');
                commit('saveView', view);
                resolve(view);
            }, function () {
                reject();
            });
        });
    },
    removeView: function removeView(_ref8, viewId) {
        var commit = _ref8.commit,
            state = _ref8.state;

        return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            api.removeView(viewId, state.user.login).then(function (viewId) {
                commit('removeView', viewId);
                resolve(viewId);
            }, function () {
                reject();
            });
        });
    },
    setGrid: function setGrid(_ref9, grid) {
        var commit = _ref9.commit,
            state = _ref9.state,
            getters = _ref9.getters;

        var view = getters.getActiveView;

        commit('setGrid', grid);

        if (view) {
            commit('changeViewGrid', {
                grid: grid,
                viewId: view.id
            });
        }
    },
    getCamImage: function getCamImage(_ref10, camId) {
        var commit = _ref10.commit,
            state = _ref10.state;

        var cam = state.cams.find(function (cam) {
            return cam.id == camId;
        }) || null;

        if (cam) {
            cam.image = 'loading';

            api.getCamImage(cam.id).then(function (r) {
                cam.image = r;
            }, function () {
                cam.image = false;
            });
        }
    },
    getAlarms: function getAlarms(_ref11, _ref12) {
        var commit = _ref11.commit,
            state = _ref11.state;
        var cams = _ref12.cams,
            params = _ref12.params;

        commit('setAlarms', []);

        return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            api.getAlarms(cams, params).then(function (alarms) {
                commit('setAlarms', alarms);
                resolve(alarms);
            }, function () {
                reject();
            });
        });
    },
    getPage: function getPage(_ref13, name) {
        var commit = _ref13.commit,
            state = _ref13.state;

        return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            api.getPage(name).then(function (r) {
                resolve(r);
            });
        });
    },
    getObject: function getObject(store, _ref14) {
        var type = _ref14.type,
            id = _ref14.id;

        return api.getAcsObject(type, id);
    },
    setWsWebConnect: function setWsWebConnect(_ref15) {
        var _this = this;

        var commit = _ref15.commit,
            dispatch = _ref15.dispatch,
            getters = _ref15.getters;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var res, wsWebConnect;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            _context.next = 3;
                            return api.get('ws_auth');

                        case 3:
                            res = _context.sent;
                            wsWebConnect = new WebSocket('ws://' + window.location.host + '/ws/');

                            commit('setWsWebConnect', wsWebConnect);
                            wsWebConnect.onmessage = function (res) {
                                var data = res.data ? JSON.parse(res.data) : null;
                                if (data) {
                                    switch (data.type) {
                                        case 'state':
                                            commit('setObjectState', {
                                                data: data.data,
                                                getters: getters
                                            });
                                            break;
                                    }
                                }
                            };
                            wsWebConnect.onclose = function () {
                                dispatch('setWsWebConnect');
                            };
                            _context.next = 10;
                            return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                                wsWebConnect.onopen = function () {
                                    resolve(_this);
                                };
                                wsWebConnect.onerror = function (err) {
                                    reject(err);
                                };
                            });

                        case 10:
                            wsWebConnect.send(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                                type: "auth",
                                token: res.token
                            }));
                            _context.next = 17;
                            break;

                        case 13:
                            _context.prev = 13;
                            _context.t0 = _context['catch'](0);

                            console.log('e', _context.t0);
                            dispatch('setWsWebConnect');

                        case 17:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this, [[0, 13]]);
        }))();
    }
});

/***/ }),
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_EventBus__ = __webpack_require__(15);










var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, _class);

        this.v = 'v1';
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(_class, [{
        key: "get",
        value: function get(url) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            return __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].http.get('/api/' + this.v + '/' + url, options).then(function (r) {
                return r.body.data;
            }, function (r) {

                if (r.status !== 400) {
                    __WEBPACK_IMPORTED_MODULE_8__services_EventBus__["a" /* EventBus */].$emit('error', {
                        message: 'Service is temporarily unavailable',
                        code: r.status
                    });
                }

                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(r);
            });
        }
    }, {
        key: "getImage",
        value: function getImage(url) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            return __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].http.get('/api/' + url, options).then(function (r) {
                var urlCreator = window.URL || window.webkitURL;

                return urlCreator.createObjectURL(r.bodyBlob);
            });
        }
    }, {
        key: "getCams",
        value: function getCams() {
            return this.get('cameras');
        }
    }, {
        key: "getCam",
        value: function getCam(id) {
            return this.get('cameras/' + id);
        }
    }, {
        key: "getViews",
        value: function getViews(login) {
            return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var viewsJson = localStorage.getItem('views');
                var views = [];

                if (viewsJson) {
                    views = JSON.parse(viewsJson);

                    if (__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isArray(views) || !__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isObject(views)) localStorage.removeItem('views');

                    views = views[login] ? views[login] : [];
                }

                resolve(views);
            });
        }
    }, {
        key: "saveView",
        value: function saveView(view, login) {
            return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var views = JSON.parse(localStorage.getItem('views')) || {};

                if (views && !views[login]) views[login] = [];

                view = {
                    id: view.id,
                    name: view.name,
                    grid: view.grid,
                    cams: view.cams
                };

                if (isNaN(view.id)) {
                    view.id = views[login].reduce(function (prev, next) {
                        var id = parseInt(next.id);
                        return id >= prev ? id + 1 : prev;
                    }, 1);

                    views[login].push(view);
                } else {
                    var index = views[login].findIndex(function (v) {
                        return view.id === v.id;
                    });

                    if (index > -1) {
                        views[login][index] = view;
                    } else {
                        reject();
                    }
                }

                localStorage.setItem('views', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(views));
                resolve(view);
            });
        }
    }, {
        key: "removeView",
        value: function removeView(viewId, login) {
            return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var views = JSON.parse(localStorage.getItem('views') || '{"' + login + '":[]}');
                var index = views[login].findIndex(function (view) {
                    return view.id === viewId;
                });

                if (index > -1) {
                    views[login].splice(index, 1);
                    localStorage.setItem('views', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(views));
                    resolve(viewId);
                } else {
                    reject();
                }
            });
        }
    }, {
        key: "getCamImage",
        value: function getCamImage(id) {
            return this.getImage('v2/cameras/' + id + '/image', { responseType: 'blob' });
        }
    }, {
        key: "getMapImage",
        value: function getMapImage(mapId, planId) {
            return this.getImage('v1/maps/' + mapId + '/image/' + planId, { responseType: 'blob' });
        }
    }, {
        key: "getMaps",
        value: function getMaps() {
            return this.get('maps');
        }
    }, {
        key: "getAlarms",
        value: function getAlarms(cams) {
            var _this = this;

            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var requests = [];
                var requestDateFormat = 'YYYYMMDDTHHmmss';
                var result = [];

                params.start_time = __WEBPACK_IMPORTED_MODULE_6_moment___default()(params.start_time).format(requestDateFormat);
                params.stop_time = __WEBPACK_IMPORTED_MODULE_6_moment___default()(params.stop_time).format(requestDateFormat);

                cams.forEach(function (cam) {
                    requests.push(_this.get('cameras/' + encodeURIComponent(cam.id) + '/protocol', { params: params }));
                });

                __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(requests).then(function (r) {
                    r.forEach(function (data, i) {
                        var cam = cams[i];

                        data.events.forEach(function (event) {
                            result.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
                                camId: cam.id,
                                name: cam.name,
                                timestamp: __WEBPACK_IMPORTED_MODULE_6_moment___default()(event.time, 'DD-MM-YY HH:mm:ss').unix()
                            }, event));
                        });
                    });

                    resolve(result);
                }, function (e) {
                    return reject(e);
                });
            });
        }
    }, {
        key: "getPage",
        value: function getPage(name) {
            return __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].http.get('/static/pages/' + name + '.html').then(function (r) {
                return r.body;
            });
        }
    }, {
        key: "getAcsObject",
        value: function getAcsObject(type, id) {
            var _this2 = this;

            return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
                _this2.get("acsconfig?type=" + type + "&ids=" + id).then(function (r) {
                    resolve(r[0]);
                }).catch(function (e) {
                    console.log(e);
                    resolve(null);
                });
            });
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 579 */,
/* 580 */,
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_dashboard_Dashboard_vue__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_auth_Auth_vue__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_alarms_Alarms_vue__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_cams_Cams_vue__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_map_Map_vue__ = __webpack_require__(702);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    redirect: '/dashboard/views/main'
  }, {
    path: '/auth',
    name: 'auth',
    component: __WEBPACK_IMPORTED_MODULE_3__modules_auth_Auth_vue__["a" /* default */]
  }, {
    path: '/dashboard/',
    name: 'Dashboard',
    component: __WEBPACK_IMPORTED_MODULE_2__modules_dashboard_Dashboard_vue__["a" /* default */],
    meta: {
      auth: true
    },
    props: { popup: 'agreement' },
    children: [{
      path: 'alarms/:alarmId?',
      name: 'alarms',
      component: __WEBPACK_IMPORTED_MODULE_4__modules_alarms_Alarms_vue__["a" /* default */],
      meta: {
        auth: true
      }
    }, {
      path: 'map/:mapGroupId/:mapId',
      name: 'map',
      component: __WEBPACK_IMPORTED_MODULE_6__modules_map_Map_vue__["a" /* default */],
      meta: {
        auth: true
      }
    }, {
      path: 'views',
      redirect: 'views/main'
    }, {
      path: 'views/:viewId?/:mapGroupId?/:mapId?/:camId?',
      name: 'views',
      component: __WEBPACK_IMPORTED_MODULE_5__modules_cams_Cams_vue__["a" /* default */],
      meta: {
        auth: true
      }
    }, {
      path: '',
      redirect: 'views/main'
    }]
  }],
  mode: 'history'
}));

/***/ }),
/* 582 */,
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_dashboard_js__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d65dbd9a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(689);
function injectStyle (ssrContext) {
  __webpack_require__(584)
}
var normalizeComponent = __webpack_require__(3)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d65dbd9a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_dashboard_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d65dbd9a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 584 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 585 */,
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_perfect_scrollbar__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_perfect_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_dropdown_Dropdown_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_tree_Tree_vue__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_sidebar_Sidebar_vue__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_loader_Loader_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_cam_Cam_vue__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_search_Search_vue__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_viewTabs_ViewTabs_vue__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_alarms_Alarms_vue__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_userInfo_UserInfo_vue__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__services_EventBus_js__ = __webpack_require__(15);


















function getVisualRectPersent() {
    return {
        left: 0,
        right: 100,
        top: 0,
        bottom: 100
    };
}

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Dashboard',
    data: function data() {
        return {
            videoStreams: [{ name: 'Base', value: 1 }, { name: 'Low resolution', value: 2 }, { name: 'High resolution', value: 3 }],
            modes: [{ name: 'Live', value: 0, alias: 'live' }, { name: 'Playback', value: 1, alias: 'playback' }],
            sidebars: {
                cams: {
                    open: true,
                    show: true,
                    search: '',
                    scroll: null,
                    modes: {
                        active: 'list',
                        list: [{ name: 'List', value: 'list' }, { name: 'Preview', value: 'preview' }]
                    }
                },
                maps: {
                    open: true,
                    search: '',
                    modes: {
                        active: 'map',
                        list: [{ name: 'Map', value: 'map' }, { name: 'Video', value: 'views' }]
                    }
                }
            },
            loading: {
                alarms: false
            },
            modals: {
                agreement: true
            },
            visualRectPersent: getVisualRectPersent()
        };
    },

    components: {
        ViewTabs: __WEBPACK_IMPORTED_MODULE_13__modules_viewTabs_ViewTabs_vue__["a" /* default */],
        Dropdown: __WEBPACK_IMPORTED_MODULE_7__components_dropdown_Dropdown_vue__["a" /* default */],
        Tree: __WEBPACK_IMPORTED_MODULE_8__components_tree_Tree_vue__["a" /* default */],
        Sidebar: __WEBPACK_IMPORTED_MODULE_9__components_sidebar_Sidebar_vue__["a" /* default */],
        Loader: __WEBPACK_IMPORTED_MODULE_10__components_loader_Loader_vue__["a" /* default */],
        Cam: __WEBPACK_IMPORTED_MODULE_11__components_cam_Cam_vue__["a" /* default */],
        VuePerfectScrollbar: __WEBPACK_IMPORTED_MODULE_6_vue_perfect_scrollbar___default.a,
        UserInfo: __WEBPACK_IMPORTED_MODULE_15__modules_userInfo_UserInfo_vue__["a" /* default */],
        Search: __WEBPACK_IMPORTED_MODULE_12__components_search_Search_vue__["a" /* default */]
    },
    created: function created() {
        var _this = this;

        this.$store.dispatch('getViews');
        this.$store.dispatch('getMaps');

        __WEBPACK_IMPORTED_MODULE_16__services_EventBus_js__["a" /* EventBus */].$on('resize:end', function () {
            _this.updateScroll(_this.$refs.camsScroll);
            _this.updateScroll(_this.$refs.mapsScroll);
            _this.updateScroll(_this.$refs.mapsAlarmScroll);
        });
        __WEBPACK_IMPORTED_MODULE_16__services_EventBus_js__["a" /* EventBus */].$on('changeMapPosition', this.onChangeMapPosition);
    },
    mounted: function mounted() {
        this.setCamsMode('list');
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
        maps: 'getMaps',
        alarmMaps: 'getAlarmMaps',
        allCams: 'getCams',
        views: 'getViews',
        alarms: 'getAlarms',
        latestAlarms: 'getLatestAlarms',
        user: 'getUser',
        activeView: 'getActiveView',
        grids: 'getGrids',
        stream: 'getStream',
        activeGrid: 'getActiveGrid',
        activeMap: 'getActiveMap',
        getMapById: 'getMapById'
    }), {
        cams: function cams() {
            var _this2 = this;

            var cams = this.allCams.filter(function (item) {
                var name = item.name.toLowerCase();
                var search = _this2.sidebars.cams.search.toLowerCase();

                return name.indexOf(search) > -1;
            });

            return cams || [];
        },
        camGroups: function camGroups() {
            var groups = [];
            var pathDelimeter = /[#:]+/;
            this.cams.forEach(function (camObj) {
                var groupPath = camObj.name.split(pathDelimeter).map(function (path) {
                    return path.trim();
                });
                if (groupPath.length > 1) {
                    var existGroup = null;

                    var _loop = function _loop(i) {
                        var path = groupPath[i];
                        if (i === 0) {
                            existGroup = groups.find(function (g) {
                                return Array.isArray(g) && g[0].value === path;
                            });
                            if (!existGroup) {
                                existGroup = [{
                                    value: path,
                                    name: path,
                                    children: []
                                }];
                                groups.push(existGroup);
                            }
                        } else {
                            var pathItem = groupPath.slice(0, i + 1).join(pathDelimeter);
                            var pathParent = groupPath.slice(0, i).join(pathDelimeter);
                            if (!existGroup[0].children.find(function (item) {
                                return item.pathParent === pathParent && item.value === pathItem;
                            })) {
                                if (i !== groupPath.length - 1) {

                                    existGroup[0].children.push({
                                        name: path,
                                        value: pathItem,
                                        parent: i == 1 ? 0 : pathParent,
                                        pathParent: pathParent
                                    });
                                } else {
                                    existGroup[0].children.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, camObj, {
                                        name: path,
                                        value: pathItem,
                                        parent: i == 1 ? 0 : pathParent,
                                        pathParent: pathParent
                                    }));
                                }
                            }
                        }
                    };

                    for (var i = 0; i < groupPath.length; i++) {
                        _loop(i);
                    }
                } else {
                    groups.push(camObj);
                }
            });
            return groups;
        },
        mapData: function mapData() {
            var mapData = this.maps.map(function (group) {
                if (group) {
                    var map = group.map.map(function (item) {
                        return {
                            value: item.id,
                            name: item.name,
                            parent: item.parent
                        };
                    });

                    return {
                        value: group.id,
                        name: group.name,
                        children: map
                    };
                }
            });
            return mapData;
        },
        alarmMapData: function alarmMapData() {

            return this.alarmMaps.map(function (group) {
                if (group) {
                    var map = group.map.map(function (item) {
                        return {
                            value: item.id,
                            name: item.name,
                            parent: item.parent
                        };
                    });

                    return {
                        value: group.id,
                        name: group.name,
                        children: map
                    };
                }
            });
        },
        disableGrid: function disableGrid() {
            return this.$route.name === 'alarms' || this.$route.name === 'map' && this.$store.state.mapMode === 'map' || this.$route.name === 'map' && this.activeMap && !this.activeMap.cams.length;
        }
    }),
    watch: {
        $route: {
            immediate: true,
            handler: function handler(route) {
                switch (route.name) {
                    case 'alarms':
                        this.sidebars.cams.show = false;
                        this.sidebars.maps.open = false;
                        break;

                    case 'views':
                        this.sidebars.cams.show = true;

                        if (route.params.mapId && route.params.mapGroupId) this.sidebars.maps.modes.active = 'views';

                        this.$nextTick(function () {
                            return __WEBPACK_IMPORTED_MODULE_16__services_EventBus_js__["a" /* EventBus */].$emit('views:select');
                        });
                        break;

                    case 'map':
                        this.sidebars.cams.show = true;
                        break;
                }
            }
        },
        activeMap: function activeMap(map) {
            var _this3 = this;

            if (map && this.sidebars.maps.modes.active === 'views') {
                var camsFilter = map.cams.filter(function (cam) {
                    return cam.x >= _this3.visualRectPersent.left && cam.x <= _this3.visualRectPersent.right && cam.y >= _this3.visualRectPersent.top && cam.y <= _this3.visualRectPersent.bottom;
                });
                var cams = this.$route.params.camId ? [this.$route.params.camId] : camsFilter.map(function (cam) {
                    return cam.id;
                });
                this.$store.commit('resetTempView');

                this.$store.commit('addCamsIntoView', {
                    camIds: cams,
                    viewId: 'main'
                });
            }
        }
    },
    methods: {
        setMap: function setMap(map) {
            var params = { mapGroupId: map.root, mapId: map.value };
            var mode = this.sidebars.maps.modes.active;

            if (mode === 'views') params.viewId = 'main';

            this.$router.push({ name: mode, params: params });
        },
        setMode: function setMode(mode) {
            this.$store.commit('setMode', mode);

            this.$nextTick(function () {
                __WEBPACK_IMPORTED_MODULE_16__services_EventBus_js__["a" /* EventBus */].$emit('mode:change');
            });
        },
        setCamsMode: function setCamsMode(mode) {
            this.sidebars.cams.modes.active = mode;
            this.updateScroll(this.$refs.camsScroll);
        },
        setGrid: function setGrid(grid) {
            this.$store.dispatch('setGrid', grid.value);
            this.$nextTick(function () {
                __WEBPACK_IMPORTED_MODULE_16__services_EventBus_js__["a" /* EventBus */].$emit('views:select');
            });
        },
        changeMapMode: function changeMapMode(mode) {
            if (mode === 'map') {
                this.visualRectPersent = getVisualRectPersent();
            }
            if (this.activeMap) {
                var params = { mapGroupId: this.activeMap.group.id, mapId: this.activeMap.id };

                if (mode === 'views') params.viewId = 'main';
                this.$router.push({ name: mode, params: params });
            }

            this.sidebars.maps.modes.active = mode;
        },
        onChangeMapPosition: function onChangeMapPosition(visualRectPersent) {
            this.visualRectPersent = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, visualRectPersent);
        },
        getAllAlarms: function getAllAlarms() {
            this.sidebars.cams.show = false;
            this.$router.push({ name: 'alarms' });
        },
        updateScroll: function updateScroll(ref) {
            if (ref) {
                this.$nextTick(function () {
                    ref.update();
                });
            }
        },
        openAlarms: function openAlarms() {
            var _this4 = this;

            this.loading.alarms = true;
            var params = {
                start_time: __WEBPACK_IMPORTED_MODULE_5_moment___default()().startOf('day').format(),
                stop_time: __WEBPACK_IMPORTED_MODULE_5_moment___default()().format(),
                max_count: 6
            };
            if (this.$route.name === 'alarms') {
                params.max_count = 30;
            }
            this.$store.dispatch('getAlarms', {
                cams: this.cams,
                params: params
            }).then(function () {
                _this4.loading.alarms = false;
            });
        },
        getAlarmComment: function getAlarmComment(alarm) {
            return __WEBPACK_IMPORTED_MODULE_14__modules_alarms_Alarms_vue__["a" /* default */].methods.getComment(alarm);
        },
        onSelectStream: function onSelectStream(stream) {
            this.$store.commit('changeStream', stream.value);
        },
        goToAlarm: function goToAlarm(alarm) {
            this.$store.commit('setMode', 1);
            this.$router.push({
                name: 'alarms',
                params: { alarmId: alarm.id }
            });
        },
        isCamSelected: function isCamSelected(cam) {
            if (this.activeView) return this.activeView.cams.some(function (c) {
                return c.id == cam.id;
            });

            if (this.activeMap) return this.activeMap.cams.some(function (c) {
                return c.id == cam.id;
            });

            return false;
        },
        onCamDrag: function onCamDrag(data, event) {
            __WEBPACK_IMPORTED_MODULE_16__services_EventBus_js__["a" /* EventBus */].$emit('cam:dragstart');

            event.dataTransfer.setData('text', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                camera_id: data.camera_id,
                connection_id: ''
            }));
        }
    }
});

/***/ }),
/* 587 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_EventBus__ = __webpack_require__(15);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Dropdown',
    data: function data() {
        return {
            show: this.open,
            positions: this.type
        };
    },

    props: {
        type: {
            type: String,
            default: 'right'
        },
        isSelect: {
            type: Boolean,
            default: false
        },
        container: {
            default: null
        },
        open: {
            type: Boolean,
            default: false
        },
        closeOther: {
            type: Boolean,
            default: true
        }
    },
    created: function created() {
        var _this = this;

        if (this.isSelect) this.$parent.$on('select:open', function () {
            _this.calculate();
        });

        this.$parent.$on('select:close', function () {
            _this.show = false;
            _this.$emit('update:open', false);
        });
    },

    watch: {
        open: function open(value) {
            this.show = value;
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        __WEBPACK_IMPORTED_MODULE_1__services_EventBus__["a" /* EventBus */].$on('root-click', function () {
            _this2.show = false;
            _this2.$emit('update:open', false);
        });

        __WEBPACK_IMPORTED_MODULE_1__services_EventBus__["a" /* EventBus */].$on('dropdown:open', function (target) {
            if (_this2.$el != target && _this2.show) {
                _this2.show = false;
                _this2.$emit('update:open', false);
            }
        });
    },

    methods: {
        toggle: function toggle(event) {
            var _this3 = this;

            if (!this.show && this.closeOther) __WEBPACK_IMPORTED_MODULE_1__services_EventBus__["a" /* EventBus */].$emit('dropdown:open', event.target);

            this.show = !this.show;
            this.$emit('update:open', this.show);

            if (this.show) {
                if (this.container) {
                    this.$nextTick(function () {
                        if (!_this3.isSelect) _this3.calculate();

                        _this3.$emit('open');
                    });
                } else this.$emit('open');
            }
        },
        calculate: function calculate() {
            var containerRects = this.container.getBoundingClientRect();
            var toggleRects = this.$refs.toggle.getBoundingClientRect();
            var listRects = this.$refs.list.getBoundingClientRect();
            var align = containerRects.right - listRects.right < 0 ? 'right' : 'left';
            var valign = containerRects.bottom - (toggleRects.bottom + listRects.height) < 0 ? 'bottom' : 'right';
            this.positions = align + ' ' + valign;
        }
    }
});

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown",class:[_vm.positions, { opened: _vm.show }]},[_c('div',{ref:"toggle",staticClass:"toggle",on:{"click":function($event){$event.stopPropagation();_vm.toggle($event)}}},[_vm._t("toggle")],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],ref:"list",staticClass:"list",on:{"click":function($event){$event.stopPropagation();_vm.show = false}}},[_vm._t("list")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_tree_js__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_384b991f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tree_vue__ = __webpack_require__(597);
function injectStyle (ssrContext) {
  __webpack_require__(591)
}
var normalizeComponent = __webpack_require__(3)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-384b991f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_tree_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_384b991f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tree_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 591 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tree_Tree_item_vue__ = __webpack_require__(593);




__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('tree-item', __WEBPACK_IMPORTED_MODULE_2__components_tree_Tree_item_vue__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Menu',
    data: function data() {
        return {
            bus: new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]()
        };
    },
    created: function created() {
        var _this = this;

        this.bus.$on('select', function (model) {
            _this.$emit('select', model);
        });

        this.bus.$on('update', function () {
            __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].nextTick(function () {
                _this.$emit('update');
            });
        });
    },

    props: {
        data: {
            type: Array,
            required: true
        },
        root: {
            type: [Number, String],
            default: null
        },
        value: {
            type: [Number, String],
            default: null
        },
        search: {
            type: String,
            default: ''
        },
        notHierarchy: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        tree: function tree() {
            var _this2 = this;

            var tree = [];
            this.data.forEach(function (item) {
                var sorted = _.sortBy(item.children, function (map) {
                    return map.parent;
                }).map(function (m) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, m, { root: item.value, children: [] });
                });
                var treeList = [];
                var lookup = {};

                sorted.forEach(function (obj) {
                    if (!_this2.notHierarchy) {
                        lookup[obj.value] = obj;
                    } else {
                        tree.push(obj);
                    }
                });
                if (!_this2.notHierarchy) {
                    sorted.forEach(function (obj) {
                        if (obj.parent !== 0) {
                            lookup[obj.parent].children.push(obj);
                        } else {
                            treeList.push(obj);
                        }
                    });
                    tree.push({
                        children: treeList,
                        value: null,
                        name: item.name,
                        root: item.value
                    });
                }
            });
            return tree;
        }
    }
});

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_tree_item_js__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_deda5632_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tree_item_vue__ = __webpack_require__(596);
function injectStyle (ssrContext) {
  __webpack_require__(594)
}
var normalizeComponent = __webpack_require__(3)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_tree_item_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_deda5632_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tree_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 594 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Menu',
    data: function data() {
        return {
            open: false

        };
    },

    props: {
        model: {
            type: Object
        },
        bus: {
            type: Object,
            required: true
        },
        root: {
            type: [Number, String],
            default: null
        },
        value: {
            type: [Number, String],
            default: null
        },
        search: {
            type: String,
            default: ''
        },
        level: {
            type: Number,
            default: 0
        }
    },
    created: function created() {
        this.updateTree();
    },

    computed: {
        hasChildren: function hasChildren() {
            return this.model.children && this.model.children.length;
        },
        active: function active() {
            return this.model.root == this.root && this.model.value == this.value;
        },
        found: function found() {
            return this.isContains(this.search, this.model.name);
        }
    },
    watch: {
        search: function search() {
            this.updateTree();
        },
        value: function value() {
            this.updateTree();
        }
    },
    methods: {
        toggle: function toggle() {
            this.open = !this.open;
            this.bus.$emit('update');
        },
        select: function select() {
            if (this.model.value !== null) this.bus.$emit('select', {
                value: this.model.value,
                root: this.model.root
            });else this.toggle();
        },
        findByCriteria: function findByCriteria(model, criteria) {
            var i = void 0,
                currentChild = void 0,
                result = void 0;

            if (criteria(model)) {
                return model;
            } else {
                if (model.children) for (i = 0; i < model.children.length; i++) {
                    currentChild = model.children[i];

                    result = this.findByCriteria(currentChild, criteria);

                    if (result !== false) {
                        return result;
                    }
                }

                return false;
            }
        },
        updateTree: function updateTree() {
            var _this = this;

            if (this.search && this.search.length) {
                this.open = !!this.findByCriteria(this.model, function (model) {
                    return model.children.some(function (item) {
                        return _this.isContains(_this.search, item.name);
                    });
                });
            } else {
                if (this.model.root == this.root) {
                    this.open = this.findByCriteria(this.model, function (model) {
                        return model.children.some(function (item) {
                            return item.value == _this.value;
                        });
                    }) || this.open;
                }
            }
        },
        isContains: function isContains(keyword, string) {
            return keyword.length && string.toLowerCase().indexOf(keyword.toLowerCase()) > -1;
        }
    }
});

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tree-item"},[_c('div',{staticClass:"item-btn",class:['level-' + _vm.level, { active: _vm.active, opened: _vm.open, 'has-children': _vm.hasChildren, found: _vm.found }],on:{"click":_vm.select}},[(_vm.hasChildren)?_c('div',{staticClass:"icon-arrow",on:{"click":function($event){$event.stopPropagation();_vm.toggle($event)}}}):_vm._e(),_vm._v(" "),_vm._t("default",[_c('div',{staticClass:"name"},[_vm._v("\n        "+_vm._s(_vm.model.name)+"\n      ")])],{model:_vm.model})],2),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasChildren && _vm.open),expression:"hasChildren && open"}],staticClass:"sub"},_vm._l((_vm.model.children),function(sub,index){return _c('li',{key:index},[_c('tree-item',{attrs:{"model":sub,"bus":_vm.bus,"root":_vm.root,"value":_vm.value,"search":_vm.search,"level":_vm.level + 1},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(index,name){return {key:"default",fn:function(data){return [_vm._t(name,null,null,data)]}}})])})],1)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"tree"},_vm._l((_vm.tree),function(item,index){return _c('li',{key:index},[_c('tree-item',{attrs:{"model":item,"root":_vm.root,"value":_vm.value,"bus":_vm.bus,"search":_vm.search},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(index,name){return {key:"default",fn:function(data){return [_vm._t(name,null,null,data)]}}})])})],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 598 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_downloadList_DownloadList_vue__ = __webpack_require__(600);


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Sidebar',
    data: function data() {
        return {
            downloadVisible: false
        };
    },

    props: {
        type: {
            type: String,
            default: 'left'
        },
        open: {
            type: Boolean,
            default: true
        },
        show: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        toggle: function toggle(isShow) {
            this.$emit('update:open', isShow === true ? isShow : !this.open);

            if (this.open) this.$emit('open');
        }
    },
    components: {
        DownloadList: __WEBPACK_IMPORTED_MODULE_0__components_downloadList_DownloadList_vue__["a" /* default */]
    }
});

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_downloadList_js__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2909960e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadList_vue__ = __webpack_require__(614);
function injectStyle (ssrContext) {
  __webpack_require__(601)
}
var normalizeComponent = __webpack_require__(3)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2909960e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_downloadList_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2909960e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 601 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__downloadListItem_DownloadListItem_vue__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_circleProgress_CircleProgress_vue__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_perfect_scrollbar__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_perfect_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(35);







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'download-list',
    props: {
        closeMenu: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            compactMode: true
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
        videos: 'getUplodedVideos',
        videoState: 'getVideoState'
    })),
    components: {
        DownloadListItem: __WEBPACK_IMPORTED_MODULE_1__downloadListItem_DownloadListItem_vue__["a" /* default */],
        CircleProgress: __WEBPACK_IMPORTED_MODULE_2__components_circleProgress_CircleProgress_vue__["a" /* default */],
        VuePerfectScrollbar: __WEBPACK_IMPORTED_MODULE_3_vue_perfect_scrollbar___default.a
    },
    methods: {
        toggle: function toggle() {
            if (!this.closeMenu) {
                this.compactMode = !this.compactMode;
                this.$emit('changeVisible', !this.compactMode);
            }
        }
    },
    watch: {
        videos: function videos() {
            if (!this.videos || !this.videos.length) {
                this.compactMode = true;
                this.$emit('changeVisible', !this.compactMode);
            }
        },
        closeMenu: function closeMenu() {
            if (this.closeMenu) {
                this.compactMode = true;
                this.$emit('changeVisible', !this.compactMode);
            }
        }
    }
});

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_downloadListItem_js__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1069d072_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadListItem_vue__ = __webpack_require__(613);
function injectStyle (ssrContext) {
  __webpack_require__(604)
}
var normalizeComponent = __webpack_require__(3)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1069d072"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_downloadListItem_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1069d072_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadListItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 604 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_EventBus__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_circleProgress_CircleProgress_vue__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tooltip_Tooltip_vue__ = __webpack_require__(609);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'download-list-item',
    props: {
        video: {
            type: Object,
            default: {
                intervalDateVideo: null,
                percent: null,
                source_id: null,
                session: null,
                link: null,
                statusLoad: null,
                tooltipText: null
            }
        }
    },
    methods: {
        deleteVideo: function deleteVideo() {
            __WEBPACK_IMPORTED_MODULE_0__services_EventBus__["a" /* EventBus */].$emit('stop-export-file', this.video.session);
            this.$store.commit('deleteUplodedVideo', this.video.session);
        }
    },
    components: {
        CircleProgress: __WEBPACK_IMPORTED_MODULE_1__components_circleProgress_CircleProgress_vue__["a" /* default */],
        Tooltip: __WEBPACK_IMPORTED_MODULE_2__components_tooltip_Tooltip_vue__["a" /* default */]
    }
});

/***/ }),
/* 606 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'circle-progress',
    props: {
        progress: {
            type: Number,
            default: 50
        },
        status: {
            default: 'progress',
            validator: function validator(value) {
                return ['success', 'fail', 'progress'].includes(value);
            }
        }
    },
    data: function data() {
        return {
            circumference: 2 * Math.PI * 54
        };
    },

    computed: {
        dashoffset: function dashoffset() {
            return this.circumference * (1 - this.progress / 100);
        }
    }
});

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner"},[(_vm.status === 'progress')?_c('svg',{staticClass:"progress",attrs:{"width":"100%","height":"100%","viewBox":"0 0 120 120"}},[_c('circle',{staticClass:"progress__meter",attrs:{"cx":"60","cy":"60","r":"54","stroke-width":"12"}}),_vm._v(" "),_c('circle',{staticClass:"progress__value",style:({strokeDashoffset: _vm.dashoffset, strokeDasharray: _vm.circumference}),attrs:{"cx":"60","cy":"60","r":"54","stroke-width":"12"}})]):_vm._e(),_vm._v(" "),(_vm.status === 'fail')?_c('img',{class:_vm.status,attrs:{"src":"/static/images/ic-oshibochka-vishla.svg"}}):_vm._e(),_vm._v(" "),(_vm.status === 'success')?_c('img',{class:_vm.status,attrs:{"src":"/static/images/ic-done.svg"}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_tooltip_js__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1b8b6a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tooltip_vue__ = __webpack_require__(612);
function injectStyle (ssrContext) {
  __webpack_require__(610)
}
var normalizeComponent = __webpack_require__(3)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e1b8b6a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_tooltip_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1b8b6a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tooltip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 610 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    name: "Tooltip",
    props: {
        text: {
            type: String,
            default: null
        },
        animation: {
            type: Boolean,
            default: false
        }
    }
});

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooltip"},[_c('div',{staticClass:"target",class:{'haveContent': !!_vm.text}},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"contents-wrapper top-right",class:{'animation': _vm.animation}},[_c('span',{staticClass:"content"},[_vm._v(_vm._s(_vm.$t(_vm.text)))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"videoItem"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"left"},[_c('tooltip',{attrs:{"text":_vm.video.tooltipText}},[_c('circle-progress',{attrs:{"progress":_vm.video.percent,"status":_vm.video.statusLoad}})],1),_vm._v(" "),_c('div',{staticClass:"id"},[_vm._v(_vm._s(_vm.video.source_id))])],1),_vm._v(" "),_c('div',{staticClass:"right"},[(_vm.video.link)?_c('a',{staticClass:"v-btn v-btn-load",attrs:{"href":_vm.video.link,"download":""}}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"v-btn v-btn-close",on:{"click":function($event){_vm.deleteVideo()}}})])]),_vm._v(" "),_c('div',{staticClass:"dates"},[_vm._v(_vm._s(_vm.video.intervalDateVideo))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.videos.length)?_c('div',{staticClass:"DownloadList",class:{'compactMode': _vm.compactMode, 'closeMenu': _vm.closeMenu}},[_c('div',{staticClass:"header",on:{"click":function($event){_vm.toggle()}}},[_c('div',{staticClass:"process"},[_c('circle-progress',{attrs:{"progress":_vm.videoState.percent,"status":_vm.videoState.status}}),_vm._v(" "),_c('div',{staticClass:"status"},[_vm._v(_vm._s(_vm.$t('DOWNLOADING'))+" "+_vm._s(_vm.videoState.completeVideoCount)+"/"+_vm._s(_vm.videoState.allVideoCount))])],1),_vm._v(" "),_c('div',{staticClass:"toggler"})]),_vm._v(" "),_c('VuePerfectScrollbar',{staticClass:"scrollbar",attrs:{"settings":{ minScrollbarLength: 30 }}},[_c('div',{staticClass:"content"},_vm._l((_vm.videos),function(video){return _c('download-list-item',{key:video.session,attrs:{"video":video}})}))])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"sidebar",class:[_vm.type, { opened: _vm.open,  'download-visible': _vm.downloadVisible} ]},[_c('div',{staticClass:"sidebar-wrap"},[( ! _vm.open)?_c('div',{staticClass:"toggle",on:{"click":_vm.toggle}},[_vm._t("icon")],2):_vm._e(),_vm._v(" "),(_vm.open)?_c('div',{staticClass:"sidebar-content"},[_vm._t("content")],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"bottom-toggle",on:{"click":_vm.toggle}},[_c('span',{staticClass:"icon-arrows"})]),_vm._v(" "),(_vm.type === 'right')?_c('div',{staticClass:"download-list-container",on:{"click":function($event){_vm.toggle(true)}}},[_c('download-list',{attrs:{"closeMenu":!_vm.open},on:{"changeVisible":function($event){_vm.downloadVisible=$event}}})],1):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 616 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Loader',
    data: function data() {
        return {};
    },

    props: {
        type: {
            type: String,
            default: 'medium'
        }
    },
    methods: {}
});

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader",class:_vm.type},[_c('div',{staticClass:"spinner"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 619 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_EventBus__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_iconCam_IconCam_vue__ = __webpack_require__(313);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Cam',
    data: function data() {
        return {};
    },

    props: {
        cam: {
            type: Object
        },
        draggable: {
            type: Boolean,
            default: false
        },
        selected: {
            type: Boolean,
            default: false
        },
        inMap: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        dragStart: function dragStart() {
            if (this.selected || !this.draggable) return false;

            __WEBPACK_IMPORTED_MODULE_0__services_EventBus__["a" /* EventBus */].$emit('cam:dragstart');
        },
        dragEnd: function dragEnd() {
            __WEBPACK_IMPORTED_MODULE_0__services_EventBus__["a" /* EventBus */].$emit('cam:dragend');
        },
        selectView: function selectView(view) {
            this.$store.commit('setGrid', view.grid);
            this.$router.push({ name: 'views', params: { viewId: view.id } });
        }
    },
    components: {
        IconCam: __WEBPACK_IMPORTED_MODULE_1__components_iconCam_IconCam_vue__["a" /* default */]
    }
});

/***/ }),
/* 621 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'IconCam',
  props: {
    cam: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: 'map' // map | preview - если map вычисляется поворот иконки, позиционировние задается в род. компоенете
    },
    isAlarm: {
      type: Boolean,
      default: false
    },
    isHighlight: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 35
    }
  },
  computed: {
    styleIcon: function styleIcon() {
      var res = {};
      if (this.type !== 'preview') {
        res.width = this.width + 'px';
        res.height = this.width + 'px';
      }
      if (this.type === 'map') {
        res.transform = 'rotate(' + this.cam.rotation + 'rad)';
      }
      return res;
    }
  }
});

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-wrapper",class:[
        _vm.cam.icon,
        {
        'icon-wrapper--preview': _vm.type === 'preview',
        'alarm-background': _vm.isAlarm,
        'cam-highlight': _vm.isHighlight
        }
    ],on:{"click":function($event){_vm.type === 'map' ? _vm.$emit('click') : ''}}},[_c('div',{staticClass:"icon-cam",style:(_vm.styleIcon),attrs:{"title":_vm.$t(("CAM_" + (_vm.cam.status.state)))}}),_vm._v(" "),_c('div',{staticClass:"icon-cam-status"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cam",class:[{
    draggable: _vm.draggable,
    'in-map': _vm.inMap,
    alarm: _vm.cam.status.state == 'ALARMED',
    selected: _vm.selected,
}]},[_c('div',{staticClass:"info",class:{ 'has-views': _vm.cam.views.length }},[_c('div',{staticClass:"main-info"},[_c('icon-cam',{staticClass:"icon",attrs:{"type":"preview","cam":_vm.cam}}),_vm._v(" "),(['ARMED', 'ALARMED'].includes(_vm.cam.status.state))?_c('div',{staticClass:"move-on"}):_vm._e(),_vm._v(" "),(!_vm.inMap)?_c('div',{staticClass:"name",attrs:{"title":_vm.cam.name}},[_vm._v(_vm._s(_vm._f("contraction")(_vm.cam.name)))]):_vm._e()],1),_vm._v(" "),(_vm.cam.views.length && !_vm.preview)?_c('div',{staticClass:"views"},_vm._l((_vm.cam.views),function(view){return _c('a',{key:view.id,staticClass:"item",attrs:{"title":view.name},on:{"click":function($event){_vm.selectView(view)}}},[_vm._v("\n                "+_vm._s(_vm._f("contraction")(view.name))+"\n            ")])})):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 625 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Search',
  props: ['value', 'placeholder'],
  methods: {
    onInput: function onInput() {
      this.$emit('input', this.$refs.searchInput.value);
    }
  }
});

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search"},[_c('input',{ref:"searchInput",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":_vm.onInput}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_viewTabs_js__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e6949ba8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewTabs_vue__ = __webpack_require__(673);
function injectStyle (ssrContext) {
  __webpack_require__(629)
}
var normalizeComponent = __webpack_require__(3)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e6949ba8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_viewTabs_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e6949ba8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewTabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 629 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_EventBus__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modal_Modal_vue__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dropdown_Dropdown_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_player_Player_vue__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_inputText_InputText_vue__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_loader_Loader_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_timeInterval_TimeInterval_vue__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_translates__ = __webpack_require__(317);













/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'view-tabs',
    data: function data() {
        return {
            form: {
                name: {
                    name: 'name',
                    validator: { required: true, uniqueTabName: true },
                    placeholder: 'View name'
                }
            },
            saving: null,
            removing: null,
            max: null,
            more: false,
            updating: true,
            full: false,
            limit: false,
            isShowDownload: false,
            camera_id: null,
            isCopy: false
        };
    },
    created: function created() {
        var _this = this;

        this.$validator.extend('uniqueTabName', {
            getMessage: function getMessage(field) {
                return 'uniqueTabName';
            },
            validate: function validate(value) {
                return (!_this.views.some(function (item) {
                    return value == item.name;
                })
                // здесь имена вьюс могут совпадать
                || !_this.isCopy && value == _this.saving.name) && value !== __WEBPACK_IMPORTED_MODULE_11__common_translates__["a" /* default */].ru['Main View'] && value !== 'Main View';
            }
        });
    },
    mounted: function mounted() {
        var _this2 = this;

        __WEBPACK_IMPORTED_MODULE_4__services_EventBus__["a" /* EventBus */].$on('resize:start', function () {
            _this2.updating = true;
        });
        __WEBPACK_IMPORTED_MODULE_4__services_EventBus__["a" /* EventBus */].$on('resize:end', this.updateTabs);
        __WEBPACK_IMPORTED_MODULE_4__services_EventBus__["a" /* EventBus */].$on('open:export', this.toggleExport);
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
        activeView: 'getActiveView',
        grids: 'getGrids',
        activeGrid: 'getActiveGrid',
        archCnvEnabled: 'getArchCnvEnabled'
    }), {
        views: function views() {
            return this.$store.state.views;
        },
        list: function list() {
            var _this3 = this;

            var result = this.views.map(function (item) {
                _this3.$set(item, 'menu', false);
                return item;
            });
            return {
                tabs: result.slice(0, this.max),
                dropdown: result.slice(this.max)
            };
        }
    }),
    watch: {
        views: {
            immediate: true,
            deep: true,
            handler: function handler() {
                var _this4 = this;

                this.$nextTick(function () {
                    _this4.updateTabs();
                });
            }
        }
    },
    methods: {
        setMaxTabs: function setMaxTabs() {
            var _this5 = this;

            if (this.$refs.list) {
                var items = this.$refs.list.children;

                var itemsWidth = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(items)).reduce(function (prev, curr) {
                    var selector = curr.getElementsByClassName('inner');
                    var el = selector.length ? selector[0] : curr;

                    return prev + el.clientWidth;
                }, 0);

                this.full = itemsWidth / this.$refs.list.clientWidth > 0.5;

                if (items.length && this.$refs.list.clientHeight > items[0].clientHeight) {
                    this.max = this.max - 1;
                    this.more = true;

                    this.$nextTick(function () {
                        _this5.setMaxTabs();
                    });
                } else {
                    this.updating = false;
                }
            }
        },
        updateTabs: function updateTabs() {
            var _this6 = this;

            this.updating = true;
            this.more = false;
            this.max = this.views.length;

            setTimeout(function () {
                _this6.setMaxTabs();
            }, 300);
        },
        select: function select(view) {
            this.$store.commit('setGrid', view.grid);
            this.$router.push({ name: 'views', params: { viewId: view.id } });
        },
        edit: function edit(tab, isCopy) {
            var _this7 = this;

            this.isCopy = !!isCopy;

            if (this.views.length > 10 && (tab.temp || this.isCopy)) {
                this.limit = true;
            } else {
                this.form.name.value = tab.temp ? this.getNewName() : tab.name;
                this.saving = tab;
                if (this.isCopy) {
                    this.saving = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.saving, { id: undefined });
                }

                __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick(function () {
                    var input = _this7.$refs['form-name'];

                    if (input) input.$emit('focus');
                });

                tab.menu = false;
            }
        },
        save: function save(tab) {
            var _this8 = this;

            var name = this.form.name.value;
            this.$validator.validateAll().then(function (result) {
                if (result) {
                    _this8.$store.dispatch('saveView', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, tab, {
                        cams: tab.cams.slice(0, _this8.grids.find(function (g) {
                            return g.value == tab.grid;
                        }).max),
                        name: name ? name : tab.name
                    })).then(function (view) {
                        _this8.isCopy = false;
                        _this8.form.name.value = null;
                        _this8.saving = null;
                        _this8.$router.push({ name: 'views', params: { viewId: view.id } }, function () {
                            _this8.$store.commit('setGrid', view.grid);
                        });
                    });
                }
            });
        },
        reset: function reset(tab) {
            var _this9 = this;

            if (tab.temp) {
                this.$store.commit('resetTempView');
                this.$store.commit('setGrid', 1);
            } else {
                this.$store.dispatch('getViewsData').then(function (views) {
                    var view = views.find(function (v) {
                        return v.id == tab.id;
                    });
                    _this9.$store.commit('setGrid', _this9.activeView.grid);
                    _this9.$store.commit('saveView', view);
                    _this9.$nextTick(function () {
                        __WEBPACK_IMPORTED_MODULE_4__services_EventBus__["a" /* EventBus */].$emit('views:select');
                    });
                });
            }
        },
        removeCamsFromView: function removeCamsFromView() {
            this.$store.commit('removeCamFromView', {
                camId: null,
                viewId: this.$store.getters.getActiveView.id
            });
        },
        remove: function remove(tab) {
            var _this10 = this;

            this.removing = null;
            this.$store.dispatch('removeView', tab.id).then(function (viewId) {

                if (_this10.views.length === 1 && !_this10.views[0].cams.length) {
                    _this10.$store.commit('resetTempView');
                    _this10.$store.commit('setGrid', 1);
                }

                if (viewId == _this10.$route.params.viewId) {
                    _this10.$router.push({ name: 'views', params: { viewId: _this10.views[0].id } });
                }
            });
        },
        toggleExport: function toggleExport() {
            var camera_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            this.camera_id = camera_id;
            this.isShowDownload = !this.isShowDownload;
        },
        getNewName: function getNewName() {
            var result = 1;

            this.views.forEach(function (item) {
                if (result <= item.id) result = item.id + 1;
            });

            return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].i18n.translate('View') + ' ' + result;
        }
    },
    components: {
        Modal: __WEBPACK_IMPORTED_MODULE_5__components_modal_Modal_vue__["a" /* default */],
        Dropdown: __WEBPACK_IMPORTED_MODULE_6__components_dropdown_Dropdown_vue__["a" /* default */],
        InputText: __WEBPACK_IMPORTED_MODULE_8__components_inputText_InputText_vue__["a" /* default */],
        Loader: __WEBPACK_IMPORTED_MODULE_9__components_loader_Loader_vue__["a" /* default */],
        TimeInterval: __WEBPACK_IMPORTED_MODULE_10__modules_timeInterval_TimeInterval_vue__["a" /* default */]
    }
});

/***/ }),
/* 631 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Modal',
    data: function data() {
        return {};
    },

    props: {
        show: {
            type: Boolean,
            default: false
        }
    }
});

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"modal"},[_c('div',[_vm._t("default")],2)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 634 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_loader_Loader_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_EventBus__ = __webpack_require__(15);










/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Player',
    inject: ['auth'],
    data: function data() {
        return {
            domain: location.origin,
            loading: true,
            options: {
                login: this.$store.state.user.login,
                password: this.auth.getTokenFromStorage(localStorage.getItem('token'))[1],
                monitor_id: {"MAIN_URL":"http://85.202.239.74:12113","WEBVIEW_URL":"http://85.202.239.74:25888","PLAYER":{"monitorId":1,"transport":4},"updateInterval":10000}.PLAYER.monitorId,
                transport: {"MAIN_URL":"http://85.202.239.74:12113","WEBVIEW_URL":"http://85.202.239.74:25888","PLAYER":{"monitorId":1,"transport":4},"updateInterval":10000}.PLAYER.transport
            },
            camsData: null,
            intervalDateVideo: null
        };
    },

    props: {
        data: {
            type: Object
        }
    },
    created: function created() {
        window.addEventListener('message', this.getMessage, false);
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('message', this.getMessage);
        __WEBPACK_IMPORTED_MODULE_8__services_EventBus__["a" /* EventBus */].$off('views:select');
        __WEBPACK_IMPORTED_MODULE_8__services_EventBus__["a" /* EventBus */].$off('mode:change');
        __WEBPACK_IMPORTED_MODULE_8__services_EventBus__["a" /* EventBus */].$off('cam:dragstart');
        __WEBPACK_IMPORTED_MODULE_8__services_EventBus__["a" /* EventBus */].$off('export-files');
        __WEBPACK_IMPORTED_MODULE_8__services_EventBus__["a" /* EventBus */].$off('stop-export-file');
    },
    mounted: function mounted() {
        __WEBPACK_IMPORTED_MODULE_8__services_EventBus__["a" /* EventBus */].$on('views:select', this.update);
        __WEBPACK_IMPORTED_MODULE_8__services_EventBus__["a" /* EventBus */].$on('mode:change', this.changeMode);
        __WEBPACK_IMPORTED_MODULE_8__services_EventBus__["a" /* EventBus */].$on('cam:dragstart', this.getCamsData);
        __WEBPACK_IMPORTED_MODULE_8__services_EventBus__["a" /* EventBus */].$on('export-files', this.exportFiles);
        __WEBPACK_IMPORTED_MODULE_8__services_EventBus__["a" /* EventBus */].$on('stop-export-file', this.stopExportFile);

        this.preloading();

        var startForm = document.createElement('form');
        startForm.setAttribute('method', 'post');
        startForm.setAttribute('target', 'webview_player');
        startForm.setAttribute('action', '/webview/video');
        startForm.setAttribute('style', 'display: none');
        var startFromHtml = '';
        var paramsSend = {
            command: 'show_monitor',
            auto_logon: 1,
            close_current_session: 1
        };
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(paramsSend, this.params);
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(paramsSend).forEach(function (key) {
            startFromHtml += '<input name="' + key + '" value="' + paramsSend[key] + '">';
        });
        startForm.innerHTML = startFromHtml;
        document.body.appendChild(startForm);
        startForm.submit();
        startForm.remove();
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])({
        stream: 'getStream'
    }), {
        params: function params() {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.options, this.data, {
                stream_role: this.stream
            });
        }
    }),
    watch: {
        stream: function stream() {
            this.sendMessage({
                command: 'init',
                stream_role: this.stream
            });
        }
    },
    methods: {
        update: function update() {
            if (this.params) {
                var data = {
                    command: 'show_monitor',
                    monitor_id: this.params.monitor_id,
                    mode: this.params.mode,
                    camera_list: this.params.camera_list.join(','),
                    layout: this.params.layout
                };

                if (this.params.time) data.time = this.params.time;

                this.sendMessage(data);
            }
        },
        changeMode: function changeMode() {
            this.sendMessage({
                command: 'changeMonitorMode',
                mode: this.params.mode
            });
        },
        sendMessage: function sendMessage(data) {
            if (this.$refs.player) this.$refs.player.contentWindow.postMessage(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), '*');
        },
        preloading: function preloading() {
            var _this = this;

            this.loading = true;
            setTimeout(function () {
                return _this.loading = false;
            }, 1500);
        },
        getCamsData: function getCamsData() {
            this.sendMessage({
                command: 'cameras_data',
                request_id: 1
            });
        },
        exportFiles: function exportFiles(data) {
            var startDateFormat = data.start_date.creationData().format;
            var endDateFormat = data.end_date.creationData().format;
            var startDateView = data.start_date.format(startDateFormat);
            var endDateView = data.end_date.format(endDateFormat);
            var formatSend = 'DD-MM-YYYY HH:mm:ss.000';
            data.start_date = data.start_date.format(formatSend);
            data.end_date = data.end_date.format(formatSend);
            this.intervalDateVideo = startDateView.slice(0, 16) + ' - ' + endDateView.slice(0, 16);
            var exportParams = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, data, {
                command: 'arch_cnv_export',
                camera_list: this.params.camera_list.join(';')
            });
            if (!!exportParams.camera_id) {
                exportParams.camera_list = exportParams.camera_id;
                delete exportParams.camera_id;
            }
            this.sendMessage(exportParams);
        },
        stopExportFile: function stopExportFile(id) {
            this.sendMessage({
                command: 'arch_cnv_cancel',
                id: id
            });
        },
        getMessage: function getMessage(event) {
            var _this2 = this;

            // console.log('event', event)
            if (event && event.data && typeof event.data === 'string') {
                var data = JSON.parse(event.data);
                switch (data.action) {
                    case 'alerts':
                        this.$router.push({ name: 'alarms', query: { cams: data.camera_id } });
                        break;
                    case 'onmap':
                        var params = null;

                        this.$store.state.maps.forEach(function (item) {
                            item.map.forEach(function (i) {
                                i.objects.forEach(function (o) {
                                    if (data.camera_id == o.id) params = { mapGroupId: item.id, mapId: i.id };
                                });
                            });
                        });

                        if (params) {
                            this.$store.commit('setCamIdFromCell', data.camera_id);
                            this.$router.push({ name: 'map', params: params });
                        }
                        break;

                    case 'setPlayerMode':
                        this.$store.commit('setMode', data.mode);
                        break;

                    case 'closeCamera':
                        this.$store.commit('removeCamFromView', {
                            camId: data.camera_id,
                            viewId: this.$store.getters.getActiveView.id
                        });
                        break;

                    case 'camera_drop':
                        if (this.camsData) {
                            this.camsData.list.forEach(function (item) {
                                if (item.camera_index == data.camera_index) {
                                    if (item.camera_id === 'null') {
                                        _this2.$store.commit('addCamsIntoView', {
                                            camIds: [data.camera_id],
                                            viewId: _this2.$store.getters.getActiveView.id
                                        });
                                    } else {
                                        _this2.$store.commit('replaceCam', {
                                            camId: data.camera_id,
                                            replacedCamId: item.camera_id,
                                            viewId: _this2.$store.getters.getActiveView.id
                                        });
                                    }
                                }
                            });
                        }

                        break;

                    case 'cameras_data':
                        this.camsData = data;
                        break;
                    case 'arch_cnv_poll':
                        {
                            this.$store.commit('setUplodedVideos', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, data, { intervalDateVideo: this.intervalDateVideo }));
                            break;
                        }
                }

                switch (data.command) {
                    case 'arch_cnv_export_show_control':
                        __WEBPACK_IMPORTED_MODULE_8__services_EventBus__["a" /* EventBus */].$emit('open:export', data.camera_id);
                        break;
                    case 'init':
                        if (+data.arch_cnv_enabled === 0) {
                            this.$store.commit('setArchCnvEnabled', false);
                        } else {
                            this.$store.commit('setArchCnvEnabled', true);
                        }
                        break;
                }
            }
        }
    },
    components: {
        Loader: __WEBPACK_IMPORTED_MODULE_7__components_loader_Loader_vue__["a" /* default */]
    }
});

/***/ }),
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"player",class:{ loading: _vm.loading }},[_c('iframe',{ref:"player",attrs:{"frameborder":"0","allowfullscreen":"allowfullscreen","name":"webview_player"}}),_vm._v(" "),(_vm.loading)?_c('loader'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 640 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'input-text',
    data: function data() {
        return {
            model: this.value,
            focused: false
        };
    },
    created: function created() {
        var _this = this;

        this.$on('focus', function () {
            _this.$refs.input.focus();
        });
    },

    computed: {
        empty: function empty() {
            return !this.model;
        }
    },
    props: {
        placeholder: String,
        name: String,
        disabled: {
            type: Boolean,
            default: false
        },
        hasError: Boolean,
        value: String,
        type: {
            type: String,
            default: 'text'
        }
    },
    watch: {
        model: function model(value) {
            this.$emit('update:value', value);
            this.$emit('input', value);
        },
        value: function value(_value) {
            this.model = _value;
        }
    },
    methods: {
        clear: function clear() {
            var _this2 = this;

            this.$nextTick(function () {
                _this2.$refs.input.focus();
            });

            this.model = null;
        }
    }
});

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-text",class:{ focused: _vm.focused, empty: _vm.empty, disabled: _vm.disabled, 'has-error': _vm.hasError }},[_c('div',{staticClass:"wrapper"},[(_vm.focused || ! _vm.empty)?_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),((_vm.type)==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],ref:"input",attrs:{"name":_vm.name,"placeholder":_vm.placeholder,"readonly":_vm.disabled,"autocomplete":"off","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.model)?_vm._i(_vm.model,null)>-1:(_vm.model)},on:{"focus":function($event){_vm.focused = true},"blur":function($event){_vm.focused = false; _vm.$emit('blur')},"change":function($event){var $$a=_vm.model,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model=$$a.concat([$$v]))}else{$$i>-1&&(_vm.model=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.model=$$c}}}}):((_vm.type)==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],ref:"input",attrs:{"name":_vm.name,"placeholder":_vm.placeholder,"readonly":_vm.disabled,"autocomplete":"off","type":"radio"},domProps:{"checked":_vm._q(_vm.model,null)},on:{"focus":function($event){_vm.focused = true},"blur":function($event){_vm.focused = false; _vm.$emit('blur')},"change":function($event){_vm.model=null}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],ref:"input",attrs:{"name":_vm.name,"placeholder":_vm.placeholder,"readonly":_vm.disabled,"autocomplete":"off","type":_vm.type},domProps:{"value":(_vm.model)},on:{"focus":function($event){_vm.focused = true},"blur":function($event){_vm.focused = false; _vm.$emit('blur')},"input":function($event){if($event.target.composing){ return; }_vm.model=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"clear",on:{"mousedown":_vm.clear}})]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_timeInterval_js__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a070318_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeInterval_vue__ = __webpack_require__(672);
function injectStyle (ssrContext) {
  __webpack_require__(644)
}
var normalizeComponent = __webpack_require__(3)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a070318"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_timeInterval_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a070318_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeInterval_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 644 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ext_datetime_Datetime_vue__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_EventBus__ = __webpack_require__(15);




var formatView = 'MM-DD-YYYY HH:mm:ss.000';

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'TimeInterval',
    props: {
        camera_id: {
            type: String,
            default: null
        }
    },
    data: function data() {
        return {
            lang: this.$store.state.i18n.locale,
            start_date: __WEBPACK_IMPORTED_MODULE_1_moment___default()().startOf('day').format(formatView),
            end_date: __WEBPACK_IMPORTED_MODULE_1_moment___default()().endOf('day').format(formatView),
            format: formatView,
            error: false
        };
    },

    components: {
        Datetime: __WEBPACK_IMPORTED_MODULE_0__components_ext_datetime_Datetime_vue__["a" /* default */]
    },
    computed: {
        errorDifferent: function errorDifferent() {
            return __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.end_date, this.format).isBefore(__WEBPACK_IMPORTED_MODULE_1_moment___default()(this.start_date, this.format));
        }
    },
    methods: {
        saveVideo: function saveVideo() {
            if (!this.error && !this.errorDifferent) {
                this.$emit('toggleExport');

                __WEBPACK_IMPORTED_MODULE_2__services_EventBus__["a" /* EventBus */].$emit('export-files', {
                    start_date: __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.start_date, formatView),
                    end_date: __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.end_date, formatView),
                    camera_id: this.camera_id
                });
            }
        },
        getError: function getError(data) {
            this.error = data;
        }
    }
});

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_datetime_js__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db2199cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Datetime_vue__ = __webpack_require__(671);
function injectStyle (ssrContext) {
  __webpack_require__(647)
}
var normalizeComponent = __webpack_require__(3)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_datetime_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db2199cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Datetime_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 647 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ext_input_text_input_text_vue__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ext_datepicker_datepicker_vue__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ext_dropdown_dropdown_vue__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ext_button_button_vue__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_EventBus__ = __webpack_require__(15);







var _data = {
    en: {
        date: {
            regex: /^\s*(1[012]|0?[1-9])\.(3[01]|[12][0-9]|0?[1-9])\.((?:19|20)\d{2})\s*$/,
            format: 'MM.DD.YYYY'
        },
        time: {
            regex: /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/,
            format: 'HH:mm'
        }
    },
    ru: {
        date: {
            regex: /^\s*(3[01]|[12][0-9]|0?[1-9])\.(1[012]|0?[1-9])\.((?:19|20)\d{2})\s*$/,
            format: 'DD.MM.YYYY'
        },
        time: {
            regex: /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/,
            format: 'HH:mm'
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'datetime',
    inject: ['$validator'],
    data: function data() {
        return {
            control: {
                date: null,
                time: null
            }
        };
    },

    props: {
        value: {
            type: String
        },
        name: {
            type: String,
            required: true
        },
        lang: {
            type: String,
            default: 'en'
        },
        format: {
            type: String,
            default: ''
        },
        error: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        control: {
            deep: true,
            handler: function handler(control) {
                var date = __WEBPACK_IMPORTED_MODULE_4_moment_moment___default()(control.date, this.data.date.format, true);
                var time = __WEBPACK_IMPORTED_MODULE_4_moment_moment___default()(control.time, this.data.time.format, true);

                if (date.isValid() && time.isValid()) {
                    var diff = time.diff(time.clone().startOf('day')) / 1000;
                    var datetime = date.add(diff, 'seconds');
                    this.$emit('input', datetime.format(this.format));
                    this.$emit('error', false);
                } else {
                    this.$emit('error', true);
                }
            }
        },
        value: {
            immediate: true,
            handler: function handler(value) {
                this.setControl(value);
            }
        },
        lang: function lang() {
            this.setControl(this.value);
        }
    },
    computed: {
        data: function data() {
            return _data[this.lang];
        }
    },
    methods: {
        setControl: function setControl(value) {
            if (value) {
                this.control.date = __WEBPACK_IMPORTED_MODULE_4_moment_moment___default()(value, this.format, true).format(this.data.date.format);
                this.control.time = __WEBPACK_IMPORTED_MODULE_4_moment_moment___default()(value, this.format, true).format(this.data.time.format);
            }
        },
        closePicker: function closePicker() {
            __WEBPACK_IMPORTED_MODULE_5__services_EventBus__["a" /* EventBus */].$emit('root-click');
        }
    },
    components: {
        InputText: __WEBPACK_IMPORTED_MODULE_0__components_ext_input_text_input_text_vue__["a" /* default */],
        Datepicker: __WEBPACK_IMPORTED_MODULE_1__components_ext_datepicker_datepicker_vue__["a" /* default */],
        Dropdown: __WEBPACK_IMPORTED_MODULE_2__components_ext_dropdown_dropdown_vue__["a" /* default */],
        'v-button': __WEBPACK_IMPORTED_MODULE_3__components_ext_button_button_vue__["a" /* default */]
    }
});

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_input_text_js__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_345db394_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_input_text_vue__ = __webpack_require__(658);
function injectStyle (ssrContext) {
  __webpack_require__(650)
}
var normalizeComponent = __webpack_require__(3)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-345db394"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_input_text_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_345db394_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_input_text_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 650 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ext_the_mask_the_mask_vue__ = __webpack_require__(652);


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'text-input',
    data: function data() {
        return {
            focused: false
        };
    },

    props: {
        name: {
            type: String,
            required: true
        },
        value: {
            type: [String, Number]
        },
        type: {
            type: String,
            default: 'text'
        },
        placeholder: {
            type: [String, Number],
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        error: {
            default: null
        },
        mask: {
            type: String,
            default: ''
        },
        masked: {
            type: Boolean,
            default: false
        },
        errorText: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        input: function input(a, b, c) {
            console.log(a, b, c);
        }
    },
    components: {
        TheMask: __WEBPACK_IMPORTED_MODULE_0__components_ext_the_mask_the_mask_vue__["a" /* default */]
    }
});

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_the_mask_vue__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cac996e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_the_mask_vue__ = __webpack_require__(657);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_the_mask_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cac996e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_the_mask_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directive__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tokens__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tokens___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__tokens__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__masker__ = __webpack_require__(315);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'TheMask',
    directives: { mask: __WEBPACK_IMPORTED_MODULE_0__directive__["a" /* default */] },
    props: {
        value: {
            type: [String, Number],
            default: null
        },
        mask: {
            type: [String, Array],
            required: true
        },
        masked: {
            type: Boolean,
            default: false
        },
        tokens: {
            type: Object,
            default: function _default() {
                return __WEBPACK_IMPORTED_MODULE_1__tokens___default.a;
            }
        },
        disabled: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'text'
        },
        name: {
            type: String,
            required: true
        },
        placeholder: {
            type: String,
            default: ''
        }
    },
    data: function data() {
        return {
            lastValue: null, // avoid unecessary emit when has no change
            display: this.value
        };
    },

    computed: {
        config: function config() {
            return {
                mask: this.mask,
                tokens: this.tokens,
                masked: this.masked
            };
        }
    },
    watch: {
        value: function value(newValue) {
            if (newValue !== this.lastValue) {
                this.display = newValue;
            }
        },
        masked: function masked() {
            this.refresh(this.display);
        }
    },
    methods: {
        onInput: function onInput(e) {
            if (e.isTrusted) return; // ignore native event
            this.refresh(e.target.value);
        },
        refresh: function refresh(value) {
            this.display = value;
            value = Object(__WEBPACK_IMPORTED_MODULE_2__masker__["a" /* default */])(value, this.mask, this.masked, this.tokens);

            if (value !== this.lastValue) {
                this.lastValue = value;
                this.$emit('input', value);
            }
        }
    }
});

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__masker__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tokens__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tokens___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__tokens__);



// https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Creating_and_triggering_events#The_old-fashioned_way
function event(name) {
    var evt = document.createEvent('Event');
    evt.initEvent(name, true, true);
    return evt;
}

/* harmony default export */ __webpack_exports__["a"] = (function (el, binding) {
    var config = binding.value;
    if (Array.isArray(config) || typeof config === 'string') {
        config = {
            mask: config,
            tokens: __WEBPACK_IMPORTED_MODULE_1__tokens___default.a
        };
    }

    if (el.tagName.toLocaleUpperCase() !== 'INPUT') {
        var els = el.getElementsByTagName('input');
        if (els.length !== 1) {
            throw new Error('v-mask directive requires 1 input, found ' + els.length);
        } else {
            el = els[0];
        }
    }

    el.oninput = function (evt) {
        if (!evt.isTrusted) return; // avoid infinite loop
        /* other properties to try to diferentiate InputEvent of Event (custom)
        InputEvent (native)
        cancelable: false
        isTrusted: true
        composed: true
        isComposing: false
        which: 0
        Event (custom)
        cancelable: true
        isTrusted: false
        */
        // by default, keep cursor at same position as before the mask
        var position = el.selectionEnd;
        // save the character just inserted
        var digit = el.value[position - 1];
        el.value = Object(__WEBPACK_IMPORTED_MODULE_0__masker__["a" /* default */])(el.value, config.mask, true, config.tokens);
        // if the digit was changed, increment position until find the digit again
        if (position !== 0) {
            while (position < el.value.length && el.value.charAt(position - 1) !== digit) {
                position++;
            }
        }
        if (el === document.activeElement) {
            el.setSelectionRange(position, position);
            setTimeout(function () {
                el.setSelectionRange(position, position);
            }, 0);
        }
        el.dispatchEvent(event('input'));
    };

    var newDisplay = Object(__WEBPACK_IMPORTED_MODULE_0__masker__["a" /* default */])(el.value, config.mask, true, config.tokens);
    if (newDisplay !== el.value) {
        el.value = newDisplay;
        el.dispatchEvent(event('input'));
    }
});

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = maskit;
/* eslint-disable */

function maskit(value, mask) {
    var masked = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var tokens = arguments[3];

    value = value || '';
    mask = mask || '';
    var iMask = 0;
    var iValue = 0;
    var output = '';

    while (iMask < mask.length && iValue < value.length) {
        var cMask = mask[iMask];
        var masker = tokens[cMask];
        var cValue = value[iValue];
        if (masker && !masker.escape) {
            if (masker.pattern.test(cValue)) {
                output += masker.transform ? masker.transform(cValue) : cValue;
                iMask++;
            }
            iValue++;
        } else {
            if (masker && masker.escape) {
                iMask++; // take the next mask char and treat it as char
                cMask = mask[iMask];
            }
            if (masked) output += cMask;
            if (cValue === cMask) iValue++; // user typed the same char
            iMask++;
        }
    }

    // fix mask that ends with a char: (#)
    var restOutput = '';
    while (iMask < mask.length && masked) {
        var _cMask = mask[iMask];
        if (tokens[_cMask]) {
            restOutput = '';
            break;
        }
        restOutput += _cMask;
        iMask++;
    }

    return output + restOutput;
}

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dynamicMask;
function dynamicMask(maskit, masks, tokens) {
    masks = masks.sort(function (a, b) {
        return a.length - b.length;
    });
    return function (value, mask) {
        var masked = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

        var i = 0;
        while (i < masks.length) {
            var currentMask = masks[i];
            i++;
            var nextMask = masks[i];
            if (!(nextMask && maskit(value, nextMask, true, tokens).length > currentMask.length)) {
                return maskit(value, currentMask, masked, tokens);
            }
        }
        return ''; // empty masks
    };
}

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.config),expression:"config"}],attrs:{"name":_vm.name,"type":_vm.type,"placeholder":_vm.placeholder,"readonly":_vm.disabled,"autocomplete":"off"},domProps:{"value":_vm.value},on:{"focus":function($event){_vm.$emit('focus')},"blur":function($event){_vm.$emit('blur')},"input":_vm.onInput}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-text",class:{ focused: _vm.focused, error: !!_vm.error && !_vm.focused }},[_c('div',{staticClass:"text-wrapper"},[(!_vm.mask)?_c('input',{ref:"input",attrs:{"name":_vm.name,"type":_vm.type,"placeholder":_vm.placeholder,"readonly":_vm.disabled,"autocomplete":"off"},domProps:{"value":_vm.value},on:{"focus":function($event){_vm.focused = true},"blur":function($event){_vm.focused = false},"input":function ($event) { _vm.$emit('input', $event.target.value) }}}):_vm._e(),_vm._v(" "),(_vm.mask)?_c('the-mask',{attrs:{"value":_vm.value,"name":_vm.name,"type":_vm.type,"placeholder":_vm.placeholder,"disabled":_vm.disabled,"mask":_vm.mask,"masked":_vm.masked},on:{"focus":function($event){_vm.focused = true},"blur":function($event){_vm.focused = false},"input":function (value) { _vm.$emit('input', value) }}}):_vm._e(),_vm._v(" "),(_vm.error && !_vm.focused && _vm.errorText)?_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_datepicker_js__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0356fad8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_datepicker_vue__ = __webpack_require__(662);
function injectStyle (ssrContext) {
  __webpack_require__(660)
}
var normalizeComponent = __webpack_require__(3)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0356fad8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_datepicker_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0356fad8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_datepicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 660 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_moment__);


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'datepicker',
    props: {
        value: {},
        format: {
            type: String,
            default: 'YYYY-MM-DD'
        },
        lang: {
            type: String,
            default: 'en'
        }
    },
    data: function data() {
        return {
            days: {
                en: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
                ru: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс']
            },
            today: null,
            month: null
        };
    },

    watch: {
        value: {
            immediate: true,
            handler: function handler(value) {
                this.today = __WEBPACK_IMPORTED_MODULE_0_moment_moment___default()().startOf('day');

                if (__WEBPACK_IMPORTED_MODULE_0_moment_moment___default()(value, this.format, true).isValid()) {
                    this.month = __WEBPACK_IMPORTED_MODULE_0_moment_moment___default()(value, this.format, true).startOf('month').format();
                } else {
                    this.month = __WEBPACK_IMPORTED_MODULE_0_moment_moment___default()().startOf('month').format();
                }
            }
        }
    },
    computed: {
        grid: function grid() {
            __WEBPACK_IMPORTED_MODULE_0_moment_moment___default.a.locale(this.lang);

            var month = [];
            var week = [];
            var date = __WEBPACK_IMPORTED_MODULE_0_moment_moment___default()(this.month);
            var daysInMonth = date.daysInMonth();
            var dayIndex = date.weekday();
            var count = daysInMonth + dayIndex;

            if (count % 7 > 0) {
                count += 7 - count % 7;
            }

            date = date.subtract(dayIndex, 'days');

            for (var i = 1; i <= count; i++) {
                week.push({
                    date: date.format(),
                    num: date.format('D'),
                    otherMonth: i < dayIndex + 1 || i >= daysInMonth + dayIndex + 1,
                    selected: date.isSame(__WEBPACK_IMPORTED_MODULE_0_moment_moment___default()(this.value, this.format)),
                    today: this.today.isSame(date)
                });

                if (i % 7 === 0) {
                    month.push(week);
                    week = [];
                }

                date.add(1, 'days');
            }

            return month;
        }
    },
    methods: {
        prevMonth: function prevMonth() {
            this.month = __WEBPACK_IMPORTED_MODULE_0_moment_moment___default()(this.month).subtract(1, 'months').format();
        },
        nextMonth: function nextMonth() {
            this.month = __WEBPACK_IMPORTED_MODULE_0_moment_moment___default()(this.month).add(1, 'months').format();
        },
        select: function select(day) {
            this.$emit('input', __WEBPACK_IMPORTED_MODULE_0_moment_moment___default()(day.date).format(this.format));
        }
    }
});

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"datepicker"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"month-header"},[_c('div',{staticClass:"arrow arrow-left",on:{"click":_vm.prevMonth}},[_c('div',{staticClass:"icon"})]),_vm._v(" "),_c('span',{staticClass:"current-month"},[_vm._v(_vm._s(_vm._f("moment")(_vm.month,'MMMM YYYY')))]),_vm._v(" "),_c('div',{staticClass:"arrow arrow-right",on:{"click":_vm.nextMonth}},[_c('div',{staticClass:"icon"})])]),_vm._v(" "),_c('div',{staticClass:"days-header"},_vm._l((_vm.days[_vm.lang]),function(day){return _c('div',{key:day,staticClass:"col"},[_vm._v(_vm._s(day))])}))]),_vm._v(" "),_c('div',{staticClass:"body"},_vm._l((_vm.grid),function(week,i){return _c('div',{key:i,staticClass:"row row-body"},_vm._l((week),function(day,j){return _c('div',{key:'day' + j,staticClass:"col",class:{ 'other-month': day.otherMonth, today: day.today, selected: day.selected },on:{"click":function($event){_vm.select(day)}}},[_c('div',{staticClass:"date"},[_vm._v(_vm._s(day.num))])])}))}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_dropdown_js__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc894970_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dropdown_vue__ = __webpack_require__(666);
function injectStyle (ssrContext) {
  __webpack_require__(664)
}
var normalizeComponent = __webpack_require__(3)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dc894970"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_dropdown_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc894970_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 664 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_EventBus__ = __webpack_require__(15);

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'dropdown',
    data: function data() {
        return {
            show: false
        };
    },

    props: {
        disabled: {
            type: Boolean,
            default: false
        }
    },
    created: function created() {
        __WEBPACK_IMPORTED_MODULE_0__services_EventBus__["a" /* EventBus */].$on('root-click', this.closeOther);
    },
    beforeDestroy: function beforeDestroy() {
        __WEBPACK_IMPORTED_MODULE_0__services_EventBus__["a" /* EventBus */].$off('root-click', this.closeOther);
    },

    watch: {
        show: function show() {
            this.$emit('change', this.show);
        }
    },
    methods: {
        toggle: function toggle() {
            if (!this.disabled) {
                this.show = !this.show;
            }
        },
        closeOther: function closeOther() {
            var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (this.$el !== el && !this.$el.contains(el)) {
                this.show = false;
            }
        }
    }
});

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown",class:{ opened: _vm.show }},[_c('div',{staticClass:"slot-toggle",on:{"click":function($event){$event.stopPropagation();_vm.toggle($event)}}},[_vm._t("toggle")],2),_vm._v(" "),_c('div',{staticClass:"slot-list",on:{"click":function($event){$event.stopPropagation();}}},[(_vm.show)?_vm._t("list"):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_button_js__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ba0c25e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_button_vue__ = __webpack_require__(670);
function injectStyle (ssrContext) {
  __webpack_require__(668)
}
var normalizeComponent = __webpack_require__(3)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ba0c25e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_button_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ba0c25e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 668 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'v-button',
    props: {
        type: {
            default: 'primary'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        submit: {
            default: false
        }
    },
    components: {}
});

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[_vm.type, { loading: _vm.loading }],attrs:{"type":_vm.submit ? 'submit' : 'button',"disabled":_vm.disabled},on:{"click":function($event){_vm.$emit('click')}}},[_c('div',{staticClass:"button-wrapper"},[_c('div',{staticClass:"bg-grad"}),_vm._v(" "),_c('span',{staticClass:"slot"},[_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"datetime"},[_c('div',{staticClass:"date"},[_c('dropdown',[_c('div',{staticClass:"dropdown-toggle",attrs:{"slot":"toggle"},slot:"toggle"},[_c('div',{staticClass:"datepicker-icon"},[_c('img',{attrs:{"src":"/static/images/ic-date.svg","alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"dropdown-list",attrs:{"slot":"list"},slot:"list"},[_c('datepicker',{attrs:{"format":_vm.data.date.format,"lang":_vm.lang},on:{"input":_vm.closePicker},model:{value:(_vm.control.date),callback:function ($$v) {_vm.$set(_vm.control, "date", $$v)},expression:"control.date"}})],1)]),_vm._v(" "),_c('input-text',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, regex: _vm.data.date.regex }),expression:"{ required: true, regex: data.date.regex }"}],attrs:{"name":_vm.name + '_date',"placeholder":"—.—.——","mask":"##.##.####","masked":true,"error":_vm.errors.first(_vm.name + '_date') || _vm.error},model:{value:(_vm.control.date),callback:function ($$v) {_vm.$set(_vm.control, "date", $$v)},expression:"control.date"}})],1),_vm._v(" "),_c('div',{staticClass:"time"},[_c('input-text',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, regex: _vm.data.time.regex }),expression:"{ required: true, regex: data.time.regex }"}],attrs:{"name":_vm.name + '_time',"placeholder":"—:—","mask":"##:##","masked":true,"error":_vm.errors.first(_vm.name + '_time') || _vm.error},model:{value:(_vm.control.time),callback:function ($$v) {_vm.$set(_vm.control, "time", $$v)},expression:"control.time"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timeInterval"},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.$t('VIDEO_EXPORT_PERIOD')))]),_vm._v(" "),_c('div',{staticClass:"interval"},[_c('Datetime',{attrs:{"name":'start_date',"lang":_vm.lang,"format":_vm.format,"error":_vm.errorDifferent},on:{"error":_vm.getError},model:{value:(_vm.start_date),callback:function ($$v) {_vm.start_date=$$v},expression:"start_date"}}),_vm._v(" "),_c('span',{staticClass:"separator"},[_vm._v("-")]),_vm._v(" "),_c('Datetime',{attrs:{"name":'end_date',"lang":_vm.lang,"format":_vm.format,"error":_vm.errorDifferent},on:{"error":_vm.getError},model:{value:(_vm.end_date),callback:function ($$v) {_vm.end_date=$$v},expression:"end_date"}})],1),_vm._v(" "),_c('div',{staticClass:"btns"},[_c('div',{staticClass:"btn btn-secondary",on:{"click":function($event){_vm.$emit('toggleExport')}}},[_c('span',[_vm._v(_vm._s(_vm.$t('Cancel')))])]),_vm._v(" "),_c('div',{staticClass:"btn btn-secondary",class:{'disable': _vm.error || _vm.errorDifferent},on:{"click":function($event){_vm.saveVideo()}}},[_c('span',[_vm._v(_vm._s(_vm.$t('Download')))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs",class:{ updating: _vm.updating, full: _vm.full }},[(_vm.updating)?_c('loader',{attrs:{"type":"small"}}):_vm._e(),_vm._v(" "),_c('div',{ref:"list",staticClass:"list"},[_vm._l((_vm.list.tabs),function(tab){return _c('div',{key:'view' + tab.id,staticClass:"tab",class:{ active: _vm.activeView && _vm.activeView.id == tab.id, opened: tab.menu }},[_c('div',{staticClass:"btn-tab",on:{"click":function($event){_vm.select(tab)}}},[_c('div',{staticClass:"inner"},[_c('div',{staticClass:"name",attrs:{"title":_vm.$t(tab.name)}},[_vm._v(_vm._s(_vm._f("contraction")(_vm.$t(tab.name))))])]),_vm._v(" "),(tab.temp ? _vm.activeView && _vm.activeView.id == tab.id : true)?_c('dropdown',{staticClass:"dropdown-menu",attrs:{"show":tab.menu}},[_c('div',{staticClass:"icon-edit",attrs:{"slot":"toggle"},slot:"toggle"},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')]),_vm._v(" "),_c('div',{staticClass:"tab-list",attrs:{"slot":"list"},slot:"list"},[(tab.changed && _vm.activeView && _vm.activeView.id == tab.id)?_c('div',{staticClass:"item",on:{"click":function($event){_vm.reset(tab)}}},[_vm._v("\n                            "+_vm._s(_vm.$t('Undo сhanges'))+"\n                        ")]):_vm._e(),_vm._v(" "),(tab.temp && tab.cams.length && _vm.activeView && _vm.activeView.id == tab.id)?_c('div',{staticClass:"item",on:{"click":_vm.removeCamsFromView}},[_vm._v("\n                            "+_vm._s(_vm.$t('Clear View'))+"\n                        ")]):_vm._e(),_vm._v(" "),(!tab.temp && tab.changed && _vm.activeView && _vm.activeView.id == tab.id)?_c('div',{staticClass:"item",on:{"click":function($event){_vm.save(tab)}}},[_vm._v("\n                            "+_vm._s(_vm.$t('Save'))+"\n                        ")]):_vm._e(),_vm._v(" "),(tab.temp ? tab.changed && _vm.activeView && _vm.activeView.id == tab.id : true)?_c('div',{staticClass:"item",on:{"click":function($event){tab.temp ? _vm.edit(tab) : _vm.edit(tab, true)}}},[_vm._v("\n                            "+_vm._s(_vm.$t('Save as'))+"\n                        ")]):_vm._e(),_vm._v(" "),(!tab.temp)?_c('div',{staticClass:"item",on:{"click":function($event){_vm.removing = tab}}},[_vm._v("\n                            "+_vm._s(_vm.$t('Delete view'))+"\n                        ")]):_vm._e(),_vm._v(" "),(!tab.temp)?_c('div',{staticClass:"item",on:{"click":function($event){_vm.edit(tab)}}},[_vm._v("\n                            "+_vm._s(_vm.$t('Rename'))+"\n                        ")]):_vm._e(),_vm._v(" "),(_vm.archCnvEnabled && _vm.activeView && _vm.activeView.id == tab.id)?_c('div',{staticClass:"item",on:{"click":function($event){_vm.toggleExport()}}},[_vm._v("\n                            "+_vm._s(_vm.$t('Download all'))+"\n                        ")]):_vm._e()])]):_vm._e()],1)])}),_vm._v(" "),(_vm.more)?_c('dropdown',{staticClass:"dropdown-more"},[_c('div',{staticClass:"icon-more",attrs:{"slot":"toggle"},slot:"toggle"},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')]),_vm._v(" "),_c('div',{staticClass:"more-list",attrs:{"slot":"list"},slot:"list"},_vm._l((_vm.list.dropdown),function(tab){return _c('div',{staticClass:"item",class:{ active: _vm.activeView && _vm.activeView.id == tab.id, opened: tab.menu },on:{"click":function($event){_vm.select(tab)}}},[_c('div',{staticClass:"name",attrs:{"title":tab.name}},[_vm._v(_vm._s(_vm._f("contraction")(tab.name)))]),_vm._v(" "),(tab.changed && !tab.temp)?_c('div',{staticClass:"btn-save",class:{ empty: ! tab.cams.length },attrs:{"title":'Reset'},on:{"click":function($event){$event.stopPropagation();_vm.reset(tab)}}},[_c('span',{staticClass:"icon-reset"})]):_vm._e(),_vm._v(" "),(tab.changed)?_c('div',{staticClass:"btn-save",class:{ empty: ! tab.cams.length },attrs:{"title":'Save'},on:{"click":function($event){$event.stopPropagation();tab.temp ? _vm.edit(tab) : _vm.save(tab)}}},[_c('span',{staticClass:"icon-save"})]):_vm._e(),_vm._v(" "),( ! tab.temp)?_c('dropdown',{staticClass:"dropdown-menu",attrs:{"show":tab.menu,"closeOther":false}},[_c('div',{staticClass:"icon-edit",attrs:{"slot":"toggle"},slot:"toggle"},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')]),_vm._v(" "),_c('div',{staticClass:"tab-list",attrs:{"slot":"list"},slot:"list"},[(_vm.activeView && _vm.activeView.id == tab.id)?_c('div',{staticClass:"item",on:{"click":function($event){_vm.toggleExport()}}},[_vm._v(_vm._s(_vm.$t('Save')))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"item",on:{"click":function($event){_vm.removing = tab}}},[_vm._v(_vm._s(_vm.$t('Delete view')))]),_vm._v(" "),_c('div',{staticClass:"item",on:{"click":function($event){_vm.edit(tab)}}},[_vm._v(_vm._s(_vm.$t('Rename')))])])]):_vm._e()],1)}))]):_vm._e()],2),_vm._v(" "),_c('modal',{attrs:{"show":!! _vm.saving}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('Save view')))]),_vm._v(" "),_c('div',{staticClass:"fields"},[_c('div',{staticClass:"field"},[_c('input-text',{directives:[{name:"validate",rawName:"v-validate.initial",value:(_vm.form.name.validator),expression:"form.name.validator",modifiers:{"initial":true}}],ref:"form-name",attrs:{"value":_vm.form.name.value,"name":_vm.form.name.name,"type":"text","placeholder":_vm.$t(_vm.form.name.placeholder),"hasError":_vm.errors.has(_vm.form.name.name)},on:{"update:value":function($event){_vm.$set(_vm.form.name, "value", $event)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"btns padding"},[_c('div',{staticClass:"btn btn-secondary",on:{"click":function($event){_vm.form.name.value = null; _vm.saving = false}}},[_c('span',[_vm._v(_vm._s(_vm.$t('Cancel')))])]),_vm._v(" "),_c('div',{staticClass:"btn",class:{ disabled: _vm.errors.count() },on:{"click":function($event){_vm.save(_vm.saving)}}},[_c('span',[_vm._v(_vm._s(_vm.$t('Save')))])])])]),_vm._v(" "),_c('modal',{attrs:{"show":!! _vm.removing}},[_c('div',{staticClass:"title small"},[_vm._v(_vm._s(_vm.$t('Are you sure you want to delete view?')))]),_vm._v(" "),_c('div',{staticClass:"btns"},[_c('div',{staticClass:"btn btn-secondary",on:{"click":function($event){_vm.removing = false}}},[_c('span',[_vm._v(_vm._s(_vm.$t('Cancel')))])]),_vm._v(" "),_c('div',{staticClass:"btn btn-removing",on:{"click":function($event){_vm.remove(_vm.removing)}}},[_c('span',[_vm._v(_vm._s(_vm.$t('Remove')))])])])]),_vm._v(" "),_c('modal',{staticClass:"forgot",attrs:{"show":_vm.limit}},[_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.$t('You can not create more than 10 views')))]),_vm._v(" "),_c('div',{staticClass:"btns padding single"},[_c('div',{staticClass:"btn",on:{"click":function($event){_vm.limit = false}}},[_c('span',[_vm._v("OK")])])])]),_vm._v(" "),_c('modal',{staticClass:"saveVideo",attrs:{"show":_vm.isShowDownload}},[_c('timeInterval',{attrs:{"camera_id":_vm.camera_id},on:{"toggleExport":function($event){_vm.toggleExport()}}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 674 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_perfect_scrollbar__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_perfect_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_cam_Cam_vue__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_sidebar_Sidebar_vue__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_datepicker_Datepicker_vue__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_dropdown_Dropdown_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_loader_Loader_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_player_Player_vue__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_search_Search_vue__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_EventBus__ = __webpack_require__(15);

















/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Alarms',
    data: function data() {
        return {
            loading: false,
            groups: {
                views: {
                    name: 'Views',
                    open: false
                },
                cams: {
                    name: 'Cameras',
                    placeholder: 'Find cameras',
                    search: '',
                    open: true
                }
            },
            filters: {
                open: true
            },
            datepicker: {
                open: false,
                start: __WEBPACK_IMPORTED_MODULE_6_moment___default()().startOf('day').format(),
                stop: __WEBPACK_IMPORTED_MODULE_6_moment___default()().endOf('day').format()
            },
            searchAlarms: {
                placeholder: 'Find alarms',
                value: ''
            },
            max_count: 10,
            prevRoute: null
        };
    },
    created: function created() {
        this.getAlarms();
    },
    mounted: function mounted() {
        this.updateScroll(this.$refs.filtersScroll);
    },
    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        next(function (vm) {
            vm.prevRoute = from;
        });
    },

    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
        cams: 'getCams',
        views: 'getAlarmViews',
        activeView: 'getAlarmsActiveView',
        list: 'getAlarms'
    }), {
        activeAlarm: function activeAlarm() {
            var _this = this;

            return this.list.find(function (item) {
                return item.id === _this.$route.params.alarmId;
            }) || null;
        },
        selectedCamsIds: function selectedCamsIds() {
            var camsIds = [];
            var queryCams = this.$route.query.cams ? this.$route.query.cams.split(',') : [];

            if (queryCams.length) {
                camsIds = queryCams;
            } else if (this.activeView) {
                this.groups.views.open = true;
                camsIds = this.activeView.cams;
            }

            return camsIds;
        },
        alarms: function alarms() {
            var _this2 = this;

            var camsIds = this.selectedCamsIds.length ? this.selectedCamsIds : this.cams.map(function (cam) {
                return cam.id;
            });

            var result = this.list.filter(function (item) {
                return camsIds.indexOf(item.camId) > -1 && item.name.toLowerCase().indexOf(_this2.searchAlarms.value.toLowerCase().trim()) !== -1;
            });

            result = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.groupBy(result, function (item) {
                return __WEBPACK_IMPORTED_MODULE_6_moment___default.a.unix(item.timestamp).startOf('day').format();
            });

            return result;
        },
        filteredCams: function filteredCams() {
            var _this3 = this;

            return this.cams.filter(function (item) {
                return item.name.toLowerCase().indexOf(_this3.groups.cams.search.toLowerCase()) > -1;
            });
        },
        isEmpty: function isEmpty() {
            return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(this.alarms);
        },
        playerData: function playerData() {
            return {
                mode: 1,
                layout: 1,
                camera_list: this.activeAlarm ? [this.activeAlarm.camId] : [],
                time: this.activeAlarm ? this.activeAlarm.time : null
            };
        }
    }),
    watch: {
        filteredCams: function filteredCams() {
            this.updateScroll(this.$refs.filtersScroll);
        },
        views: function views() {
            this.updateScroll(this.$refs.filtersScroll);
        },
        alarms: function alarms() {
            this.updateScroll(this.$refs.alarmsScroll);
        },
        $route: function $route(to, from) {
            this.$nextTick(function () {
                __WEBPACK_IMPORTED_MODULE_15__services_EventBus__["a" /* EventBus */].$emit('views:select');
            });
        }
    },
    methods: {
        selectDate: function selectDate(date) {
            this.datepicker.start = date.start;
            this.datepicker.stop = date.end;
            this.getAlarms();
            this.datepicker.open = false;
        },
        toggleGroup: function toggleGroup(type) {
            this.groups[type].open = !this.groups[type].open;
            this.updateScroll(this.$refs.filtersScroll);
        },
        updateScroll: function updateScroll(ref) {
            if (ref) {
                this.$nextTick(function () {
                    ref.update();
                });
            }
        },
        getComment: function getComment(alarm) {
            if (alarm.comment) return alarm.comment;

            if (alarm.description) return alarm.description;

            return __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].i18n.translate('EVENT_' + alarm.action);
        },
        getAlarms: function getAlarms() {
            var _this4 = this;

            this.loading = true;

            setTimeout(function () {
                _this4.$store.dispatch('getAlarms', {
                    cams: _this4.cams,
                    params: {
                        start_time: _this4.datepicker.start,
                        stop_time: _this4.datepicker.stop,
                        max_count: 30
                    }
                }).then(function (alarms) {
                    _this4.updateScroll(_this4.$refs.alarmsScroll);
                    _this4.loading = false;
                });
            }, 500);
        },
        toggle: function toggle(id) {
            var ids = [];
            var query = null;

            if (this.activeView) {
                ids = [id];
                query = { cams: ids.join(',') };
            } else {
                ids = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.selectedCamsIds));

                if (ids.indexOf(id) > -1) {
                    ids = ids.filter(function (item) {
                        return item != id;
                    });
                } else {
                    ids.push(id);
                }

                query = ids.length ? { cams: ids.join(',') } : null;
            }

            this.$router.replace({ name: 'alarms', query: query });
        },
        toggleAlarm: function toggleAlarm(alarm) {
            var query = {
                cams: this.$route.query.cams,
                view: this.$route.query.view
            };

            this.$store.commit('setMode', 1);

            var route = {
                name: 'alarms',
                params: { alarmId: this.$route.params.alarmId === alarm.id ? null : alarm.id },
                query: query
            };

            this.$router.replace(route);
        },
        goBack: function goBack() {
            var paramsRoute = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$route.params);
            if (paramsRoute.length) {
                this.$router.push(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.$route, { params: {} }));
            } else if (this.prevRoute) {
                this.$router.push(this.prevRoute);
            } else {
                this.$router.push('/');
            }
        }
    },
    components: {
        Cam: __WEBPACK_IMPORTED_MODULE_8__components_cam_Cam_vue__["a" /* default */],
        Datepicker: __WEBPACK_IMPORTED_MODULE_10__components_datepicker_Datepicker_vue__["a" /* default */],
        Sidebar: __WEBPACK_IMPORTED_MODULE_9__components_sidebar_Sidebar_vue__["a" /* default */],
        VuePerfectScrollbar: __WEBPACK_IMPORTED_MODULE_7_vue_perfect_scrollbar___default.a,
        Dropdown: __WEBPACK_IMPORTED_MODULE_11__components_dropdown_Dropdown_vue__["a" /* default */],
        Loader: __WEBPACK_IMPORTED_MODULE_12__components_loader_Loader_vue__["a" /* default */],
        Player: __WEBPACK_IMPORTED_MODULE_13__components_player_Player_vue__["a" /* default */],
        Search: __WEBPACK_IMPORTED_MODULE_14__components_search_Search_vue__["a" /* default */]
    }
});

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_datepicker_js__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c54852e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Datepicker_vue__ = __webpack_require__(679);
function injectStyle (ssrContext) {
  __webpack_require__(677)
}
var normalizeComponent = __webpack_require__(3)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c54852e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_datepicker_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c54852e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Datepicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 677 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'datepicker',
    props: {
        dateStart: {
            type: String
        },
        dateEnd: {
            type: String
        },
        lang: {
            type: String,
            default: 'en'
        }
    },
    data: function data() {
        return {
            days: {
                en: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
                ru: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс']
            },
            today: __WEBPACK_IMPORTED_MODULE_0_moment___default()().startOf('day'),
            selectedMonth: __WEBPACK_IMPORTED_MODULE_0_moment___default()().startOf('month').format(),
            selectedDateStart: this.dateStart,
            selectedDateEnd: this.dateEnd
        };
    },

    computed: {
        month: function month() {
            __WEBPACK_IMPORTED_MODULE_0_moment___default.a.locale(this.lang);

            var month = [];
            var week = [];
            var date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.selectedMonth);
            var daysInMonth = date.daysInMonth();
            var dayIndex = date.weekday();
            var count = daysInMonth + dayIndex;

            if (count % 7 > 0) count += 7 - count % 7;

            date = date.subtract(dayIndex, 'days');

            for (var i = 1; i <= count; i++) {
                var otherMonth = i < dayIndex + 1 || i >= daysInMonth + dayIndex + 1;

                week.push({
                    date: date.format(),
                    num: date.format('D'),
                    disabled: otherMonth || date > __WEBPACK_IMPORTED_MODULE_0_moment___default()().endOf('day'),
                    otherMonth: otherMonth,
                    today: this.today.isSame(date),
                    limitDate: date.isSame(__WEBPACK_IMPORTED_MODULE_0_moment___default()(this.selectedDateStart)) || date.isSame(__WEBPACK_IMPORTED_MODULE_0_moment___default()(this.selectedDateEnd).startOf('day'))
                });

                if (i % 7 === 0) {
                    month.push(week);
                    week = [];
                }

                date.add(1, 'days');
            }

            return month;
        }
    },
    methods: {
        prevMonth: function prevMonth() {
            this.selectedMonth = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.selectedMonth).subtract(1, 'months').format();
        },
        nextMonth: function nextMonth() {
            this.selectedMonth = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.selectedMonth).add(1, 'months').format();
        },
        selectDate: function selectDate(day) {
            if (this.selectedDateStart && this.selectedDateEnd) {
                this.selectedDateStart = day.date;
                this.selectedDateEnd = null;
            } else if (!this.selectedDateEnd) {
                if (__WEBPACK_IMPORTED_MODULE_0_moment___default()(day.date) < __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.selectedDateStart)) {
                    this.selectedDateEnd = this.selectedDateStart;
                    this.selectedDateStart = day.date;
                } else this.selectedDateEnd = day.date;
            }
        },
        isSelected: function isSelected(date) {
            if (this.selectedDateStart && this.selectedDateEnd) {
                return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date) >= __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.selectedDateStart) && __WEBPACK_IMPORTED_MODULE_0_moment___default()(date) <= __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.selectedDateEnd);
            } else if (!this.selectedDateEnd) {
                return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).isSame(__WEBPACK_IMPORTED_MODULE_0_moment___default()(this.selectedDateStart));
            }
        },
        submit: function submit() {
            var end = this.selectedDateEnd ? __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.selectedDateEnd).endOf('day').format() : __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.selectedDateStart).endOf('day').format();
            this.$emit('select', { start: this.selectedDateStart, end: end });
        },
        cancel: function cancel() {
            this.$emit('cancel');
        }
    }
});

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"date-picker"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"month-header"},[_c('div',{staticClass:"arrow arrow-left",on:{"click":_vm.prevMonth}},[_c('div',{staticClass:"icon"})]),_vm._v(" "),_c('span',{staticClass:"current-month"},[_vm._v(_vm._s(_vm._f("moment")(_vm.selectedMonth,'MMMM YYYY')))]),_vm._v(" "),_c('div',{staticClass:"arrow arrow-right",on:{"click":_vm.nextMonth}},[_c('div',{staticClass:"icon"})])]),_vm._v(" "),_c('div',{staticClass:"days-header"},_vm._l((_vm.days[_vm.lang]),function(day){return _c('div',{staticClass:"col"},[_vm._v(_vm._s(day))])}))]),_vm._v(" "),_c('div',{staticClass:"body"},_vm._l((_vm.month),function(week,i){return _c('div',{key:i,staticClass:"row row-body"},_vm._l((week),function(day,j){return _c('div',{key:'day' + j,staticClass:"col",class:{ disabled: day.disabled, selected: _vm.isSelected(day.date), 'other-month': day.otherMonth, today: day.today, 'limit-date': day.limitDate },on:{"click":function($event){_vm.selectDate(day)}}},[_c('div',{staticClass:"date"},[_vm._v(_vm._s(day.num))])])}))})),_vm._v(" "),_c('div',{staticClass:"btns"},[_c('div',{staticClass:"btn-dropdown-list",on:{"click":function($event){_vm.cancel()}}},[_c('span',[_vm._v(_vm._s(_vm.$t('Cancel')))])]),_vm._v(" "),_c('div',{staticClass:"btn-dropdown-list",on:{"click":function($event){_vm.submit()}}},[_c('span',[_vm._v(_vm._s(_vm.$t('OK')))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alarms"},[_c('sidebar',{attrs:{"type":"left","open":_vm.filters.open},on:{"update:open":function($event){_vm.$set(_vm.filters, "open", $event)}}},[_c('div',{attrs:{"slot":"icon"},slot:"icon"},[_c('img',{attrs:{"src":"/static/images/ic-cam-default.svg"}})]),_vm._v(" "),_c('div',{staticClass:"slot-content",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"list-wrap"},[_c('VuePerfectScrollbar',{ref:"filtersScroll",staticClass:"scrollbar"},[_c('div',{staticClass:"s-content"},[_c('div',{staticClass:"filters"},[(_vm.views.length)?_c('div',{staticClass:"filter-group",class:{ opened: _vm.groups.views.open }},[_c('div',{staticClass:"sidebar-header"},[_c('div',{staticClass:"toggle",on:{"click":function($event){_vm.toggleGroup('views')}}},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.$t(_vm.groups.views.name)))]),_vm._v(" "),_c('div',{staticClass:"icon-arrow"})])]),_vm._v(" "),(_vm.groups.views.open)?_c('div',{staticClass:"list"},_vm._l((_vm.views),function(view){return _c('router-link',{key:'alarmview' + view.id,staticClass:"filter views",class:{ 'active': view.id == _vm.$route.query.view },attrs:{"to":{ name: 'alarms', query: { view: view.id } },"replace":""}},[_c('div',{staticClass:"name",attrs:{"title":view.name}},[_vm._v(_vm._s(_vm._f("contraction")(view.name)))])])})):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"filter-group",class:{ opened: _vm.groups.cams.open }},[_c('div',{staticClass:"sidebar-header"},[_c('div',{staticClass:"toggle",on:{"click":function($event){_vm.toggleGroup('cams')}}},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.$t(_vm.groups.cams.name)))]),_vm._v(" "),_c('div',{staticClass:"icon-arrow"})]),_vm._v(" "),(_vm.groups.cams.open)?_c('Search',{attrs:{"placeholder":_vm.$t(_vm.groups.cams.placeholder)},model:{value:(_vm.groups.cams.search),callback:function ($$v) {_vm.$set(_vm.groups.cams, "search", $$v)},expression:"groups.cams.search"}}):_vm._e()],1),_vm._v(" "),(_vm.groups.cams.open)?_c('div',{staticClass:"list"},_vm._l((_vm.filteredCams),function(cam){return _c('div',{key:'filter' + cam.id,staticClass:"filter cams",on:{"click":function($event){_vm.toggle(cam.id)}}},[_c('cam',{attrs:{"draggble":false,"cam":cam,"selected":_vm.$route.query.cams && _vm.$route.query.cams.split(',').indexOf(cam.id) > -1}})],1)})):_vm._e()])])])])],1)])]),_vm._v(" "),_c('div',{staticClass:"alarms-list"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"header-left"},[_c('div',{staticClass:"icon-back",on:{"click":_vm.goBack}}),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('Alarms')))])]),_vm._v(" "),_c('div',{staticClass:"header-right"},[_c('Search',{attrs:{"placeholder":_vm.$t(_vm.searchAlarms.placeholder)},model:{value:(_vm.searchAlarms.value),callback:function ($$v) {_vm.$set(_vm.searchAlarms, "value", $$v)},expression:"searchAlarms.value"}}),_vm._v(" "),_c('dropdown',{attrs:{"open":_vm.datepicker.open},on:{"update:open":function($event){_vm.$set(_vm.datepicker, "open", $event)}}},[_c('div',{staticClass:"datepicker",attrs:{"slot":"toggle"},slot:"toggle"},[_c('img',{attrs:{"src":"/static/images/ic-date.svg"}})]),_vm._v(" "),_c('div',{staticClass:"datepicker-list",attrs:{"slot":"list"},on:{"click":function($event){$event.stopPropagation();}},slot:"list"},[_c('datepicker',{attrs:{"dateStart":_vm.datepicker.start,"dateEnd":_vm.datepicker.stop,"lang":_vm.$store.state.i18n.locale},on:{"select":_vm.selectDate,"cancel":function($event){_vm.datepicker.open = false}}})],1)])],1)]),_vm._v(" "),_c('div',{staticClass:"list-wrap",class:{ empty: _vm.loading || _vm.isEmpty }},[(_vm.loading)?_c('loader',{attrs:{"type":"dark"}}):_vm._e(),_vm._v(" "),(! _vm.isEmpty && ! _vm.loading)?_c('VuePerfectScrollbar',{ref:"alarmsScroll",staticClass:"scrollbar",attrs:{"settings":{ minScrollbarLength: 50 }}},[_c('div',{staticClass:"s-content"},_vm._l((_vm.alarms),function(group,day){return _c('div',{key:day,staticClass:"group"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("moment")(day,'DD MMMM YYYY')))]),_vm._v(" "),_c('div',{staticClass:"day-list"},_vm._l((group),function(alarm,k){return _c('div',{key:'alarm' + k,staticClass:"alarm",class:{ active: _vm.activeAlarm && _vm.activeAlarm.id === alarm.id },on:{"click":function($event){_vm.toggleAlarm(alarm)}}},[_c('div',{staticClass:"info"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(alarm.name))]),_vm._v(" "),_c('div',{staticClass:"date"},[_vm._v(_vm._s(_vm._f("moment")(alarm.timestamp,'DD MMM YYYY HH:mm:ss')))])]),_vm._v(" "),_c('div',{staticClass:"comment"},[_vm._v(_vm._s(_vm.getComment(alarm)))])])}))])}))]):_vm._e(),_vm._v(" "),(_vm.isEmpty && ! _vm.loading)?_c('div',{staticClass:"empty"},[_c('div',{staticClass:"icon-no-alarms"}),_vm._v(" "),_c('div',{staticClass:"caption"},[_vm._v(_vm._s(_vm.$t('No alarms for this period')))])]):_vm._e()],1)]),_vm._v(" "),(!! _vm.activeAlarm)?_c('player',{attrs:{"data":_vm.playerData}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_userInfo_js__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df8ec02c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserInfo_vue__ = __webpack_require__(688);
function injectStyle (ssrContext) {
  __webpack_require__(682)
}
var normalizeComponent = __webpack_require__(3)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-df8ec02c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_userInfo_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df8ec02c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 682 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modal_Modal_vue__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_inputText_InputText_vue__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dropdown_Dropdown_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modalPage_ModalPage_vue__ = __webpack_require__(684);







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'user-info',
    inject: ['auth', 'localization'],
    data: function data() {
        return {
            form: {
                object: {
                    name: 'object',
                    validator: { required: true, uniqueObject: true },
                    placeholder: 'Object',
                    value: null
                }
            },
            editing: false,
            users: [],
            links: [{ name: 'About SecurOS', alias: 'about' }],
            lang: {
                active: this.$store.state.i18n.locale,
                modal: false,
                list: [{ name: 'en', title: 'EN' }, { name: 'ru', title: 'Рус' }]
            }
        };
    },
    created: function created() {
        var _this = this;

        var usersJson = localStorage.getItem('users');

        if (usersJson) {
            this.users = JSON.parse(usersJson).filter(function (user) {
                return user.remember === true;
            });
        }

        this.$validator.extend('uniqueObject', {
            getMessage: function getMessage(field) {
                return 'uniqueObject';
            },
            validate: function validate(value) {
                return !_this.users.some(function (item) {
                    return value == item.object;
                }) || value == _this.$store.state.user.object;
            }
        });
    },

    methods: {
        logout: function logout() {
            var _this2 = this;

            this.auth.logout().then(function () {
                _this2.$router.push({ name: 'auth' });
            });
        },
        edit: function edit() {
            var _this3 = this;

            this.form.object.value = this.$store.state.user.object;
            this.editing = true;

            __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].nextTick(function () {
                var input = _this3.$refs['form-object'];

                if (input) input.$emit('focus');
            });
        },
        save: function save() {
            var _this4 = this;

            var usersJson = localStorage.getItem('users');

            if (usersJson) {
                var users = JSON.parse(usersJson);
                var user = users.find(function (user) {
                    return user.login == _this4.$store.state.user.login;
                });

                if (user) {
                    user.object = this.form.object.value;
                    this.$store.commit('setUser', user);
                    localStorage.setItem('users', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(users));
                    this.editing = false;
                }
            }
        },
        changeLang: function changeLang() {
            this.localization.set(this.lang.active);
            this.lang.modal = false;
        }
    },
    components: {
        Modal: __WEBPACK_IMPORTED_MODULE_2__components_modal_Modal_vue__["a" /* default */],
        InputText: __WEBPACK_IMPORTED_MODULE_3__components_inputText_InputText_vue__["a" /* default */],
        Dropdown: __WEBPACK_IMPORTED_MODULE_4__components_dropdown_Dropdown_vue__["a" /* default */],
        ModalPage: __WEBPACK_IMPORTED_MODULE_5__components_modalPage_ModalPage_vue__["a" /* default */]
    }
});

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_modalPage_js__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7694ceea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalPage_vue__ = __webpack_require__(687);
function injectStyle (ssrContext) {
  __webpack_require__(685)
}
var normalizeComponent = __webpack_require__(3)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_modalPage_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7694ceea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 685 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_perfect_scrollbar__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_perfect_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_loader_Loader_vue__ = __webpack_require__(42);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'modal-page',
    data: function data() {
        return {
            content: '',
            loaded: false
        };
    },

    props: {
        name: {
            String: String,
            required: true
        },
        title: {
            type: String
        }
    },
    mounted: function mounted() {
        if (this.show) this.getPage();
    },

    components: {
        VuePerfectScrollbar: __WEBPACK_IMPORTED_MODULE_0_vue_perfect_scrollbar___default.a,
        Loader: __WEBPACK_IMPORTED_MODULE_1__components_loader_Loader_vue__["a" /* default */]
    },
    computed: {
        show: function show() {
            return this.$route.query.popup === this.name;
        }
    },
    watch: {
        show: function show(value) {
            this.loaded = false;

            if (value) {
                this.getPage();
            }
        }
    },
    methods: {
        getPage: function getPage() {
            var _this = this;

            setTimeout(function () {
                _this.$store.dispatch('getPage', _this.name + '_' + _this.$store.state.i18n.locale).then(function (content) {
                    _this.content = content;
                    _this.loaded = true;
                });
            }, 500);
        }
    }
});

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"modal-page"},[_c('div',[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('router-link',{staticClass:"close",attrs:{"to":{ query: null },"replace":""}})],1),_vm._v(" "),_c('div',{staticClass:"content"},[(! _vm.loaded)?_c('loader'):_vm._e(),_vm._v(" "),(_vm.loaded)?_c('VuePerfectScrollbar',{ref:"scroll",staticClass:"scrollbar"},[_c('div',{staticClass:"s-content",domProps:{"innerHTML":_vm._s(_vm.content)}})]):_vm._e()],1)])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-info"},[_c('dropdown',{attrs:{"type":"left"}},[_c('div',{staticClass:"current",attrs:{"slot":"toggle"},slot:"toggle"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.$store.state.user.object))]),_vm._v(" "),_c('div',{staticClass:"icon-arrow"}),_vm._v(" "),_c('div',{staticClass:"icon-edit",on:{"click":function($event){_vm.edit()}}})]),_vm._v(" "),_c('div',{staticClass:"dropdown-list",attrs:{"slot":"list"},slot:"list"},[_vm._l((_vm.links),function(link){return _c('router-link',{key:link.alias,staticClass:"item",attrs:{"to":{ query: { popup: link.alias } },"replace":""}},[_vm._v(_vm._s(_vm.$t(link.name)))])}),_vm._v(" "),_c('div',{staticClass:"item lang",on:{"click":function($event){_vm.lang.modal = true}}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('Change language')))]),_vm._v(" "),_c('div',{staticClass:"icon-lang",class:_vm.lang.active})]),_vm._v(" "),_c('div',{staticClass:"separator"}),_vm._v(" "),(_vm.$store.state.user)?_c('div',{staticClass:"item",on:{"click":function($event){_vm.logout()}}},[_vm._v(_vm._s(_vm.$t('Logout')))]):_vm._e()],2)]),_vm._v(" "),_c('modal',{attrs:{"show":_vm.editing}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('Save object')))]),_vm._v(" "),_c('div',{staticClass:"fields"},[_c('div',{staticClass:"field"},[_c('input-text',{directives:[{name:"validate",rawName:"v-validate.initial",value:(_vm.form.object.validator),expression:"form.object.validator",modifiers:{"initial":true}}],ref:"form-object",attrs:{"value":_vm.form.object.value,"name":_vm.form.object.name,"type":"text","placeholder":_vm.$t(_vm.form.object.placeholder),"hasError":_vm.errors.has(_vm.form.object.name)},on:{"update:value":function($event){_vm.$set(_vm.form.object, "value", $event)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"btns padding"},[_c('div',{staticClass:"btn btn-secondary",on:{"click":function($event){_vm.form.object.value = null; _vm.editing = false}}},[_c('span',[_vm._v(_vm._s(_vm.$t('Cancel')))])]),_vm._v(" "),_c('div',{staticClass:"btn",class:{ disabled: _vm.errors.count() },on:{"click":function($event){_vm.save()}}},[_c('span',[_vm._v(_vm._s(_vm.$t('Save')))])])])]),_vm._v(" "),_c('modal',{staticClass:"modal-lang",attrs:{"show":_vm.lang.modal}},[_c('div',{staticClass:"title small"},[_vm._v(_vm._s(_vm.$t('Select language')))]),_vm._v(" "),_c('div',{staticClass:"fields"},_vm._l((_vm.lang.list),function(l){return _c('div',{staticClass:"field"},[_c('div',{staticClass:"lang-item",on:{"click":function($event){_vm.lang.active = l.name}}},[_c('div',{staticClass:"icon-check",class:{ active: l.name === _vm.lang.active }}),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v(_vm._s(l.title))]),_vm._v(" "),_c('div',{staticClass:"icon-lang",class:l.name})])])})),_vm._v(" "),_c('div',{staticClass:"btns padding"},[_c('div',{staticClass:"btn",class:{ disabled: _vm.errors.count() },on:{"click":function($event){_vm.changeLang()}}},[_c('span',[_vm._v("OK")])])])]),_vm._v(" "),_vm._l((_vm.links),function(link){return _c('modal-page',{key:'modal' + link.alias,attrs:{"title":_vm.$t(link.name),"name":link.alias}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"user"},[_vm._m(0,false,false),_vm._v(" "),_c('user-info')],1),_vm._v(" "),_c('dropdown',{staticClass:"grid-dropdown",class:{ disabled: _vm.disableGrid },attrs:{"type":"left"}},[_c('div',{staticClass:"icon-grid",style:({
              'background-image': ("url(/static/images/grid/" + (_vm.activeGrid.icon) + ".svg)")
            }),attrs:{"slot":"toggle"},slot:"toggle"}),_vm._v(" "),_c('div',{staticClass:"grid-list",attrs:{"slot":"list"},slot:"list"},_vm._l((_vm.grids),function(item){return _c('div',{key:item.icon,staticClass:"item",class:{ active: _vm.$store.state.grid == item.value },on:{"click":function($event){_vm.setGrid(item)}}},[_c('img',{attrs:{"src":'/static/images/grid/' + item.icon + '.svg'}})])}))]),_vm._v(" "),_c('div',{staticClass:"views"},[_c('view-tabs')],1),_vm._v(" "),_c('div',{staticClass:"controls"},[_c('dropdown',{staticClass:"stream-role-dropdown"},[_c('div',{staticClass:"btn-control",attrs:{"slot":"toggle"},slot:"toggle"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t(_vm.videoStreams.find(function (s) { return s.value === _vm.stream; }).name)))])]),_vm._v(" "),_c('div',{staticClass:"stream-role-list",attrs:{"slot":"list"},slot:"list"},_vm._l((_vm.videoStreams),function(s,k){return _c('div',{key:k,staticClass:"stream-item",class:{
              selected: s.value === _vm.stream
            },on:{"click":function($event){_vm.onSelectStream(s)}}},[_vm._v("\n            "+_vm._s(_vm.$t(s.name))+"\n          ")])}))]),_vm._v(" "),_vm._l((_vm.modes),function(mode,k){return _c('div',{key:k,staticClass:"btn-control",class:[mode.alias, { active: _vm.$store.state.mode == mode.value }],on:{"click":function($event){_vm.setMode(mode.value)}}},[_c('span',{staticClass:"icon",class:'icon-' + mode.alias}),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t(mode.name)))])])}),_vm._v(" "),_c('dropdown',{staticClass:"alarms-dropdown",on:{"open":_vm.openAlarms}},[_c('div',{staticClass:"btn-control",class:{ active: _vm.$route.name === 'alarms'},attrs:{"slot":"toggle"},slot:"toggle"},[_c('span',{staticClass:"icon icon-alarms"}),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('Alarms')))])]),_vm._v(" "),_c('div',{staticClass:"alarms-list",attrs:{"slot":"list"},slot:"list"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('Alarms')))]),_vm._v(" "),(_vm.loading.alarms)?_c('loader',{attrs:{"type":"small"}}):_vm._e(),_vm._v(" "),( ! _vm.loading.alarms)?_c('div',{staticClass:"list-wrap"},_vm._l((_vm.latestAlarms),function(alarm,k){return _c('div',{key:'alarm' + k,staticClass:"alarm-item",on:{"click":function($event){_vm.goToAlarm(alarm)}}},[_c('div',{staticClass:"alarm-info"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(alarm.name))]),_vm._v(" "),_c('div',{staticClass:"date"},[_vm._v(_vm._s(_vm._f("moment")(alarm.timestamp,'DD MMM YYYY HH:mm:ss')))])]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v(_vm._s(_vm.getAlarmComment(alarm)))])])})):_vm._e(),_vm._v(" "),( ! _vm.loading.alarms)?_c('div',{staticClass:"btns"},[_c('div',{staticClass:"btn-dropdown-list",on:{"click":_vm.getAllAlarms}},[_c('span',[_vm._v(_vm._s(_vm.$t('View all')))])])]):_vm._e()],1)])],2)],1),_vm._v(" "),_c('div',{staticClass:"container"},[_c('sidebar',{attrs:{"type":"left","open":_vm.sidebars.cams.open,"show":_vm.sidebars.cams.show},on:{"update:open":function($event){_vm.$set(_vm.sidebars.cams, "open", $event)},"open":function($event){_vm.updateScroll(_vm.$refs.camsScroll)}}},[_c('div',{attrs:{"slot":"icon"},slot:"icon"},[_c('img',{attrs:{"src":"/static/images/ic-cam-default.svg"}})]),_vm._v(" "),_c('div',{staticClass:"slot-content",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"sidebar-header"},[_c('div',{staticClass:"cams-mode"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('Cameras')))])]),_vm._v(" "),_c('Search',{attrs:{"placeholder":_vm.$t('Find cameras')},model:{value:(_vm.sidebars.cams.search),callback:function ($$v) {_vm.$set(_vm.sidebars.cams, "search", $$v)},expression:"sidebars.cams.search"}})],1),_vm._v(" "),_c('div',{staticClass:"list-wrap cams-wrap"},[_c('VuePerfectScrollbar',{ref:"camsScroll",staticClass:"scrollbar"},[_c('div',{staticClass:"s-content"},[_c('ul',{staticClass:"cams-list",class:{ preview: _vm.sidebars.cams.modes.active == 'preview' }},_vm._l((_vm.camGroups),function(cam,k){return _c('li',{key:'drag-cam' + k},[(!Array.isArray(cam))?_c('drag',{attrs:{"transfer-data":{ camera_id: cam.id, connection_id: '' },"draggable":_vm.activeView != null},on:{"dragstart":_vm.onCamDrag}},[_c('cam',{attrs:{"draggable":_vm.activeView != null,"selected":_vm.isCamSelected(cam),"cam":cam,"preview":_vm.sidebars.cams.modes.active == 'preview'}})],1):_c('tree',{attrs:{"data":cam},scopedSlots:_vm._u([{key:"default",fn:function(ref){
            var model = ref.model;
return [(model.id)?_c('drag',{attrs:{"transfer-data":{ camera_id: model.id, connection_id: '' },"draggable":_vm.activeView != null},on:{"dragstart":_vm.onCamDrag}},[_c('cam',{attrs:{"draggable":_vm.activeView != null,"selected":_vm.isCamSelected(cam),"cam":model,"preview":_vm.sidebars.cams.modes.active == 'preview'}})],1):_vm._e()]}}])})],1)}))])])],1)])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('router-view')],1),_vm._v(" "),_c('sidebar',{attrs:{"type":"right","open":_vm.sidebars.maps.open},on:{"update:open":function($event){_vm.$set(_vm.sidebars.maps, "open", $event)},"open":function($event){_vm.updateScroll(_vm.$refs.mapsScroll)}}},[_c('div',{attrs:{"slot":"icon"},slot:"icon"},[_c('img',{attrs:{"src":"/static/images/ic-map.svg"}})]),_vm._v(" "),_c('div',{staticClass:"slot-content",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"sidebar-header"},[_c('div',{staticClass:"maps-mode"},[_c('div',{staticClass:"modes"},_vm._l((_vm.sidebars.maps.modes.list),function(mode){return _c('div',{key:mode.value,staticClass:"item",class:[mode.value, { active: _vm.sidebars.maps.modes.active == mode.value }],on:{"click":function($event){_vm.changeMapMode(mode.value)}}},[_c('div',{staticClass:"icon"}),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.$t(mode.name)))])])}))]),_vm._v(" "),_c('Search',{attrs:{"placeholder":_vm.$t('Find object')},model:{value:(_vm.sidebars.maps.search),callback:function ($$v) {_vm.$set(_vm.sidebars.maps, "search", $$v)},expression:"sidebars.maps.search"}})],1),_vm._v(" "),_c('div',{staticClass:"list-wrap map-wrap"},[_c('div',{staticClass:"list-block"},[_c('VuePerfectScrollbar',{ref:"mapsScroll",staticClass:"scrollbar",attrs:{"settings":{ suppressScrollX: true }}},[_c('div',{staticClass:"s-content"},[_c('tree',{attrs:{"data":_vm.mapData,"root":_vm.$route.params.mapGroupId,"value":_vm.$route.params.mapId,"search":_vm.sidebars.maps.search},on:{"select":_vm.setMap,"update":function () { return _vm.updateScroll(_vm.$refs.mapsScroll); }}})],1)])],1),_vm._v(" "),_c('div',{staticClass:"list-block"},[_c('div',{staticClass:"list-block__title"},[_vm._v(_vm._s(_vm.$t('Alarms')))]),_vm._v(" "),_c('VuePerfectScrollbar',{ref:"mapsAlarmScroll",staticClass:"scrollbar",attrs:{"settings":{ suppressScrollX: true }}},[_c('div',{staticClass:"s-content"},[_c('tree',{attrs:{"data":_vm.alarmMapData,"root":_vm.$route.params.mapGroupId,"value":_vm.$route.params.mapId,"notHierarchy":true},on:{"select":_vm.setMap,"update":function () { return _vm.updateScroll(_vm.$refs.mapsScroll); }}})],1)])],1)])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":"/static/images/logo-min.svg"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_auth_js__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1267fced_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Auth_vue__ = __webpack_require__(697);
function injectStyle (ssrContext) {
  __webpack_require__(691)
}
var normalizeComponent = __webpack_require__(3)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1267fced"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_auth_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1267fced_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Auth_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 691 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_loader_Loader_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dropdown_Dropdown_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_inputText_InputText_vue__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dropdownSelect_DropdownSelect_vue__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modal_Modal_vue__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_regex__ = __webpack_require__(696);







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Auth',
    inject: ['auth', 'localization'],
    data: function data() {
        return {
            mode: 'new',
            users: [],
            loading: false,
            authError: false,
            form: {
                object: {
                    control: 'input-text',
                    value: null,
                    placeholder: 'Object',
                    mode: 'new',
                    alias: 'object'
                },
                login: {
                    control: 'input-text',
                    value: null,
                    validator: { required: true, disableRoot: true },
                    placeholder: 'Login'
                },
                password: {
                    control: 'input-text',
                    type: 'password',
                    value: null,
                    validator: { required: true },
                    placeholder: 'Password'
                },
                remember: {
                    control: 'checkbox',
                    value: true,
                    trueValue: true,
                    falseValue: false,
                    label: 'Save credentials',
                    mode: 'new'
                }
            },
            forgot: {
                show: false
            },
            lang: {
                active: null,
                list: [{ name: 'en', title: 'EN' }, { name: 'ru', title: 'Рус' }]
            }
        };
    },
    created: function created() {
        var _this = this;

        var usersJson = localStorage.getItem('users');

        if (usersJson) {
            this.users = JSON.parse(usersJson);
        }

        if (this.users.length) {
            this.form.object.value = this.users[0].object;
            this.form.login.value = this.users[0].login;
        }

        this.lang.active = this.lang.list.find(function (item) {
            return item.name === _this.$store.state.i18n.locale;
        });

        this.$validator.extend('disableRoot', {
            getMessage: function getMessage(field) {
                return 'disableRoot';
            },
            validate: function validate(value) {
                return value.toLowerCase() !== 'root';
            }
        });
    },

    computed: {
        formData: function formData() {
            return {
                object: this.form.object.value,
                login: this.form.login.value,
                password: this.form.password.value,
                remember: this.form.remember.value
            };
        }
    },
    watch: {
        form: {
            handler: function handler(form) {
                var _this2 = this;

                this.errors.items.forEach(function (item) {
                    _this2.errors.removeById('backend');
                });
            },

            deep: true
        }
    },
    methods: {
        login: function login() {
            var _this3 = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    _this3.loading = true;

                    _this3.auth.login(_this3.formData).then(function () {
                        _this3.loading = false;
                        _this3.$router.push({ name: 'views', params: { viewId: 'main' } });
                    }, function (e) {
                        if (e.status === 400) {
                            _this3.errors.add({ field: 'password', msg: 'auth', id: 'backend' });
                        }

                        _this3.loading = false;
                    });
                }
            });
        }
    },
    components: {
        Loader: __WEBPACK_IMPORTED_MODULE_0__components_loader_Loader_vue__["a" /* default */],
        Dropdown: __WEBPACK_IMPORTED_MODULE_1__components_dropdown_Dropdown_vue__["a" /* default */],
        DropdownSelect: __WEBPACK_IMPORTED_MODULE_3__components_dropdownSelect_DropdownSelect_vue__["a" /* default */],
        InputText: __WEBPACK_IMPORTED_MODULE_2__components_inputText_InputText_vue__["a" /* default */],
        Modal: __WEBPACK_IMPORTED_MODULE_4__components_modal_Modal_vue__["a" /* default */]
    }
});

/***/ }),
/* 693 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dropdown_Dropdown_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_perfect_scrollbar__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_perfect_scrollbar__);




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'dropdown-select',
    data: function data() {
        return {
            open: false,
            scroll: false,
            container: document.body
        };
    },

    props: {
        list: {
            type: Array,
            default: []
        },
        value: {
            default: null
        },
        placeholder: String,
        name: String,
        max: {
            type: Number,
            default: 8
        },
        type: {
            type: String
        }
    },
    computed: {
        selected: function selected() {
            var _this = this;

            return this.list.find(function (item) {
                return item.value == _this.value;
            });
        }
    },
    methods: {
        select: function select(item) {
            this.open = false;
            this.$emit('update:value', item.value);
            this.$emit('change', item.value);
            this.$emit('input', item.value);
            this.$emit('blur');
        },
        openDropdown: function openDropdown() {
            var _this2 = this;

            var option = this.$refs.scroll.$el.getElementsByClassName('first')[0];
            var content = this.$refs.options;
            var wrap = this.$refs.wrap;

            if (option && content) {
                this.$nextTick(function () {
                    var itemHeight = option.clientHeight + _this2.getStyleValue(option, 'marginBottom') + _this2.getStyleValue(option, 'marginTop');
                    var maxHeight = itemHeight * _this2.max + _this2.getStyleValue(wrap, 'paddingBottom') + _this2.getStyleValue(wrap, 'paddingTop');
                    var height = _this2.list.length * itemHeight;
                    _this2.scroll = height > maxHeight;

                    content.style.height = _this2.scroll ? maxHeight + 'px' : 'auto';

                    _this2.$refs.scroll.update();
                    _this2.$emit('select:open');
                });
            }
        },
        getStyleValue: function getStyleValue(el, style) {
            return parseInt(window.getComputedStyle(el)[style]);
        }
    },
    components: {
        Dropdown: __WEBPACK_IMPORTED_MODULE_1__components_dropdown_Dropdown_vue__["a" /* default */],
        VuePerfectScrollbar: __WEBPACK_IMPORTED_MODULE_2_vue_perfect_scrollbar___default.a
    }
});

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dropdown',{staticClass:"dropdown-select",class:[_vm.type, { empty: ! _vm.selected, 'has-scroll': _vm.scroll }],attrs:{"type":"full","container":_vm.container,"isSelect":true},on:{"open":_vm.openDropdown}},[_c('div',{staticClass:"current",attrs:{"slot":"toggle"},slot:"toggle"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.placeholder))]),_vm._v(" "),(_vm.selected)?_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t(_vm.selected.name)))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"icon"})]),_vm._v(" "),_c('div',{ref:"options",staticClass:"options",attrs:{"slot":"list"},slot:"list"},[_c('VuePerfectScrollbar',{ref:"scroll",staticClass:"scrollbar",attrs:{"settings":{ minScrollbarLength: 30 }}},[_c('div',{ref:"wrap",staticClass:"s-content"},_vm._l((_vm.list),function(option,k){return _c('div',{staticClass:"option",class:{ active: option.value == _vm.value, first: k == 0  },on:{"click":function($event){_vm.select(option)}}},[_vm._v(_vm._s(_vm.$t(option.name)))])}))])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = ({
    login: '^[a-zA-Z0-9\s(\)\"\/\.\-]*$',
    password: '^[a-zA-Z0-9\s(\)\"\/\.\-]*$'
});

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth"},[_c('div',{staticClass:"wrapper"},[_vm._m(0,false,false),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.login($event)}}},[(_vm.lang.active)?_c('dropdown',{staticClass:"lang-dropdown"},[_c('div',{staticClass:"lang-toggle",attrs:{"slot":"toggle"},slot:"toggle"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.lang.active.title))]),_vm._v(" "),_c('span',{staticClass:"icon-lang",class:_vm.lang.active.name}),_vm._v(" "),_c('span',{staticClass:"icon-arrow"})]),_vm._v(" "),_c('div',{staticClass:"lang-list",attrs:{"slot":"list"},slot:"list"},_vm._l((_vm.lang.list),function(l){return _c('div',{staticClass:"item",on:{"click":function($event){_vm.lang.active = l; _vm.localization.set(l.name)}}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(l.title))]),_vm._v(" "),_c('div',{staticClass:"icon-lang",class:l.name})])}))]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:( ! _vm.loading),expression:" ! loading"}],staticClass:"auth-form"},[_c('div',{staticClass:"fields"},_vm._l((_vm.form),function(field,key){return (! field.mode || field.mode == _vm.mode)?_c('div',{key:field.name,staticClass:"field",class:'field-' + key},[(field.control == 'input-text')?_c('input-text',{directives:[{name:"validate",rawName:"v-validate.initial",value:(field.validator),expression:"field.validator",modifiers:{"initial":true}}],key:key,attrs:{"value":field.value,"data-vv-as":_vm.$t(field.placeholder),"name":key,"type":field.type ? field.type : 'text',"placeholder":_vm.$t(field.placeholder),"hasError":_vm.errors.has(key) && _vm.fields[key].dirty,"disabled":field.disabled},on:{"update:value":function($event){_vm.$set(field, "value", $event)}}}):_vm._e()],1):_vm._e()})),_vm._v(" "),(_vm.errors.count())?_c('div',{staticClass:"errors"},_vm._l((_vm.fields),function(field,key){return (_vm.errors.has(key) && field.dirty)?_c('div',{key:'error-' + key,staticClass:"error"},[_vm._v("\n            "+_vm._s(_vm.$t(_vm.errors.first(key)))+"\n          ")]):_vm._e()})):_vm._e(),_vm._v(" "),_c('div',{staticClass:"links"},[_c('div',{staticClass:"link",on:{"click":function($event){_vm.forgot.show = true}}},[_vm._v(_vm._s(_vm.$t('Forgot password?')))])]),_vm._v(" "),_c('div',{staticClass:"btns"},[_c('button',{staticClass:"btn",class:{ disabled: _vm.errors.count() },attrs:{"type":"submit","tabindex":"0"}},[_c('span',[_vm._v(_vm._s(_vm.$t('Enter')))])])])])],1),_vm._v(" "),(_vm.loading)?_c('loader'):_vm._e()],1),_vm._v(" "),_c('modal',{staticClass:"forgot",attrs:{"show":_vm.forgot.show}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('Forgot password?')))]),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.$t('Forgot password message')))]),_vm._v(" "),_c('div',{staticClass:"btns padding single"},[_c('div',{staticClass:"btn",on:{"click":function($event){_vm.forgot.show = false}}},[_c('span',[_vm._v("OK")])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":"/static/images/logo.svg"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cams_js__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e5672e5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cams_vue__ = __webpack_require__(701);
function injectStyle (ssrContext) {
  __webpack_require__(699)
}
var normalizeComponent = __webpack_require__(3)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e5672e5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cams_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e5672e5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cams_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 699 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_EventBus__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_player_Player_vue__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modal_Modal_vue__ = __webpack_require__(73);






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Cams',
    data: function data() {
        return {
            dragging: false,
            info: {
                show: false
            }
        };
    },
    created: function created() {
        __WEBPACK_IMPORTED_MODULE_2__services_EventBus__["a" /* EventBus */].$on('cam:dragstart', this.onDragstart);
        __WEBPACK_IMPORTED_MODULE_2__services_EventBus__["a" /* EventBus */].$on('cam:dragend', this.onDragend);
    },
    beforeDestroy: function beforeDestroy() {
        __WEBPACK_IMPORTED_MODULE_2__services_EventBus__["a" /* EventBus */].$off('cam:dragstart', this.onDragstart);
        __WEBPACK_IMPORTED_MODULE_2__services_EventBus__["a" /* EventBus */].$off('cam:dragend', this.onDragend);
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
        view: 'getActiveView',
        mode: 'getMode',
        map: 'getActiveMap',
        grid: 'getActiveGrid',
        allCams: 'getCams'
    }), {
        cams: function cams() {
            return this.view ? this.view.cams : [];
        },
        isMap: function isMap() {
            return this.$route.params.mapId && this.$route.params.mapGroupId;
        },
        playerData: function playerData() {
            return {
                mode: this.mode,
                layout: this.grid.value,
                camera_list: this.cams.map(function (cam) {
                    return cam.id;
                })
            };
        }
    }),
    methods: {
        add: function add(data) {
            this.$store.commit('addCamsIntoView', {
                camIds: [data.camera_id],
                viewId: this.view.id
            });
        },
        remove: function remove(cam) {
            this.$store.commit('removeCamFromView', {
                camId: cam,
                viewId: this.view.id
            });
        },
        onDragstart: function onDragstart() {
            this.dragging = true;
        },
        onDragend: function onDragend() {
            this.dragging = false;
        }
    },
    components: {
        Player: __WEBPACK_IMPORTED_MODULE_3__components_player_Player_vue__["a" /* default */],
        Modal: __WEBPACK_IMPORTED_MODULE_4__components_modal_Modal_vue__["a" /* default */]
    }
});

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('drop',{staticClass:"cams",class:{ empty: ! _vm.cams.length },on:{"drop":_vm.add}},[(_vm.cams.length)?_c('div',{staticClass:"wrap"},[_c('player',{attrs:{"data":_vm.playerData}})],1):_vm._e(),_vm._v(" "),( ! _vm.cams.length && ! _vm.isMap)?_c('div',{staticClass:"empty"},[_c('div',{staticClass:"icon-drop-cameras"}),_vm._v(" "),_c('div',{staticClass:"caption"},[_vm._v(_vm._s(_vm.$t('drop cams')))])]):_vm._e(),_vm._v(" "),( ! _vm.cams.length && _vm.isMap)?_c('div',{staticClass:"empty"},[_c('div',{staticClass:"icon-no-cameras"}),_vm._v(" "),_c('div',{staticClass:"caption"},[_vm._v(_vm._s(_vm.$t('No cameras')))])]):_vm._e(),_vm._v(" "),_c('modal',{staticClass:"forgot",attrs:{"show":_vm.info.show}},[_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.$t('max cameras error')))]),_vm._v(" "),_c('div',{staticClass:"btns padding single"},[_c('div',{staticClass:"btn",on:{"click":function($event){_vm.info.show = false}}},[_c('span',[_vm._v("OK")])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_map_js__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ae2052d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__ = __webpack_require__(713);
function injectStyle (ssrContext) {
  __webpack_require__(703)
}
var normalizeComponent = __webpack_require__(3)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1ae2052d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_map_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ae2052d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 703 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_EventBus__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_helper__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_loader_Loader_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_map_object_map_object_vue__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_dropdownSelect_DropdownSelect_vue__ = __webpack_require__(320);












/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Map',
    data: function data() {
        return {
            popup: {
                open: false
            },
            x: null,
            y: null,
            translate: {
                x: 0,
                y: 0
            },
            dragging: false,
            zoom: {
                active: 1,
                list: [{ name: '25%', value: 0.25 }, { name: '50%', value: 0.50 }, { name: '75%', value: 0.75 }, { name: '100%', value: 1 }, { name: '150%', value: 1.5 }, { name: '175%', value: 1.75 }, { name: '200%', value: 2 }, { name: '300%', value: 3 }, { name: '400%', value: 4 }, { name: '600%', value: 6 }, { name: '800%', value: 8 }],
                fit: { name: 'Fit into window', value: 'fit' }
            },
            loading: false,

            indicateAlarmsDur: 1000,
            isIndicateAlarms: true,
            isShowIndicateAlarms: true,
            indicateAlarmsTimeout: null,

            camIdFromCellDur: 500,
            camIdFromCellCountMax: 6,
            camIdFromCellCountShow: 0,
            camIdFromCellTimeout: null,
            isIndicateCamIdFromCell: true,
            limitWidthIcon: 20
        };
    },
    mounted: function mounted() {

        this.camIdFromCellTimeout = setTimeout(this.onCamIdFromCellTimeout, this.camIdFromCellDur);

        this.indicateAlarmsTimeout = setTimeout(this.onIndicateAlarmsTimeout, this.indicateAlarmsDur);

        __WEBPACK_IMPORTED_MODULE_6__services_EventBus__["a" /* EventBus */].$on('mouseup', this.mouseup);

        __WEBPACK_IMPORTED_MODULE_6__services_EventBus__["a" /* EventBus */].$on('mousemove', this.mousemove);
    },
    beforeDestroy: function beforeDestroy() {
        clearTimeout(this.indicateAlarmsTimeout);
        this.indicateAlarmsTimeout = null;

        clearTimeout(this.camIdFromCellTimeout);
        this.camIdFromCellTimeout = null;
        this.$store.commit('setCamIdFromCell', '');

        __WEBPACK_IMPORTED_MODULE_6__services_EventBus__["a" /* EventBus */].$off('mouseup', this.mouseup);
        __WEBPACK_IMPORTED_MODULE_6__services_EventBus__["a" /* EventBus */].$off('mousemove', this.mouseup);
    },

    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
        maps: 'getMaps',
        cams: 'getCams',
        alarmCams: 'getAlarmCams',
        activeMap: 'getActiveMap',
        grids: 'getGrids',
        camIdFromCell: 'getCamIdFromCell'
    }), {
        map: function map() {
            var _this = this;

            if (this.activeMap) {

                var activeMap = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.activeMap, {
                    cams: this.activeMap.cams.map(function (cam) {
                        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this.cams.find(function (c) {
                            return c.id == cam.id;
                        }), cam);
                    }).filter(function (cam) {
                        return !!cam.status;
                    })
                });
                return activeMap;
            }

            return null;
        },
        mapObjects: function mapObjects() {
            return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.map.cams), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.map.mapObjs));
        },
        isShowIndicateAlarmsControl: function isShowIndicateAlarmsControl() {
            var _this2 = this;

            return this.alarmCams.some(function (aCam) {
                return _this2.map.cams.some(function (mCam) {
                    return aCam.id === mCam.id;
                });
            });
        },
        zoomList: function zoomList() {
            return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.zoom.list), [this.zoom.fit]);
        },
        objsStyle: function objsStyle() {
            var _this3 = this;

            /**
             * в пикселях. Учитываем, что ширина равна высоте (круг)
             */
            var defaultWidth = 35;
            var minDistanceIcons = 5;
            var minDistanceCenter = defaultWidth + minDistanceIcons;

            var result = {};
            var mapWidth = this.map.width * this.zoom.active;
            var mapHeight = this.map.height * this.zoom.active;
            var mapObjs = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.map.cams), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.map.mapObjs));
            mapObjs.forEach(function (obj) {
                var addedObj = {
                    id: obj.id,
                    x: mapWidth / 100 * obj.x,
                    y: mapHeight / 100 * obj.y,
                    width: defaultWidth,
                    left: mapWidth / 100 * obj.x - defaultWidth / 2,
                    top: mapHeight / 100 * obj.y - defaultWidth / 2
                };
                var resultKey = obj.type === 'CAM' ? obj.id : obj.type + '_' + obj.id;
                result[resultKey] = addedObj;
            });
            var styleObjArr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(result);
            styleObjArr.forEach(function (styleCompare) {
                styleObjArr.forEach(function (styleObj) {
                    var distance = Math.sqrt(Math.pow(styleCompare.x - styleObj.x, 2) + Math.pow(styleCompare.y - styleObj.y, 2));
                    if (distance !== 0) {
                        var diffDistCenter = minDistanceCenter - distance;
                        if (diffDistCenter > 0) {
                            var maxWidthIcon = distance - minDistanceIcons;
                            if (maxWidthIcon < _this3.limitWidthIcon) {
                                maxWidthIcon = _this3.limitWidthIcon;
                            }
                            if (styleCompare.width > maxWidthIcon) {
                                styleCompare.width = maxWidthIcon;
                            }
                            if (styleObj.width > maxWidthIcon) {
                                styleObj.width = maxWidthIcon;
                            }
                        }
                    }
                });
            });
            return result;
        }
    }),
    watch: {
        'activeMap': {
            immediate: true,
            handler: function handler(map, prev) {
                var _this4 = this;

                var isSame = map && prev && map.id == prev.id && map.group.id == prev.group.id;

                if (!isSame) {
                    this.setDefaultZoom();

                    if (map && !this.loading) {
                        if (map.image === null) this.loading = true;

                        if (!map.image) {
                            this.$store.dispatch('getMapImage', {
                                mapGroupId: map.group.id,
                                mapId: map.id,
                                imageId: map.imageId
                            }).then(function (src) {
                                _this4.setDefaultZoom();
                                _this4.loading = false;
                            }, function () {
                                _this4.loading = false;
                            });
                        } else {
                            __WEBPACK_IMPORTED_MODULE_7__common_helper__["a" /* default */].preloadImage(map.image).then(function (image) {
                                _this4.setDefaultZoom();
                                _this4.loading = false;
                            });
                        }
                    }
                }
            }
        },
        '$route': function $route() {
            this.isShowIndicateAlarms = true;
            if (this.indicateAlarmsTimeout === null) {
                this.indicateAlarmsTimeout = setTimeout(this.onIndicateAlarmsTimeout, this.indicateAlarmsDur);
            }

            clearTimeout(this.camIdFromCellTimeout);
            this.camIdFromCellTimeout = null;
            this.$store.commit('setCamIdFromCell', '');
        }
    },
    methods: {
        nextZoom: function nextZoom() {
            var _this5 = this;

            var zoomIn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var next = void 0;

            if (!zoomIn) next = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.sortBy(this.zoom.list, function (item) {
                return item.value;
            }).find(function (item) {
                return item.value > _this5.zoom.active;
            });else next = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.sortBy(this.zoom.list, function (item) {
                return -item.value;
            }).find(function (item) {
                return item.value < _this5.zoom.active;
            });

            if (next) {
                this.zoom.active = next.value;
            }
        },
        setZoom: function setZoom(value) {
            if (!this.zoom.list.some(function (item) {
                return item.value === value;
            })) {
                var mapContainer = this.$refs.map;
                var ratio = this.map.width / this.map.height;
                var pratio = mapContainer.clientWidth / mapContainer.clientHeight;

                if (ratio < pratio) {
                    value = mapContainer.clientHeight / this.map.height;
                } else {
                    value = mapContainer.clientWidth / this.map.width;
                }

                this.zoom.fit.value = value;
            }

            this.translate.x = 0;
            this.translate.y = 0;
            this.zoom.active = value;
        },
        mousemove: function mousemove(e) {
            if (this.dragging) {
                this.translate.x = e.pageX - this.x;
                this.translate.y = e.pageY - this.y;
            }
        },
        mousedown: function mousedown(e) {
            e.preventDefault();
            this.dragging = true;
            this.x = e.pageX - this.translate.x;
            this.y = e.pageY - this.translate.y;
        },
        mouseup: function mouseup(e) {
            this.dragging = false;
            this.onChangeMapPosition();
        },
        mouseWheel: function mouseWheel(e) {
            this.nextZoom(e.deltaY > 0);
            this.onChangeMapPosition();
        },
        onIndicateAlarmsTimeout: function onIndicateAlarmsTimeout() {
            this.isIndicateAlarms = !this.isIndicateAlarms;
            this.indicateAlarmsTimeout = setTimeout(this.onIndicateAlarmsTimeout, this.indicateAlarmsDur);
        },
        onCamIdFromCellTimeout: function onCamIdFromCellTimeout() {
            if (this.camIdFromCellCountShow < this.camIdFromCellCountMax) {
                this.isIndicateCamIdFromCell = !this.isIndicateCamIdFromCell;
                this.camIdFromCellCountShow++;
                this.camIdFromCellTimeout = setTimeout(this.onCamIdFromCellTimeout, this.camIdFromCellDur);
            } else {
                this.isIndicateCamIdFromCell = false;
            }
        },
        onChangeShowIndicateAlarms: function onChangeShowIndicateAlarms() {
            if (this.isShowIndicateAlarms) {
                this.indicateAlarmsTimeout = setTimeout(this.onIndicateAlarmsTimeout, this.indicateAlarmsDur);
            } else {
                clearTimeout(this.indicateAlarmsTimeout);
                this.indicateAlarmsTimeout = null;
                this.isIndicateAlarms = true;
            }
        },
        onChangeMapPosition: function onChangeMapPosition() {
            var _this6 = this;

            this.$nextTick(function () {
                var mapContainer = _this6.$refs.map;
                var schemeImg = _this6.$refs.scheme;
                var parentPos = mapContainer.getBoundingClientRect();
                var childrenPos = schemeImg.getBoundingClientRect();
                var relativePos = {
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0
                };

                var iconCamHalfW = 27;
                var iconCamHalfH = 21;

                relativePos.top = childrenPos.top + iconCamHalfH - parentPos.top;
                relativePos.bottom = parentPos.bottom - childrenPos.bottom - iconCamHalfH;
                relativePos.left = childrenPos.left + iconCamHalfW - parentPos.left;
                relativePos.right = parentPos.right - childrenPos.right - iconCamHalfW;

                var visualRectPersent = {
                    left: 0,
                    right: 100,
                    top: 0,
                    bottom: 100
                };

                visualRectPersent.left = relativePos.left >= 0 ? 0 : Math.abs(relativePos.left / childrenPos.width * 100);
                visualRectPersent.right = relativePos.right >= 0 ? 100 : Math.abs((childrenPos.width + relativePos.right) / childrenPos.width * 100);
                visualRectPersent.top = relativePos.top >= 0 ? 0 : Math.abs(relativePos.top / childrenPos.height * 100);
                visualRectPersent.bottom = relativePos.bottom >= 0 ? 100 : Math.abs((childrenPos.height + relativePos.bottom) / childrenPos.height * 100);

                __WEBPACK_IMPORTED_MODULE_6__services_EventBus__["a" /* EventBus */].$emit('changeMapPosition', visualRectPersent);
            });
        },
        setDefaultZoom: function setDefaultZoom() {
            if (this.map && this.map.image && this.$refs.map) {
                var zoom = this.map.width > this.$refs.map.clientWidth || this.map.height > this.$refs.map.clientHeight ? 'fit' : 1;
                this.setZoom(zoom);
            }
        },
        getMapObjKey: function getMapObjKey(mObj) {
            return mObj.type === 'CAM' ? 'cam' + mObj.id : mObj.type + '_' + mObj.id;
        }
    },
    components: {
        Loader: __WEBPACK_IMPORTED_MODULE_8__components_loader_Loader_vue__["a" /* default */],
        MapObject: __WEBPACK_IMPORTED_MODULE_9__components_map_object_map_object_vue__["a" /* default */],
        DropdownSelect: __WEBPACK_IMPORTED_MODULE_10__components_dropdownSelect_DropdownSelect_vue__["a" /* default */]
    }
});

/***/ }),
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_map_object_js__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_049e5b74_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_map_object_vue__ = __webpack_require__(712);
function injectStyle (ssrContext) {
  __webpack_require__(710)
}
var normalizeComponent = __webpack_require__(3)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-049e5b74"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_map_object_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_049e5b74_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_map_object_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 710 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dropdown_Dropdown_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_loader_Loader_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_iconCam_IconCam_vue__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_cam_Cam_vue__ = __webpack_require__(133);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MapObject',
  components: {
    Dropdown: __WEBPACK_IMPORTED_MODULE_2__components_dropdown_Dropdown_vue__["a" /* default */],
    IconCam: __WEBPACK_IMPORTED_MODULE_4__components_iconCam_IconCam_vue__["a" /* default */],
    Loader: __WEBPACK_IMPORTED_MODULE_3__components_loader_Loader_vue__["a" /* default */],
    Cam: __WEBPACK_IMPORTED_MODULE_5__components_cam_Cam_vue__["a" /* default */]
  },
  props: {
    map: {
      type: Object,
      required: true
    },
    type: {
      type: String, // cam | object
      default: 'cam'
    },
    /**
     * объект камеры,
     * созданный после слияния объекта на карте
     * с type == 'CAM' и объекта камеры по запросу
     * cameras (fetchCams) (обязателен, если type === 'cam')
     */
    cam: {
      type: Object
    },
    /**
     * Другие объекты не являющиеся камерами (type !== 'CAM') -
     * обязателен, если type === 'object'
     */
    mapObject: {
      type: Object
    },
    limitWidthIcon: {
      type: Number,
      default: 20
    },
    /**
     * размеры иконки и расстояние между иконками на карте
     */
    styleWidthDistance: {
      type: Object,
      required: true
    },
    isHighlight: {
      type: Boolean
    },
    isIndicateAlarms: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      dataObjectLoading: false,
      dataObject: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    alarmCams: 'getAlarmCams'
  }), {
    isDataLoaded: function isDataLoaded() {
      if (this.type === 'cam') {
        return this.cam.image && this.cam.image !== 'loading';
      }
      return !this.dataObjectLoading;
    },
    isHaveImage: function isHaveImage() {
      return this.type === 'cam' && ['DETACHED', 'DISARM_DETACHED'].indexOf(this.cam.status.state) == -1;
    }
  }),
  created: function created() {
    if (this.type === 'cam') {
      this.getImage();
    } else {
      this.fetchObject();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    getObject: 'getObject'
  }), {
    getImage: function getImage() {
      if (this.cam.image === null && this.isHaveImage) {
        this.$store.dispatch('getCamImage', this.cam.id);
      }
    },
    fetchObject: function fetchObject() {
      var _this = this;

      this.dataObjectLoading = true;
      this.getObject({
        type: this.mapObject.type,
        id: this.mapObject.id
      }).then(function (res) {
        _this.dataObject = res;
        _this.dataObjectLoading = false;
      });
    },
    onDropdownOpen: function onDropdownOpen(event) {
      if (event) {
        if (this.type === 'object') {
          this.fetchObject();
        }
      }
    },
    viewCam: function viewCam() {
      if (this.type === 'cam') {
        this.$router.push({
          name: 'views',
          params: {
            viewId: 'main',
            mapGroupId: this.map.group.id,
            mapId: this.map.id,
            camId: this.cam.id
          }
        });
      } else {
        this.$store.commit('addCamsIntoView', {
          camIds: this.dataObject.cameras.split(','),
          viewId: 'main'
        });
        this.$router.push({
          name: 'views',
          params: {
            viewId: 'main'
          }
        });
      }
    }
  })
});

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"map-object",staticClass:"map-object",style:({ top: _vm.styleWidthDistance.top  + 'px', left: _vm.styleWidthDistance.left  + 'px' })},[_c('dropdown',{attrs:{"type":"left"},on:{"update:open":_vm.onDropdownOpen}},[_c('template',{slot:"toggle"},[(_vm.type === 'cam')?_c('icon-cam',{attrs:{"isHighlight":_vm.isHighlight,"isAlarm":!!_vm.alarmCams.find(function (aCam) { return aCam.id === _vm.cam.id; }) && _vm.isIndicateAlarms,"cam":_vm.cam,"width":_vm.styleWidthDistance.width}}):(_vm.type === 'object')?_c('div',{staticClass:"object-icon",style:({
                    width: _vm.styleWidthDistance.width + 'px',
                    height: _vm.styleWidthDistance.width + 'px',
                    'background-image': ("url('/static/images/acs/" + (_vm.mapObject.status) + ".png')")
                })}):_vm._e(),_vm._v(" "),(_vm.styleWidthDistance.width > _vm.limitWidthIcon)?_c('div',{staticClass:"map-object__name",style:({'color': _vm.map.color})},[(_vm.type === 'cam')?[_vm._v("\n                    "+_vm._s(_vm._f("contraction")(_vm.cam.name))+"\n                ")]:(_vm.dataObject)?[_vm._v("\n                    "+_vm._s(_vm._f("contraction")(_vm.dataObject.name))+"\n                ")]:_vm._e()],2):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"list",attrs:{"slot":"list"},slot:"list"},[_c('div',{staticClass:"preview",class:{
                    loaded: _vm.isDataLoaded
                }},[(_vm.type === 'cam' && (_vm.cam.image === false || !_vm.isHaveImage))?_c('div',{staticClass:"preview__status-disabled"},[_c('div',{staticClass:"preview__icon-no-signal"}),_vm._v(" "),_c('div',{staticClass:"preview__error"},[_vm._v(_vm._s(_vm.$t('No signal')))])]):_vm._e(),_vm._v(" "),(_vm.type === 'cam' ? _vm.cam.image === 'loading' : !_vm.isDataLoaded)?_c('loader',{attrs:{"type":"small"}}):_vm._e(),_vm._v(" "),(_vm.type === 'cam')?_c('div',{staticClass:"preview__img",style:({ 'background-image': 'url(' + _vm.cam.image + ')' })}):_vm._e(),_vm._v(" "),(_vm.isDataLoaded && (_vm.isHaveImage || (_vm.dataObject && _vm.dataObject.cameras)))?_c('div',{staticClass:"preview__btn-link",on:{"click":_vm.viewCam}},[_vm._v("\n                    "+_vm._s(_vm.$t('View camera'))+"\n                ")]):(_vm.isDataLoaded && (_vm.dataObject && !_vm.dataObject.cameras))?_c('div',{staticClass:"preview__btn-link preview__btn-link--no-clickable"},[_vm._v("\n                    "+_vm._s(_vm.$t('No cameras'))+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.type === 'cam')?_c('cam',{staticClass:"preview__cam",attrs:{"cam":_vm.cam,"in-map":""}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"map-info"},[(_vm.type === 'cam')?_c('div',{staticClass:"map-info__name",attrs:{"title":_vm.cam.name}},[_vm._v("\n                    "+_vm._s(_vm._f("contraction")(_vm.cam.name))+"\n                ")]):(_vm.dataObject)?_c('div',{staticClass:"map-info__name",attrs:{"title":_vm.dataObject.name}},[_vm._v("\n                    "+_vm._s(_vm._f("contraction")(_vm.dataObject.name))+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.type === 'cam')?[(_vm.cam.views && _vm.cam.views.length)?_c('div',{staticClass:"map-info__group"},[_c('div',{staticClass:"map-info__label"},[_vm._v(_vm._s(_vm.$t('Views with camera')))]),_vm._v(" "),_c('div',{staticClass:"map-info__values"},_vm._l((_vm.cam.views),function(view){return _c('router-link',{key:'view' + view.id,staticClass:"map-info__value",attrs:{"title":view.name,"to":{
                                name: 'views',
                                params: { viewId: view.id }
                            }}},[_vm._v("\n                                "+_vm._s(_vm._f("contraction")(view.name))+"\n                            ")])}))]):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.dataObject && _vm.dataObject.cameras)?_c('div',{staticClass:"map-info__group"},[_c('div',{staticClass:"map-info__label"},[_vm._v(_vm._s(_vm.$t('IDs cameras')))]),_vm._v(" "),_c('div',{staticClass:"map-info__value"},[_vm._v(_vm._s(_vm.dataObject.cameras))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"map-info__group"},[_c('div',{staticClass:"map-info__label"},[_vm._v(_vm._s(_vm.$t('Location on map')))]),_vm._v(" "),_c('div',{staticClass:"map-info__value"},[_vm._v(_vm._s(_vm.map.group.name)+" - "+_vm._s(_vm.map.name))])])],2)])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.map)?_c('div',{ref:"map",staticClass:"map"},[_c('div',{staticClass:"scheme"},[_c('div',{staticClass:"img",class:{ dragging: _vm.dragging },style:({ transform: 'translate3d(' + _vm.translate.x + 'px,' + _vm.translate.y + 'px,0)', width: _vm.map.width * _vm.zoom.active + 'px', height: _vm.map.height * _vm.zoom.active + 'px'}),on:{"mousedown":_vm.mousedown,"mouseup":_vm.mouseup,"mousewheel":_vm.mouseWheel}},[(_vm.map.image)?_c('img',{ref:"scheme",attrs:{"src":_vm.map.image}}):_vm._e(),_vm._v(" "),(_vm.map.image)?_c('div',{staticClass:"cams"},[_vm._l((_vm.map.cams),function(cam){return _c('map-object',{key:'cam' + cam.id,attrs:{"map":_vm.map,"cam":cam,"styleWidthDistance":_vm.objsStyle[cam.id],"isHighlight":cam.id === _vm.camIdFromCell && _vm.isIndicateCamIdFromCell,"isIndicateAlarms":_vm.isIndicateAlarms}})}),_vm._v(" "),_vm._l((_vm.map.mapObjs),function(object){return _c('map-object',{key:((object.type) + "_" + (object.id)),attrs:{"type":"object","map":_vm.map,"mapObject":object,"styleWidthDistance":_vm.objsStyle[((object.type) + "_" + (object.id))]}})}),_vm._v(" "),_vm._l((_vm.map.levels),function(level){return _c('router-link',{key:'level' + level.mapId,staticClass:"level-item",style:({ top: level.y * _vm.zoom.active + 'px', left: level.x * _vm.zoom.active + 'px' }),attrs:{"to":{ name: 'map', params: { rootMapId: _vm.map.group.id, mapId: level.mapId } }}},[_vm._v("\n          "+_vm._s(level.id)+"\n          "),_c('div',{staticClass:"icon-level"})])})],2):_vm._e()]),_vm._v(" "),(_vm.map.image === false)?_c('div',{staticClass:"status"},[_c('div',{staticClass:"icon-no-map"}),_vm._v(" "),_c('div',{staticClass:"caption"},[_vm._v(_vm._s(_vm.$t('Image unavailable')))])]):_vm._e()]),_vm._v(" "),(_vm.map.image)?_c('div',{staticClass:"controls"},[(_vm.isShowIndicateAlarmsControl)?_c('label',{staticClass:"indicate-alarms-label",class:{'checked': _vm.isShowIndicateAlarms}},[_c('div',{staticClass:"indicate-alarms-label__text"},[_vm._v("\n        "+_vm._s(_vm.$t('Indicate alarms on cameras'))+"\n      ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isShowIndicateAlarms),expression:"isShowIndicateAlarms"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isShowIndicateAlarms)?_vm._i(_vm.isShowIndicateAlarms,null)>-1:(_vm.isShowIndicateAlarms)},on:{"change":[function($event){var $$a=_vm.isShowIndicateAlarms,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isShowIndicateAlarms=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isShowIndicateAlarms=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isShowIndicateAlarms=$$c}},_vm.onChangeShowIndicateAlarms]}})]):_vm._e(),_vm._v(" "),_c('dropdown-select',{staticClass:"dropdown-zoom",attrs:{"list":_vm.zoomList,"value":_vm.zoom.active,"type":"small"},on:{"change":_vm.setZoom}}),_vm._v(" "),_c('div',{staticClass:"bigger control-btn",class:{ disabled: _vm.zoom.active >= _vm.zoom.list[_vm.zoom.list.length - 1].value},on:{"click":function($event){_vm.nextZoom()}}}),_vm._v(" "),_c('div',{staticClass:"smaller control-btn",class:{ disabled: _vm.zoom.active <= _vm.zoom.list[0].value},on:{"click":function($event){_vm.nextZoom(true)}}})],1):_vm._e(),_vm._v(" "),_c('loader',{class:{ loading: _vm.loading }})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

/* harmony default export */ __webpack_exports__["a"] = ({
    filters: {
        contraction: function contraction(value) {
            if (value.length > 20) {
                return value.slice(0, 10).trim() + ' ... ' + value.slice(-10).trim();
            }

            return value;
        }
    },
    install: function install(Vue) {
        var _this = this;

        var filters = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.filters);

        filters.forEach(function (k) {
            return Vue.filter(k, _this.filters[k]);
        });
    }
});

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_js__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82dfb184_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(718);
function injectStyle (ssrContext) {
  __webpack_require__(716)
}
var normalizeComponent = __webpack_require__(3)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82dfb184_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 716 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_EventBus_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modal_Modal_vue__ = __webpack_require__(73);







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'App',
    inject: ['auth'],
    data: function data() {
        return {
            timeout: null,
            resizing: false,
            version: 1,
            error: null,
            isIE: false
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
        activeMap: 'getActiveMap'
    })),
    created: function created() {
        var _this = this;

        var version = parseInt(localStorage.getItem('version'));

        if (version < this.version) localStorage.clear();

        localStorage.setItem('version', this.version);

        __WEBPACK_IMPORTED_MODULE_4__services_EventBus_js__["a" /* EventBus */].$on('error', function (data) {
            _this.error = data;
        });

        var ua = window.navigator.userAgent.toLowerCase();

        if (/trident/gi.test(ua) || /msie/gi.test(ua)) {
            this.isIE = true;
            __WEBPACK_IMPORTED_MODULE_4__services_EventBus_js__["a" /* EventBus */].$emit('error', {
                message: 'Error IE'
            });
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        window.addEventListener('resize', function () {
            _this2.resizing = true;
            clearTimeout(_this2.timeout);

            _this2.timeout = setTimeout(function () {
                _this2.resizing = false;
            }, 200);
        });
    },

    watch: {
        resizing: function resizing(value) {
            __WEBPACK_IMPORTED_MODULE_4__services_EventBus_js__["a" /* EventBus */].$emit('resize:' + (value ? 'start' : 'end'));
        },
        activeMap: function activeMap(map, prev) {
            var isSame = map && prev && map.id == prev.id && map.group.id == prev.group.id;
            if (!isSame) {
                if (prev) {
                    this.subscribeObjectChanges(prev, 'delete');
                }
                if (map) {
                    this.subscribeObjectChanges(map);
                }
            }
        }
    },
    methods: {
        rootClick: function rootClick() {
            __WEBPACK_IMPORTED_MODULE_4__services_EventBus_js__["a" /* EventBus */].$emit('root-click');
        },
        mouseup: function mouseup() {
            __WEBPACK_IMPORTED_MODULE_4__services_EventBus_js__["a" /* EventBus */].$emit('mouseup');
        },
        mousemove: function mousemove(e) {
            __WEBPACK_IMPORTED_MODULE_4__services_EventBus_js__["a" /* EventBus */].$emit('mousemove', e);
        },
        subscribeObjectChanges: function subscribeObjectChanges(mapObject) {
            var _this3 = this;

            var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'add';

            mapObject.objects.filter(function (item) {
                return item.type !== 'LEVEL' && item.type !== 'CAM';
            }).forEach(function (o) {
                _this3.$store.state.wsWebConnect.send(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                    type: 'subscribe',
                    data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, action + '_rules', [{
                        type: o.type,
                        id: o.id,
                        action: 'STATE_CHANGED'
                    }])
                }));
            });
        }
    },
    components: {
        Modal: __WEBPACK_IMPORTED_MODULE_5__components_modal_Modal_vue__["a" /* default */]
    }
});

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"app",attrs:{"id":"app"},on:{"click":_vm.rootClick,"mouseup":_vm.mouseup,"mousemove":_vm.mousemove}},[(!_vm.isIE)?_c('router-view'):_vm._e(),_vm._v(" "),(_vm.error)?_c('modal',{attrs:{"show":!! _vm.error}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('Error'))+" "+_vm._s(_vm.error.code))]),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.$t(_vm.error.message)))]),_vm._v(" "),_c('div',{staticClass:"btns padding single"},[_c('div',{staticClass:"btn",on:{"click":function($event){_vm.error = null}}},[_c('span',[_vm._v("OK")])])])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(12);






var _class = function () {
    function _class(store, router) {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, _class);

        this.$store = store;
        this.camsTimeout = null;

        router.beforeEach(function (to, from, next) {
            if (to.meta.auth && !store.state.user) {
                _this.loginFromStorage().then(function () {
                    next();
                }, function () {
                    next('/auth');
                });
            } else {
                next();
            }
        });
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(_class, [{
        key: 'login',
        value: function login(data) {
            var _this2 = this;

            var token = btoa(unescape(encodeURIComponent(data.login + ':' + data.password)));
            var storageToken = btoa(unescape(encodeURIComponent(data.login + '㋛' + data.password)));
            var user = {
                object: data.object,
                login: data.login,
                remember: data.remember
            };

            __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].http.headers.common['Authorization'] = 'Basic ' + token;

            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                _this2.$store.dispatch('getCams').then(function () {
                    var usersJson = localStorage.getItem('users');
                    var users = usersJson ? JSON.parse(usersJson) : [];
                    var index = users.findIndex(function (item) {
                        return item.object == user.object;
                    });

                    if (index > -1) users.splice(index, 1);

                    users.unshift(user);

                    localStorage.setItem('users', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(users));
                    localStorage.setItem('token', storageToken);
                    _this2.$store.commit('setUser', user);

                    var getCams = function getCams() {
                        _this2.$store.dispatch('getCams');
                        _this2.camsTimeout = setTimeout(getCams, {"MAIN_URL":"http://85.202.239.74:12113","WEBVIEW_URL":"http://85.202.239.74:25888","PLAYER":{"monitorId":1,"transport":4},"updateInterval":10000}.updateInterval);
                    };
                    _this2.camsTimeout = setTimeout(getCams, {"MAIN_URL":"http://85.202.239.74:12113","WEBVIEW_URL":"http://85.202.239.74:25888","PLAYER":{"monitorId":1,"transport":4},"updateInterval":10000}.updateInterval);
                    _this2.$store.dispatch('setWsWebConnect').then(function () {
                        resolve();
                    });
                }, function (e) {
                    if (e.status === 400) _this2.$store.commit('resetUser');

                    reject(e);
                });
            });
        }
    }, {
        key: 'loginFromStorage',
        value: function loginFromStorage() {
            var _this3 = this;

            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var user = _this3.getUserFromStorage();

                if (user) {
                    _this3.login(user).then(function () {
                        resolve();
                    }, function () {
                        reject();
                    });
                } else reject();
            });
        }
    }, {
        key: 'getTokenFromStorage',
        value: function getTokenFromStorage(token) {
            return decodeURIComponent(escape(atob(token))).split('㋛');
        }
    }, {
        key: 'getUserFromStorage',
        value: function getUserFromStorage() {
            var usersJson = localStorage.getItem('users');
            var token = localStorage.getItem('token');

            if (usersJson && token) {
                var users = JSON.parse(usersJson);
                var data = this.getTokenFromStorage(token);

                if (data.length == 2) {
                    var login = data[0];
                    var user = users.find(function (item) {
                        return item.login = login;
                    });

                    if (user) {
                        return { object: user.object, login: login, password: data[1], remember: user.remember };
                    } else return false;
                } else return false;
            } else return false;
        }
    }, {
        key: 'logout',
        value: function logout() {
            localStorage.removeItem('token');
            this.$store.commit('resetUser');
            clearTimeout(this.camsTimeout);
            this.camsTimeout = null;

            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                resolve();
            });
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vee_validate__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_cookies__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_cookies__);







var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);

        this.lang = {
            default: 'en',
            storage: localStorage.getItem('lang'),
            browser: navigator.language.substr(0, 2)
        };

        this.set(this.get());
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
        key: "get",
        value: function get() {
            if (this.lang.storage && __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].i18n.locales().indexOf(this.lang.storage)) {
                return this.lang.storage;
            }

            if (this.lang.browser) return this.lang.browser;

            return this.lang.default;
        }
    }, {
        key: "set",
        value: function set(lang) {
            localStorage.setItem('lang', lang);
            __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].i18n.set(lang);
            __WEBPACK_IMPORTED_MODULE_3_moment___default.a.locale(lang);
            __WEBPACK_IMPORTED_MODULE_4_vee_validate__["a" /* Validator */].localize(lang);

            if (typeof Event === 'function') {
                window.dispatchEvent(new Event('resize'));
            } else {
                var evt = window.document.createEvent('UIEvents');
                evt.initUIEvent('resize', true, false, window, 0);
                window.dispatchEvent(evt);
            }

            var langCode = 0;
            switch (lang) {
                case 'ru':
                    langCode = 1;
                    break;
                case 'fr':
                    langCode = 2;
                    break;
                case 'pt':
                    langCode = 3;
                    break;
            }
            __WEBPACK_IMPORTED_MODULE_5_vue_cookies___default.a.set('language', langCode, 0, '/webview');
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ })
],[321]);


// WEBPACK FOOTER //
// static/js/app.bcc0a759f1dcb6705035.js